/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AiAnalysis = {
  __typename?: 'AIAnalysis';
  _v: AnalysisVersion;
  analysis?: Maybe<Array<Criterion>>;
  failureReason?: Maybe<AnalysisFailureReason>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Prompt>;
  state: AnalysisState;
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  channelHandle?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hasChannel: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  thumbnails: Array<Thumbnail>;
};

export type ActionHelpers = {
  __typename?: 'ActionHelpers';
  approve: Scalars['String']['output'];
  reject: Scalars['String']['output'];
  skip: Scalars['String']['output'];
  undo: Scalars['String']['output'];
};

export type ActionMetrics = {
  __typename?: 'ActionMetrics';
  candidatesQueued?: Maybe<Scalars['Int']['output']>;
  videosRemoved?: Maybe<Scalars['Int']['output']>;
  videosSurfaced?: Maybe<Scalars['Int']['output']>;
};

export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  actionId?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  subLine: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  verb: Scalars['String']['output'];
  videoId?: Maybe<Scalars['String']['output']>;
};

export type ActivityRow = {
  __typename?: 'ActivityRow';
  actionId?: Maybe<Scalars['String']['output']>;
  actionStatus?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  time: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  tone: Scalars['String']['output'];
  videoId?: Maybe<Scalars['String']['output']>;
  videoTitle?: Maybe<Scalars['String']['output']>;
};

export type AdminAccountInfoReplay = {
  __typename?: 'AdminAccountInfoReplay';
  capturedAt: Scalars['String']['output'];
  parseError?: Maybe<Scalars['String']['output']>;
  parsedChannelHandle?: Maybe<Scalars['String']['output']>;
  parsedEmail?: Maybe<Scalars['String']['output']>;
  parsedHasChannel?: Maybe<Scalars['Boolean']['output']>;
  parsedName?: Maybe<Scalars['String']['output']>;
  parsedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  rawJson: Scalars['String']['output'];
  rawStoragePath?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
};

export type AdminCcDevice = {
  __typename?: 'AdminCcDevice';
  appVersion?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerDisplayName?: Maybe<Scalars['String']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerUid: Scalars['String']['output'];
  registeredAt: Scalars['String']['output'];
  subscribedProfileIds: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdminCcOwner = {
  __typename?: 'AdminCcOwner';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  linkedAt?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type AdminCcProfile = {
  __typename?: 'AdminCcProfile';
  channelHandle?: Maybe<Scalars['String']['output']>;
  devices: Array<AdminCcProfileDevice>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<AdminCcOwner>;
  profileId: Scalars['ID']['output'];
  sessions: Array<AdminCcSession>;
  status: AdminCcProfileStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminCcProfileDevice = {
  __typename?: 'AdminCcProfileDevice';
  appVersion?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AdminCcProfileStatus = {
  __typename?: 'AdminCcProfileStatus';
  lastTaskAt?: Maybe<Scalars['String']['output']>;
  lastTaskType?: Maybe<Scalars['String']['output']>;
  youtubeSessionInvalidReason?: Maybe<Scalars['String']['output']>;
  youtubeSessionLastCheckedAt?: Maybe<Scalars['String']['output']>;
  youtubeSessionValid?: Maybe<Scalars['Boolean']['output']>;
  youtubeSignedOut?: Maybe<Scalars['Boolean']['output']>;
  youtubeSignedOutAt?: Maybe<Scalars['String']['output']>;
};

export type AdminCcSession = {
  __typename?: 'AdminCcSession';
  expiresAt: Scalars['Float']['output'];
  lastSeenAt?: Maybe<Scalars['Float']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['ID']['output'];
  state: AdminCcSessionState;
};

export enum AdminCcSessionState {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Idle = 'IDLE',
  New = 'NEW'
}

export type AdminCcTotals = {
  __typename?: 'AdminCcTotals';
  activeSessions: Scalars['Int']['output'];
  expiredSessions: Scalars['Int']['output'];
  idleSessions: Scalars['Int']['output'];
  newSessions: Scalars['Int']['output'];
  orphanSessions: Scalars['Int']['output'];
  ownersWithProfiles: Scalars['Int']['output'];
  profiles: Scalars['Int']['output'];
  profilesWithActiveDevice: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  signedOutProfiles: Scalars['Int']['output'];
  unclaimedProfiles: Scalars['Int']['output'];
};

export type AdminCommandCenter = {
  __typename?: 'AdminCommandCenter';
  devices: Array<AdminCcDevice>;
  generatedAt: Scalars['String']['output'];
  orphanSessions: Array<AdminCcSession>;
  profiles: Array<AdminCcProfile>;
  totals: AdminCcTotals;
};

export type AdminDeleteSessionResult = {
  __typename?: 'AdminDeleteSessionResult';
  errors: Array<Scalars['String']['output']>;
  sessionDeleted: Scalars['Boolean']['output'];
  sessionId: Scalars['ID']['output'];
  tasksDeleted: Scalars['Int']['output'];
};

export type AdminEnqueuePipelineEvalResult = {
  __typename?: 'AdminEnqueuePipelineEvalResult';
  evalRunId: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
};

export type AdminEvalFailedSpecialist = {
  __typename?: 'AdminEvalFailedSpecialist';
  error: Scalars['String']['output'];
  specialization: Scalars['String']['output'];
};

export type AdminEvalFinalizeResult = {
  __typename?: 'AdminEvalFinalizeResult';
  ageBandVerdicts: Array<AgeBandVerdict>;
  costEstimate?: Maybe<CostEstimateInfo>;
  explanation: Scalars['String']['output'];
  model: Scalars['String']['output'];
  rating: VideoRating;
  score: Scalars['Float']['output'];
  tokenUsage: TokenUsageInfo;
};

export type AdminEvalPipelineInput = {
  childAge?: InputMaybe<Scalars['Int']['input']>;
  detectorModel?: InputMaybe<Scalars['String']['input']>;
  finalizeModel?: InputMaybe<Scalars['String']['input']>;
  specialistModel?: InputMaybe<Scalars['String']['input']>;
  triageModel?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['String']['input'];
};

export type AdminEvalPipelineProgress = {
  __typename?: 'AdminEvalPipelineProgress';
  completed?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phase: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AdminEvalPipelineResult = {
  __typename?: 'AdminEvalPipelineResult';
  enqueuedAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  evalRunId: Scalars['ID']['output'];
  failedSpecialists: Array<AdminEvalFailedSpecialist>;
  finalize?: Maybe<AdminEvalFinalizeResult>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<AdminEvalPipelineProgress>;
  skippedSpecialists: Array<AdminEvalSkippedSpecialist>;
  specialists: Array<AdminEvalSpecialistResult>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: AdminEvalRunStatus;
  summary?: Maybe<Scalars['String']['output']>;
  totalCostUSD: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
  triage?: Maybe<AdminEvalTriageResult>;
  videoId: Scalars['String']['output'];
};

export enum AdminEvalRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type AdminEvalSkippedSpecialist = {
  __typename?: 'AdminEvalSkippedSpecialist';
  reason: Scalars['String']['output'];
  specialization: Scalars['String']['output'];
};

export type AdminEvalSpecialistResult = {
  __typename?: 'AdminEvalSpecialistResult';
  agentVersion: Scalars['String']['output'];
  costEstimate?: Maybe<CostEstimateInfo>;
  explanation: Scalars['String']['output'];
  model: Scalars['String']['output'];
  politicsFacts?: Maybe<PoliticsFacts>;
  rating: VideoRating;
  religionFacts?: Maybe<ReligionFacts>;
  score: Scalars['Float']['output'];
  specialization: Scalars['String']['output'];
  tokenUsage: TokenUsageInfo;
};

export type AdminEvalTriageResult = {
  __typename?: 'AdminEvalTriageResult';
  categoryTags: Array<AgentCategoryTag>;
  confidence: Scalars['Float']['output'];
  costEstimate?: Maybe<CostEstimateInfo>;
  explanation: Scalars['String']['output'];
  model: Scalars['String']['output'];
  rating: VideoRating;
  riskFlags: Array<AgentRiskFlag>;
  score: Scalars['Float']['output'];
  tokenUsage: TokenUsageInfo;
  verdict: TriageVerdict;
};

export type AdminInsightCandidate = {
  __typename?: 'AdminInsightCandidate';
  aiConfidence?: Maybe<Scalars['String']['output']>;
  aiRating?: Maybe<Scalars['String']['output']>;
  aiScore?: Maybe<Scalars['Float']['output']>;
  alreadyNotified: Scalars['Boolean']['output'];
  channelName?: Maybe<Scalars['String']['output']>;
  included: Scalars['Boolean']['output'];
  lastWatchAt?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rankPosition?: Maybe<Scalars['Int']['output']>;
  reason: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  scoreBase?: Maybe<Scalars['Float']['output']>;
  scoreCapped: Scalars['Boolean']['output'];
  scoreRecency?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['String']['output'];
};

export type AdminInsightCandidateList = {
  __typename?: 'AdminInsightCandidateList';
  candidates: Array<AdminInsightCandidate>;
  chosenVideoId?: Maybe<Scalars['String']['output']>;
  excludedCount: Scalars['Int']['output'];
  includedCount: Scalars['Int']['output'];
  notes: Array<Scalars['String']['output']>;
  profileId: Scalars['String']['output'];
  profileName?: Maybe<Scalars['String']['output']>;
  scanned: Scalars['Int']['output'];
};

export type AdminInsightTestResult = {
  __typename?: 'AdminInsightTestResult';
  chosenRating?: Maybe<Scalars['String']['output']>;
  chosenSeverity?: Maybe<Scalars['String']['output']>;
  chosenTitle?: Maybe<Scalars['String']['output']>;
  chosenVideoId?: Maybe<Scalars['String']['output']>;
  copyBody?: Maybe<Scalars['String']['output']>;
  copyTitle?: Maybe<Scalars['String']['output']>;
  devicesTargeted: Scalars['Int']['output'];
  notes: Array<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  profileId: Scalars['String']['output'];
  profileName?: Maybe<Scalars['String']['output']>;
  pushErrors: Scalars['Int']['output'];
  pushOk: Scalars['Int']['output'];
  ratedCount: Scalars['Int']['output'];
  scanned: Scalars['Int']['output'];
};

export type AdminPurgeProfileResult = {
  __typename?: 'AdminPurgeProfileResult';
  cacheProfileFeedDeleted: Scalars['Int']['output'];
  correctiveActionsDeleted: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  feedSnapshotsDeleted: Scalars['Int']['output'];
  feedbackDeleted: Scalars['Int']['output'];
  historySnapshotsDeleted: Scalars['Int']['output'];
  profileExisted: Scalars['Boolean']['output'];
  profileId: Scalars['ID']['output'];
  profileStatusDeleted: Scalars['Boolean']['output'];
  relatedSnapshotsDeleted: Scalars['Int']['output'];
  sessionsDeleted: Scalars['Int']['output'];
  tasksDeleted: Scalars['Int']['output'];
};

export type AdminRecomputeCorrectiveActionsResult = {
  __typename?: 'AdminRecomputeCorrectiveActionsResult';
  channelsMarked: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  profileId: Scalars['ID']['output'];
  videoMarked: Scalars['Boolean']['output'];
};

export type AdminRerunScoringPipelineResult = {
  __typename?: 'AdminRerunScoringPipelineResult';
  jobId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceTaskId: Scalars['String']['output'];
  videoCount: Scalars['Int']['output'];
};

export type AdminResetAllVideoScoresResult = {
  __typename?: 'AdminResetAllVideoScoresResult';
  scoresDeleted: Scalars['Int']['output'];
  videosAffected: Scalars['Int']['output'];
};

export type AdminResetAllVideoSummariesResult = {
  __typename?: 'AdminResetAllVideoSummariesResult';
  summariesDeleted: Scalars['Int']['output'];
  videosAffected: Scalars['Int']['output'];
};

export type AdminResetVideoScoresResult = {
  __typename?: 'AdminResetVideoScoresResult';
  scoresDeleted: Scalars['Int']['output'];
  videosConsidered: Scalars['Int']['output'];
};

export type AdminResetVideoSummaryResult = {
  __typename?: 'AdminResetVideoSummaryResult';
  summariesDeleted: Scalars['Int']['output'];
};

export type AdminScoringTestResult = {
  __typename?: 'AdminScoringTestResult';
  cacheLLMId: Scalars['ID']['output'];
  explanation: Scalars['String']['output'];
  rating: VideoRating;
  request: LlmRequest;
  response: ChatCompletionResponse;
  score: Scalars['Float']['output'];
};

export type AdminSeedPromptsResult = {
  __typename?: 'AdminSeedPromptsResult';
  prompts: Array<AdminSeededPrompt>;
  seeded: Scalars['Int']['output'];
};

export type AdminSeededPrompt = {
  __typename?: 'AdminSeededPrompt';
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AdminSweepProfileSessionsResult = {
  __typename?: 'AdminSweepProfileSessionsResult';
  deletedSessionIds: Array<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  profileId: Scalars['ID']['output'];
  sessionsDeleted: Scalars['Int']['output'];
  tasksDeleted: Scalars['Int']['output'];
};

export enum AgeBand {
  Kid = 'KID',
  Teen = 'TEEN',
  Toddler = 'TODDLER',
  Tween = 'TWEEN'
}

export type AgeBandVerdict = {
  __typename?: 'AgeBandVerdict';
  band: AgeBand;
  explanation: Scalars['String']['output'];
  maxAge: Scalars['Int']['output'];
  minAge: Scalars['Int']['output'];
  rating: VideoRating;
  score: Scalars['Float']['output'];
};

export type Agent = {
  __typename?: 'Agent';
  data_requirement: DataRequirement;
  description: Scalars['String']['output'];
  max_age: Scalars['Int']['output'];
  min_age: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  scoreDirection: ScoreDirection;
  specialization: AgentSpecialization;
  summarization_need?: Maybe<SummarizationNeed>;
  thumbnails: Array<Thumbnail>;
  triggers?: Maybe<AgentTriggers>;
  type: AgentType;
  version: Scalars['String']['output'];
};

export type AgentAggregateScore = {
  __typename?: 'AgentAggregateScore';
  confidence: ScoreConfidence;
  explanation: Scalars['String']['output'];
  overriddenAgents?: Maybe<Array<AgentId>>;
  rating: VideoRating;
  restricted: Scalars['Boolean']['output'];
  restrictingAgents?: Maybe<Array<AgentId>>;
  score: Scalars['Float']['output'];
  transcriptLen?: Maybe<Scalars['Int']['output']>;
  videoId: Scalars['String']['output'];
};

export type AgentAnalysisChatLog = {
  __typename?: 'AgentAnalysisChatLog';
  agent_id?: Maybe<AgentId>;
  createdAt: Scalars['String']['output'];
  request: LlmRequest;
  response: ChatCompletionResponse;
  response_format: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export enum AgentCategoryTag {
  Arts = 'ARTS',
  Comedy = 'COMEDY',
  Fiction = 'FICTION',
  Gaming = 'GAMING',
  History = 'HISTORY',
  KidsSlop = 'KIDS_SLOP',
  Language = 'LANGUAGE',
  Music = 'MUSIC',
  News = 'NEWS',
  Physical = 'PHYSICAL',
  Political = 'POLITICAL',
  Reaction = 'REACTION',
  Religious = 'RELIGIOUS',
  SocialStudies = 'SOCIAL_STUDIES',
  Stem = 'STEM'
}

export type AgentId = {
  __typename?: 'AgentId';
  specialization: AgentSpecialization;
  version: Scalars['String']['output'];
};

export type AgentIdInput = {
  specialization: AgentSpecialization;
  version: Scalars['String']['input'];
};

export type AgentParameterOverrides = {
  extraGuidelines?: InputMaybe<Scalars['String']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type AgentPromptEntry = {
  __typename?: 'AgentPromptEntry';
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: AgentPromptKind;
  lastEvalScore?: Maybe<Scalars['Float']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  parentVersion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum AgentPromptKind {
  Identity = 'IDENTITY',
  Template = 'TEMPLATE'
}

export enum AgentRiskFlag {
  PossibleAd = 'POSSIBLE_AD',
  PossibleAiSlop = 'POSSIBLE_AI_SLOP',
  PossibleDiscrimination = 'POSSIBLE_DISCRIMINATION',
  PossibleEmotionalSafety = 'POSSIBLE_EMOTIONAL_SAFETY',
  PossibleLanguage = 'POSSIBLE_LANGUAGE',
  PossibleLowQuality = 'POSSIBLE_LOW_QUALITY',
  PossibleMentalHealth = 'POSSIBLE_MENTAL_HEALTH',
  PossibleMisinformation = 'POSSIBLE_MISINFORMATION',
  PossibleNoLearningPayload = 'POSSIBLE_NO_LEARNING_PAYLOAD',
  PossibleOnlineSafety = 'POSSIBLE_ONLINE_SAFETY',
  PossiblePhysicalSafety = 'POSSIBLE_PHYSICAL_SAFETY',
  PossiblePolitical = 'POSSIBLE_POLITICAL',
  PossibleReligious = 'POSSIBLE_RELIGIOUS',
  PossibleSexuality = 'POSSIBLE_SEXUALITY',
  PossibleSubstanceUse = 'POSSIBLE_SUBSTANCE_USE',
  PossibleViolence = 'POSSIBLE_VIOLENCE'
}

export type AgentScore = ScoreBase & {
  __typename?: 'AgentScore';
  ageBandVerdicts?: Maybe<Array<AgeBandVerdict>>;
  agent: AgentId;
  cacheHit?: Maybe<Scalars['Boolean']['output']>;
  cache_llm_id: Scalars['ID']['output'];
  costEstimate?: Maybe<CostEstimateInfo>;
  createdAt?: Maybe<Scalars['String']['output']>;
  explanation: Scalars['String']['output'];
  gatedContext?: Maybe<GatedContext>;
  id: Scalars['ID']['output'];
  kind: ScoreKind;
  model?: Maybe<Scalars['String']['output']>;
  politicsFacts?: Maybe<PoliticsFacts>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  rating: VideoRating;
  religionFacts?: Maybe<ReligionFacts>;
  score: Scalars['Float']['output'];
  scoreDirection: ScoreDirection;
  tokenUsage?: Maybe<TokenUsageInfo>;
  transcriptLen?: Maybe<Scalars['Int']['output']>;
  triageOutput?: Maybe<TriageOutput>;
  type: AgentType;
  videoId: Scalars['String']['output'];
};

export enum AgentSpecialization {
  Appropriateness = 'APPROPRIATENESS',
  AppropriatenessTriage = 'APPROPRIATENESS_TRIAGE',
  DevelopmentalMilestones = 'DEVELOPMENTAL_MILESTONES',
  EducationalValue = 'EDUCATIONAL_VALUE',
  EducationArts = 'EDUCATION_ARTS',
  EducationHistory = 'EDUCATION_HISTORY',
  EducationLanguage = 'EDUCATION_LANGUAGE',
  EducationPhysical = 'EDUCATION_PHYSICAL',
  EducationSocialStudies = 'EDUCATION_SOCIAL_STUDIES',
  EducationStem = 'EDUCATION_STEM',
  Engagement = 'ENGAGEMENT',
  EntertainmentComedy = 'ENTERTAINMENT_COMEDY',
  EntertainmentFiction = 'ENTERTAINMENT_FICTION',
  EntertainmentGaming = 'ENTERTAINMENT_GAMING',
  EntertainmentMusic = 'ENTERTAINMENT_MUSIC',
  SafetyEmotional = 'SAFETY_EMOTIONAL',
  SafetyOnline = 'SAFETY_ONLINE',
  SafetyPhysical = 'SAFETY_PHYSICAL',
  SensitiveAdvertising = 'SENSITIVE_ADVERTISING',
  SensitiveAiGenerated = 'SENSITIVE_AI_GENERATED',
  SensitiveDiscrimination = 'SENSITIVE_DISCRIMINATION',
  SensitiveLanguage = 'SENSITIVE_LANGUAGE',
  SensitiveMentalHealth = 'SENSITIVE_MENTAL_HEALTH',
  SensitiveMisinformation = 'SENSITIVE_MISINFORMATION',
  SensitivePolitics = 'SENSITIVE_POLITICS',
  SensitiveReligion = 'SENSITIVE_RELIGION',
  SensitiveSexuality = 'SENSITIVE_SEXUALITY',
  SensitiveSubstanceUse = 'SENSITIVE_SUBSTANCE_USE',
  SensitiveViolence = 'SENSITIVE_VIOLENCE'
}

export type AgentTriggers = {
  __typename?: 'AgentTriggers';
  always?: Maybe<Scalars['Boolean']['output']>;
  categoryTags?: Maybe<Array<AgentCategoryTag>>;
  riskFlags?: Maybe<Array<AgentRiskFlag>>;
};

export enum AgentType {
  Analysis = 'ANALYSIS',
  Detection = 'DETECTION',
  Meta = 'META'
}

export type AggregateChannelMessage = AnalysisQueueMessage & {
  __typename?: 'AggregateChannelMessage';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AggregateProfileChannelFeedbackMessage = AnalysisQueueMessage & {
  __typename?: 'AggregateProfileChannelFeedbackMessage';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum AgreementType {
  Agree = 'AGREE',
  Disagree = 'DISAGREE'
}

export enum AnalysisFailureReason {
  AiAnalysisError = 'AI_ANALYSIS_ERROR',
  DurationNotFound = 'DURATION_NOT_FOUND',
  TranscriptNotFound = 'TRANSCRIPT_NOT_FOUND'
}

export type AnalysisQueue = AggregateChannelMessage | AggregateProfileChannelFeedbackMessage | BindFeedbackTokensMessage | ControlHeartbeatSessionsMessage | ControlSendInsightNotificationsMessage | ControlSweepChannelMarksMessage | ControlSweepChannelRescoresMessage | ControlSweepEvaluateChannelMarksMessage | ControlSweepEvaluateVideoMarksMessage | ControlSweepProfileChannelOverlayMarksMessage | ControlSweepProfileMarksMessage | ControlSweepReevaluateAllMessage | ControlSweepRetryStuckActionsMessage | ControlSweepReviewInboxMessage | ControlSweepStaleAlgorithmVersionMessage | ControlSweepSubscriptionsMessage | EvaluateChannelActionsMessage | EvaluateProfileActionsMessage | EvaluateVideoActionsMessage | FetchTranscriptMessage | IngestAckFeedMessage | IngestAckGenericMessage | IngestAckHistoryMessage | IngestAckRelatedMessage | IngestAckTranscriptMessage | IngestReparseMessage | ProcessFeedMessage | ProcessHistoryMessage | ScoringAnalyzeVideoMessage | ScoringEvalAgentCellMessage | ScoringEvalAgentFanoutMessage | ScoringEvalPipelineMessage | ScoringEvolvePromptMessage | ScoringRescoreLibraryMessage | TriageVideosMessage;

export type AnalysisQueueMessage = {
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum AnalysisQueueMessageType {
  AggregateChannel = 'AGGREGATE_CHANNEL',
  AggregateProfileChannelFeedback = 'AGGREGATE_PROFILE_CHANNEL_FEEDBACK',
  BindFeedbackTokens = 'BIND_FEEDBACK_TOKENS',
  ControlHeartbeatSessions = 'CONTROL_HEARTBEAT_SESSIONS',
  ControlSendInsightNotifications = 'CONTROL_SEND_INSIGHT_NOTIFICATIONS',
  ControlSweepChannelMarks = 'CONTROL_SWEEP_CHANNEL_MARKS',
  ControlSweepChannelRescores = 'CONTROL_SWEEP_CHANNEL_RESCORES',
  ControlSweepEvaluateChannelMarks = 'CONTROL_SWEEP_EVALUATE_CHANNEL_MARKS',
  ControlSweepEvaluateVideoMarks = 'CONTROL_SWEEP_EVALUATE_VIDEO_MARKS',
  ControlSweepProfileChannelOverlayMarks = 'CONTROL_SWEEP_PROFILE_CHANNEL_OVERLAY_MARKS',
  ControlSweepProfileMarks = 'CONTROL_SWEEP_PROFILE_MARKS',
  ControlSweepReevaluateAll = 'CONTROL_SWEEP_REEVALUATE_ALL',
  ControlSweepRetryStuckActions = 'CONTROL_SWEEP_RETRY_STUCK_ACTIONS',
  ControlSweepReviewInbox = 'CONTROL_SWEEP_REVIEW_INBOX',
  ControlSweepStaleAlgorithmVersion = 'CONTROL_SWEEP_STALE_ALGORITHM_VERSION',
  ControlSweepSubscriptions = 'CONTROL_SWEEP_SUBSCRIPTIONS',
  EvaluateChannelActions = 'EVALUATE_CHANNEL_ACTIONS',
  EvaluateProfileActions = 'EVALUATE_PROFILE_ACTIONS',
  EvaluateVideoActions = 'EVALUATE_VIDEO_ACTIONS',
  FetchTranscript = 'FETCH_TRANSCRIPT',
  IngestAckFeed = 'INGEST_ACK_FEED',
  IngestAckGeneric = 'INGEST_ACK_GENERIC',
  IngestAckHistory = 'INGEST_ACK_HISTORY',
  IngestAckRelated = 'INGEST_ACK_RELATED',
  IngestAckTranscript = 'INGEST_ACK_TRANSCRIPT',
  IngestReparseFeed = 'INGEST_REPARSE_FEED',
  IngestReparseHistory = 'INGEST_REPARSE_HISTORY',
  IngestReparseRelated = 'INGEST_REPARSE_RELATED',
  IngestReparseTranscript = 'INGEST_REPARSE_TRANSCRIPT',
  ProcessFeed = 'PROCESS_FEED',
  ProcessHistory = 'PROCESS_HISTORY',
  ScoringAnalyzeVideo = 'SCORING_ANALYZE_VIDEO',
  ScoringEvalAgentCell = 'SCORING_EVAL_AGENT_CELL',
  ScoringEvalAgentFanout = 'SCORING_EVAL_AGENT_FANOUT',
  ScoringEvalPipeline = 'SCORING_EVAL_PIPELINE',
  ScoringEvolvePrompt = 'SCORING_EVOLVE_PROMPT',
  ScoringRescoreLibrary = 'SCORING_RESCORE_LIBRARY',
  TriageVideos = 'TRIAGE_VIDEOS'
}

export enum AnalysisState {
  Completed = 'COMPLETED',
  Deprecated = 'DEPRECATED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  None = 'NONE'
}

export enum AnalysisVersion {
  Version_0_1_0 = 'VERSION_0_1_0'
}

export type ApplyCorrectiveActionInput = {
  actionId: Scalars['ID']['input'];
};

export type ApplyCorrectiveActionResult = {
  __typename?: 'ApplyCorrectiveActionResult';
  action?: Maybe<CorrectiveActionUnion>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ApplySuggestionResult = {
  __typename?: 'ApplySuggestionResult';
  executedAction?: Maybe<ExecutedAction>;
  suggestion: Suggestion;
};

export type Author = {
  __typename?: 'Author';
  id: Scalars['ID']['output'];
  is_moderator?: Maybe<Scalars['Boolean']['output']>;
  is_verified?: Maybe<Scalars['Boolean']['output']>;
  is_verified_artist?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  thumbnails: Array<Thumbnail>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AuthorAggregateScore = {
  __typename?: 'AuthorAggregateScore';
  allScoresFromFeedback: Scalars['Boolean']['output'];
  authorId: Scalars['String']['output'];
  confidence: ScoreConfidence;
  explanation: Scalars['String']['output'];
  rating: VideoRating;
  recommended: Array<Video>;
  restricted: Scalars['Boolean']['output'];
  restrictedVideoCount: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  totalOverriddenAgents: Scalars['Int']['output'];
  videoCount: Scalars['Int']['output'];
  videos: Array<AuthorVideoScore>;
  videosWithFeedback: Scalars['Int']['output'];
  watched: Array<Video>;
};

export type AuthorVideoScore = {
  __typename?: 'AuthorVideoScore';
  confidence?: Maybe<ScoreConfidence>;
  id: Scalars['ID']['output'];
  rating?: Maybe<VideoRating>;
  score?: Maybe<Scalars['Float']['output']>;
  video: Video;
};

export type BindFeedbackTokensMessage = AnalysisQueueMessage & {
  __typename?: 'BindFeedbackTokensMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  triggerSnapshotId?: Maybe<Scalars['String']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum BlobMigrationCollection {
  AgentPrompts = 'AGENT_PROMPTS',
  FeedSnapshots = 'FEED_SNAPSHOTS',
  HistorySnapshots = 'HISTORY_SNAPSHOTS',
  TaskResults = 'TASK_RESULTS',
  Transcripts = 'TRANSCRIPTS'
}

export type BlobMigrationResult = {
  __typename?: 'BlobMigrationResult';
  collection: BlobMigrationCollection;
  errors: Scalars['Int']['output'];
  finished: Scalars['Boolean']['output'];
  migrated: Scalars['Int']['output'];
  scanned: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type BullmqJobEntry = {
  __typename?: 'BullmqJobEntry';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  dataJson: Scalars['String']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  progressJson?: Maybe<Scalars['String']['output']>;
  returnValueJson?: Maybe<Scalars['String']['output']>;
  state: BullmqJobState;
};

export enum BullmqJobState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Waiting = 'WAITING'
}

export type BullmqQueueConcurrency = {
  __typename?: 'BullmqQueueConcurrency';
  concurrency: Scalars['Int']['output'];
  queueName: Scalars['String']['output'];
};

export type BullmqWorker = {
  __typename?: 'BullmqWorker';
  activeJobs: Scalars['Int']['output'];
  addr?: Maybe<Scalars['String']['output']>;
  ageSeconds?: Maybe<Scalars['Int']['output']>;
  idleSeconds?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  queueName: Scalars['String']['output'];
};

export type BullmqWorkersSnapshot = {
  __typename?: 'BullmqWorkersSnapshot';
  concurrencyByQueue: Array<BullmqQueueConcurrency>;
  concurrencyPerWorker: Scalars['Int']['output'];
  rateLimitDurationMs: Scalars['Int']['output'];
  rateLimitMax: Scalars['Int']['output'];
  totalActiveJobs: Scalars['Int']['output'];
  totalWorkers: Scalars['Int']['output'];
  workers: Array<BullmqWorker>;
};

export type ChannelCorrectiveAction = CorrectiveAction & {
  __typename?: 'ChannelCorrectiveAction';
  algorithmVersion?: Maybe<CorrectiveActionAlgorithmVersion>;
  appliedAt?: Maybe<Scalars['Float']['output']>;
  autoApplyEligible: Scalars['Boolean']['output'];
  channel: Author;
  channelScore: AuthorAggregateScore;
  confidence?: Maybe<ScoreConfidence>;
  confidenceReason?: Maybe<ConfidenceReason>;
  createdAt: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['Float']['output']>;
  events?: Maybe<Array<CorrectiveActionEvent>>;
  evidenceFingerprint?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Float']['output']>;
  feedbackTokens?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  kind: CorrectiveActionKind;
  profileId: Scalars['String']['output'];
  severity?: Maybe<CorrectiveActionSeverity>;
  skipUntil?: Maybe<Scalars['Float']['output']>;
  sourceVideoIds?: Maybe<Array<Scalars['String']['output']>>;
  status: CorrectiveActionStatus;
  takenAt?: Maybe<Scalars['Float']['output']>;
  takenBy?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tokenStatus: TokenStatus;
  trigger: CorrectiveActionTrigger;
  type: CorrectiveActionType;
};

export type ChannelEvolution = {
  __typename?: 'ChannelEvolution';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  changeLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  spark: Array<Scalars['Int']['output']>;
  tone: Scalars['String']['output'];
};

export type ChannelFeedbackQuality = {
  __typename?: 'ChannelFeedbackQuality';
  bad: Array<ChannelFeedbackRow>;
  badCount: Scalars['Int']['output'];
  good: Array<ChannelFeedbackRow>;
  goodCount: Scalars['Int']['output'];
  tbd: Array<ChannelFeedbackRow>;
  tbdCount: Scalars['Int']['output'];
};

export type ChannelFeedbackRow = {
  __typename?: 'ChannelFeedbackRow';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  channelId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  followed: Scalars['Boolean']['output'];
  netScore: Scalars['Int']['output'];
  noVotes: Scalars['Int']['output'];
  skipVotes: Scalars['Int']['output'];
  yesVotes: Scalars['Int']['output'];
};

export type ChatCompletionAssistantMessageParam = {
  __typename?: 'ChatCompletionAssistantMessageParam';
  audio?: Maybe<Scalars['JSON']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  function_call?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refusal?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tool_calls?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export type ChatCompletionChoice = {
  __typename?: 'ChatCompletionChoice';
  finish_reason?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  logprobs?: Maybe<Scalars['JSON']['output']>;
  message: ChatCompletionMessage;
};

export type ChatCompletionCreateParamsBase = {
  __typename?: 'ChatCompletionCreateParamsBase';
  audio?: Maybe<Scalars['JSON']['output']>;
  frequency_penalty?: Maybe<Scalars['Float']['output']>;
  function_call?: Maybe<Scalars['JSON']['output']>;
  functions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  logit_bias?: Maybe<Scalars['JSON']['output']>;
  logprobs?: Maybe<Scalars['Boolean']['output']>;
  max_completion_tokens?: Maybe<Scalars['Int']['output']>;
  max_tokens?: Maybe<Scalars['Int']['output']>;
  messages: Array<ChatCompletionMessageParam>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  modalities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  model: Scalars['String']['output'];
  n?: Maybe<Scalars['Int']['output']>;
  parallel_tool_calls?: Maybe<Scalars['Boolean']['output']>;
  prediction?: Maybe<Scalars['JSON']['output']>;
  presence_penalty?: Maybe<Scalars['Float']['output']>;
  prompt_cache_key?: Maybe<Scalars['String']['output']>;
  reasoning_effort?: Maybe<Scalars['String']['output']>;
  response_format?: Maybe<Scalars['JSON']['output']>;
  safety_identifier?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['Int']['output']>;
  service_tier?: Maybe<Scalars['String']['output']>;
  stop?: Maybe<Scalars['JSON']['output']>;
  store?: Maybe<Scalars['Boolean']['output']>;
  stream?: Maybe<Scalars['Boolean']['output']>;
  stream_options?: Maybe<Scalars['JSON']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  tool_choice?: Maybe<Scalars['JSON']['output']>;
  tools?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  top_logprobs?: Maybe<Scalars['Int']['output']>;
  top_p?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  verbosity?: Maybe<Scalars['String']['output']>;
  web_search_options?: Maybe<Scalars['JSON']['output']>;
};

export type ChatCompletionDeveloperMessageParam = {
  __typename?: 'ChatCompletionDeveloperMessageParam';
  content?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type ChatCompletionFunctionMessageParam = {
  __typename?: 'ChatCompletionFunctionMessageParam';
  content?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type ChatCompletionMessage = {
  __typename?: 'ChatCompletionMessage';
  content?: Maybe<Scalars['String']['output']>;
  function_call?: Maybe<Scalars['JSON']['output']>;
  refusal?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tool_calls?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export type ChatCompletionMessageParam = ChatCompletionAssistantMessageParam | ChatCompletionDeveloperMessageParam | ChatCompletionFunctionMessageParam | ChatCompletionSystemMessageParam | ChatCompletionToolMessageParam | ChatCompletionUserMessageParam;

export type ChatCompletionResponse = {
  __typename?: 'ChatCompletionResponse';
  choices: Array<Scalars['JSON']['output']>;
  created: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  model: Scalars['String']['output'];
  object: Scalars['String']['output'];
  system_fingerprint?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<ChatCompletionUsage>;
};

export type ChatCompletionSystemMessageParam = {
  __typename?: 'ChatCompletionSystemMessageParam';
  content?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type ChatCompletionToolMessageParam = {
  __typename?: 'ChatCompletionToolMessageParam';
  content?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tool_call_id: Scalars['String']['output'];
};

export type ChatCompletionUsage = {
  __typename?: 'ChatCompletionUsage';
  completion_tokens?: Maybe<Scalars['Int']['output']>;
  completion_tokens_details?: Maybe<Scalars['JSON']['output']>;
  prompt_tokens?: Maybe<Scalars['Int']['output']>;
  prompt_tokens_details?: Maybe<Scalars['JSON']['output']>;
  total_tokens?: Maybe<Scalars['Int']['output']>;
};

export type ChatCompletionUserMessageParam = {
  __typename?: 'ChatCompletionUserMessageParam';
  content?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export enum ChatModel {
  Gpt_3_5Turbo = 'GPT_3_5_TURBO',
  Gpt_4O = 'GPT_4O',
  Gpt_4OMini = 'GPT_4O_MINI',
  Gpt_4Turbo = 'GPT_4_TURBO',
  O1Mini = 'O1_MINI',
  O1Preview = 'O1_PREVIEW'
}

export type CollectionFirestoreCount = {
  __typename?: 'CollectionFirestoreCount';
  collection: Scalars['String']['output'];
  deletes: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  writes: Scalars['Int']['output'];
};

export enum ConfidenceReason {
  AgentAggregate = 'AGENT_AGGREGATE',
  AggregatePlusFeedback = 'AGGREGATE_PLUS_FEEDBACK',
  ParentFeedback = 'PARENT_FEEDBACK'
}

export enum ContentSeverity {
  Heavy = 'HEAVY',
  Incidental = 'INCIDENTAL',
  Moderate = 'MODERATE'
}

export type ControlHeartbeatSessionsMessage = AnalysisQueueMessage & {
  __typename?: 'ControlHeartbeatSessionsMessage';
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSendInsightNotificationsMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSendInsightNotificationsMessage';
  createdAt: Scalars['String']['output'];
  slot?: Maybe<Scalars['String']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepChannelMarksMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepChannelMarksMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepChannelRescoresMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepChannelRescoresMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepEvaluateChannelMarksMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepEvaluateChannelMarksMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepEvaluateVideoMarksMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepEvaluateVideoMarksMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepProfileChannelOverlayMarksMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepProfileChannelOverlayMarksMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepProfileMarksMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepProfileMarksMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepReevaluateAllMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepReevaluateAllMessage';
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepRetryStuckActionsMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepRetryStuckActionsMessage';
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepReviewInboxMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepReviewInboxMessage';
  createdAt: Scalars['String']['output'];
  profileId?: Maybe<Scalars['String']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepStaleAlgorithmVersionMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepStaleAlgorithmVersionMessage';
  createdAt: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ControlSweepSubscriptionsMessage = AnalysisQueueMessage & {
  __typename?: 'ControlSweepSubscriptionsMessage';
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Cookie = {
  __typename?: 'Cookie';
  domain?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CookieInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CorrectiveAction = {
  algorithmVersion?: Maybe<CorrectiveActionAlgorithmVersion>;
  appliedAt?: Maybe<Scalars['Float']['output']>;
  autoApplyEligible: Scalars['Boolean']['output'];
  confidence?: Maybe<ScoreConfidence>;
  confidenceReason?: Maybe<ConfidenceReason>;
  createdAt: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['Float']['output']>;
  events?: Maybe<Array<CorrectiveActionEvent>>;
  evidenceFingerprint?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Float']['output']>;
  feedbackTokens?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  kind: CorrectiveActionKind;
  profileId: Scalars['String']['output'];
  severity?: Maybe<CorrectiveActionSeverity>;
  skipUntil?: Maybe<Scalars['Float']['output']>;
  sourceVideoIds?: Maybe<Array<Scalars['String']['output']>>;
  status: CorrectiveActionStatus;
  takenAt?: Maybe<Scalars['Float']['output']>;
  takenBy?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tokenStatus: TokenStatus;
  trigger: CorrectiveActionTrigger;
  type: CorrectiveActionType;
};

export enum CorrectiveActionAlgorithmVersion {
  Version_0_1_0 = 'VERSION_0_1_0',
  Version_0_2_0 = 'VERSION_0_2_0',
  Version_0_3_0 = 'VERSION_0_3_0'
}

export type CorrectiveActionEvent = {
  __typename?: 'CorrectiveActionEvent';
  actionId: Scalars['String']['output'];
  actor: CorrectiveActionEventActor;
  at: Scalars['Float']['output'];
  edgeTaskId?: Maybe<Scalars['String']['output']>;
  event: CorrectiveActionEventKind;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  tokenUsed?: Maybe<Scalars['String']['output']>;
  undoToken?: Maybe<Scalars['String']['output']>;
};

export enum CorrectiveActionEventActor {
  EdgeAgent = 'EDGE_AGENT',
  ParentMobile = 'PARENT_MOBILE',
  ParentWeb = 'PARENT_WEB',
  System = 'SYSTEM'
}

export enum CorrectiveActionEventKind {
  Applied = 'APPLIED',
  BoundToken = 'BOUND_TOKEN',
  Dismissed = 'DISMISSED',
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Refreshed = 'REFRESHED',
  Reverted = 'REVERTED',
  Skipped = 'SKIPPED',
  Superseded = 'SUPERSEDED'
}

export enum CorrectiveActionKind {
  Channel = 'CHANNEL',
  Feed = 'FEED',
  Video = 'VIDEO'
}

export enum CorrectiveActionSeverity {
  High = 'HIGH',
  Optional = 'OPTIONAL'
}

export type CorrectiveActionStats = {
  __typename?: 'CorrectiveActionStats';
  channelAnalysisTriggered: Scalars['Int']['output'];
  dontRecommendChannel: Scalars['Int']['output'];
  notInterested: Scalars['Int']['output'];
  recentlyRecommended: Scalars['Int']['output'];
  recentlyTaken: Scalars['Int']['output'];
  subscribe: Scalars['Int']['output'];
  totalDismissed: Scalars['Int']['output'];
  totalFailed: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
  totalRecommended: Scalars['Int']['output'];
  totalTaken: Scalars['Int']['output'];
  undoActions: Scalars['Int']['output'];
  userFeedbackTriggered: Scalars['Int']['output'];
  userTriggered: Scalars['Int']['output'];
  videoAnalysisTriggered: Scalars['Int']['output'];
};

export enum CorrectiveActionStatus {
  Dismissed = 'DISMISSED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Recommended = 'RECOMMENDED',
  Superseded = 'SUPERSEDED',
  Taken = 'TAKEN'
}

export enum CorrectiveActionTrigger {
  ChannelScoreAnalysis = 'CHANNEL_SCORE_ANALYSIS',
  FeedShelf = 'FEED_SHELF',
  User = 'USER',
  UserFeedback = 'USER_FEEDBACK',
  VideoAnalysis = 'VIDEO_ANALYSIS'
}

export enum CorrectiveActionType {
  BlockChannel = 'BLOCK_CHANNEL',
  BlockVideo = 'BLOCK_VIDEO',
  FollowChannel = 'FOLLOW_CHANNEL',
  RemoveShorts = 'REMOVE_SHORTS',
  UnblockChannel = 'UNBLOCK_CHANNEL',
  UnblockVideo = 'UNBLOCK_VIDEO',
  UnfollowChannel = 'UNFOLLOW_CHANNEL'
}

export type CorrectiveActionUnion = ChannelCorrectiveAction | FeedCorrectiveAction | VideoCorrectiveAction;

export type CostByAgent = {
  __typename?: 'CostByAgent';
  callCount: Scalars['Int']['output'];
  costUSD: Scalars['Float']['output'];
  model: Scalars['String']['output'];
  specialization: Scalars['String']['output'];
  tokens: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type CostByModel = {
  __typename?: 'CostByModel';
  callCount: Scalars['Int']['output'];
  costUSD: Scalars['Float']['output'];
  model: Scalars['String']['output'];
  tokens: Scalars['Int']['output'];
};

export type CostDailyBucket = {
  __typename?: 'CostDailyBucket';
  callCount: Scalars['Int']['output'];
  costUSD: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  tokens: Scalars['Int']['output'];
};

export type CostEstimateInfo = {
  __typename?: 'CostEstimateInfo';
  inputCost: Scalars['Float']['output'];
  model: Scalars['String']['output'];
  outputCost: Scalars['Float']['output'];
  pricingDate: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
};

export type CreateFeedTaskResult = {
  __typename?: 'CreateFeedTaskResult';
  message: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type CreateInviteResult = {
  __typename?: 'CreateInviteResult';
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type Criterion = {
  __typename?: 'Criterion';
  measure: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

export type DailyFeedStats = {
  __typename?: 'DailyFeedStats';
  averageScore: Scalars['Float']['output'];
  processedVideos: Array<Video>;
  scoreDistribution: ScoreDistribution;
  videosProcessed: Scalars['Int']['output'];
  videosScoredCount: Scalars['Int']['output'];
};

export type DailyHistoryStats = {
  __typename?: 'DailyHistoryStats';
  averageDurationPerVideo: Scalars['Float']['output'];
  averageScore: Scalars['Float']['output'];
  processedVideos: Array<Video>;
  scoreDistribution: ScoreDistribution;
  totalDurationWatched: Scalars['Int']['output'];
  videosProcessed: Scalars['Int']['output'];
  videosScoredCount: Scalars['Int']['output'];
};

export type DailyObjectionableStats = {
  __typename?: 'DailyObjectionableStats';
  objectionableVideosRecommended: Scalars['Int']['output'];
  objectionableVideosWatched: Scalars['Int']['output'];
  recommendedObjectionableVideos: Array<Video>;
  watchedObjectionableVideos: Array<Video>;
};

export type DailyScore = {
  __typename?: 'DailyScore';
  date: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export enum DataRequirement {
  MetadataOnly = 'METADATA_ONLY',
  SummaryRequired = 'SUMMARY_REQUIRED',
  TranscriptRequired = 'TRANSCRIPT_REQUIRED'
}

export type DateRange = {
  __typename?: 'DateRange';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type DeleteEdgeTaskResult = {
  __typename?: 'DeleteEdgeTaskResult';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteEdgeTasksResult = {
  __typename?: 'DeleteEdgeTasksResult';
  deleted: Scalars['Int']['output'];
};

export type DesktopHeartbeatResult = {
  __typename?: 'DesktopHeartbeatResult';
  acceptedCount: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
};

export type DesktopProfileHeartbeat = {
  profileId: Scalars['ID']['input'];
  youtubeSessionInvalidReason?: InputMaybe<Scalars['String']['input']>;
  youtubeSessionValid: Scalars['Boolean']['input'];
};

export type Device = {
  __typename?: 'Device';
  appVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  registeredAt: Scalars['String']['output'];
  subscribedProfileIds: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type DeviceGrant = {
  __typename?: 'DeviceGrant';
  expiresAt: Scalars['Float']['output'];
  token: Scalars['String']['output'];
};

export type DevicePairing = {
  __typename?: 'DevicePairing';
  code: Scalars['String']['output'];
  expiresAt: Scalars['Float']['output'];
  pairingId: Scalars['ID']['output'];
};

export type DevicePairingClaimResult = {
  __typename?: 'DevicePairingClaimResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DevicePairingStatus = {
  __typename?: 'DevicePairingStatus';
  grant?: Maybe<DeviceGrant>;
  status: Scalars['String']['output'];
};

export type EdgeProfileStats = {
  __typename?: 'EdgeProfileStats';
  feedEnrichingPct?: Maybe<Scalars['Int']['output']>;
  flagged7d: Scalars['Int']['output'];
  historyEnrichingPct?: Maybe<Scalars['Int']['output']>;
  pendingDecisions: Scalars['Int']['output'];
  topChannel7d?: Maybe<Scalars['String']['output']>;
  topChannel7dCount: Scalars['Int']['output'];
  videos7d: Scalars['Int']['output'];
  videosToday: Scalars['Int']['output'];
};

export type EdgeQueueTask = {
  __typename?: 'EdgeQueueTask';
  claimedByDeviceId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  executedBy?: Maybe<Scalars['String']['output']>;
  extractionJobId?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<TaskFailureReason>;
  failureStage?: Maybe<TaskFailureStage>;
  handledVia?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxRetries: Scalars['Int']['output'];
  parserVersion?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  profileId: Scalars['String']['output'];
  result?: Maybe<TaskResult>;
  retryCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  state: TaskState;
  type: EdgeQueueTaskType;
  updatedAt: Scalars['String']['output'];
};

export enum EdgeQueueTaskType {
  CorrectiveBlockChannel = 'CORRECTIVE_BLOCK_CHANNEL',
  CorrectiveBlockVideo = 'CORRECTIVE_BLOCK_VIDEO',
  CorrectiveFollowChannel = 'CORRECTIVE_FOLLOW_CHANNEL',
  CorrectiveRemoveShorts = 'CORRECTIVE_REMOVE_SHORTS',
  CorrectiveUnblockChannel = 'CORRECTIVE_UNBLOCK_CHANNEL',
  CorrectiveUnblockVideo = 'CORRECTIVE_UNBLOCK_VIDEO',
  CorrectiveUnfollowChannel = 'CORRECTIVE_UNFOLLOW_CHANNEL',
  QueryFeed = 'QUERY_FEED',
  QueryHistory = 'QUERY_HISTORY',
  QueryRelated = 'QUERY_RELATED',
  QuerySubscriptions = 'QUERY_SUBSCRIPTIONS',
  Transcribe = 'TRANSCRIBE'
}

export type EdgeRecentWatch = {
  __typename?: 'EdgeRecentWatch';
  channelName?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['ID']['output'];
  watchedAt: Scalars['String']['output'];
};

export type EnqueueJobResult = {
  __typename?: 'EnqueueJobResult';
  jobId?: Maybe<Scalars['String']['output']>;
  messageType: AnalysisQueueMessageType;
  ok: Scalars['Boolean']['output'];
};

export type EvalAgentEntry = {
  __typename?: 'EvalAgentEntry';
  dataRequirement: DataRequirement;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  max_age: Scalars['Int']['output'];
  min_age: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  scoreDirection: ScoreDirection;
  specialization: AgentSpecialization;
  summarizationNeed?: Maybe<SummarizationNeed>;
  thumbnails: Array<Thumbnail>;
  triggers?: Maybe<AgentTriggers>;
  type: AgentType;
  version: Scalars['String']['output'];
};

export type EvalExpectedPerAgentInput = {
  rating?: InputMaybe<VideoRating>;
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  specialization: AgentSpecialization;
};

export type EvalFieldAccuracy = {
  __typename?: 'EvalFieldAccuracy';
  rating: EvalFieldCategoricalAccuracy;
  restricted: EvalFieldCategoricalAccuracy;
  score: EvalFieldScoreAccuracy;
};

export type EvalFieldCategoricalAccuracy = {
  __typename?: 'EvalFieldCategoricalAccuracy';
  correct: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EvalFieldScoreAccuracy = {
  __typename?: 'EvalFieldScoreAccuracy';
  avgContribution: Scalars['Float']['output'];
  avgDistance: Scalars['Float']['output'];
};

export type EvalReport = {
  __typename?: 'EvalReport';
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  fieldAccuracy: EvalFieldAccuracy;
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  overallScore: Scalars['Float']['output'];
  passedCases: Scalars['Int']['output'];
  promptVersion: Scalars['String']['output'];
  ranAt: Scalars['String']['output'];
  results: Array<Scalars['JSON']['output']>;
  totalCases: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  totalTokenUsage: TokenUsageInfo;
};

export type EvalTestCase = {
  __typename?: 'EvalTestCase';
  addedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expected: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type EvalTestCaseInput = {
  expected: Array<EvalExpectedPerAgentInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['String']['input'];
};

export type EvaluateChannelActionsMessage = AnalysisQueueMessage & {
  __typename?: 'EvaluateChannelActionsMessage';
  authorId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EvaluateProfileActionsMessage = AnalysisQueueMessage & {
  __typename?: 'EvaluateProfileActionsMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EvaluateVideoActionsMessage = AnalysisQueueMessage & {
  __typename?: 'EvaluateVideoActionsMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Evidence = {
  __typename?: 'Evidence';
  factorSummary?: Maybe<Array<EvidenceFactorSummary>>;
  oneLine: Scalars['String']['output'];
  preview: EvidencePreview;
  scoring?: Maybe<EvidenceScoring>;
  videos: Array<EvidenceVideo>;
};

export type EvidenceFactor = {
  __typename?: 'EvidenceFactor';
  contribution: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type EvidenceFactorSummary = {
  __typename?: 'EvidenceFactorSummary';
  avgScore: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lowCount: Scalars['Int']['output'];
  videoCount: Scalars['Int']['output'];
};

export type EvidencePreview = {
  __typename?: 'EvidencePreview';
  bullets: Array<EvidencePreviewBullet>;
  headline: Scalars['String']['output'];
  reversibleNote: Scalars['String']['output'];
};

export type EvidencePreviewBullet = {
  __typename?: 'EvidencePreviewBullet';
  kind: PreviewKind;
  text: Scalars['String']['output'];
};

export type EvidenceScoring = {
  __typename?: 'EvidenceScoring';
  confidencePct: Scalars['Int']['output'];
  direction: ThresholdDirection;
  factors: Array<EvidenceFactor>;
  finalScore: Scalars['Float']['output'];
  modelVersion: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  threshold: Scalars['Float']['output'];
};

export type EvidenceVideo = {
  __typename?: 'EvidenceVideo';
  aiRating?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mins: Scalars['Int']['output'];
  parentVerdict?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcriptBacked?: Maybe<Scalars['Boolean']['output']>;
  watched: Scalars['Boolean']['output'];
};

export type EvolveAgentPromptInput = {
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['input'];
  autoEvalAfter?: InputMaybe<Scalars['Boolean']['input']>;
  autoEvalModel?: InputMaybe<Scalars['String']['input']>;
  basePromptVersion?: InputMaybe<Scalars['String']['input']>;
  coachModel: Scalars['String']['input'];
  sampleLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ExecutedAction = {
  __typename?: 'ExecutedAction';
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metricsDelta?: Maybe<ActionMetrics>;
  occurredAt: Scalars['Float']['output'];
  outcome: Scalars['String']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  profileId: Scalars['ID']['output'];
  target: SuggestionTarget;
  verb: SuggestionVerb;
  voteId?: Maybe<Scalars['ID']['output']>;
};

export type FeedCorrectiveAction = CorrectiveAction & {
  __typename?: 'FeedCorrectiveAction';
  algorithmVersion?: Maybe<CorrectiveActionAlgorithmVersion>;
  appliedAt?: Maybe<Scalars['Float']['output']>;
  autoApplyEligible: Scalars['Boolean']['output'];
  confidence?: Maybe<ScoreConfidence>;
  confidenceReason?: Maybe<ConfidenceReason>;
  createdAt: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['Float']['output']>;
  events?: Maybe<Array<CorrectiveActionEvent>>;
  evidenceFingerprint?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Float']['output']>;
  feedbackTokens?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  kind: CorrectiveActionKind;
  lastAppliedAt?: Maybe<Scalars['Float']['output']>;
  profileId: Scalars['String']['output'];
  reapplyCount?: Maybe<Scalars['Int']['output']>;
  severity?: Maybe<CorrectiveActionSeverity>;
  skipUntil?: Maybe<Scalars['Float']['output']>;
  sourceVideoIds?: Maybe<Array<Scalars['String']['output']>>;
  status: CorrectiveActionStatus;
  takenAt?: Maybe<Scalars['Float']['output']>;
  takenBy?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tokenStatus: TokenStatus;
  trigger: CorrectiveActionTrigger;
  type: CorrectiveActionType;
};

export type FeedVideo = {
  __typename?: 'FeedVideo';
  author: Author;
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  feedback?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  is_live?: Maybe<Scalars['Boolean']['output']>;
  is_watched?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['String']['output']>;
  recommended_on: Array<Scalars['String']['output']>;
  snapshot_date: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  thumbnails: Array<Thumbnail>;
  title: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
  watch_date?: Maybe<Scalars['String']['output']>;
};

export type FeedbackLog = ScoreBase & {
  __typename?: 'FeedbackLog';
  agent: AgentId;
  agentScoreId?: Maybe<Scalars['ID']['output']>;
  agreement?: Maybe<AgreementType>;
  authorId: Scalars['String']['output'];
  date: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: ScoreKind;
  profileId: Scalars['String']['output'];
  rating: VideoRating;
  score: Scalars['Float']['output'];
  scoreDirection: ScoreDirection;
  type: AgentType;
  userId: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type FeedbackToken = {
  __typename?: 'FeedbackToken';
  token: Scalars['String']['output'];
  undoToken: Scalars['String']['output'];
};

export type FeedbackTokens = {
  __typename?: 'FeedbackTokens';
  dontRecommendChannel: FeedbackToken;
  notInterested: FeedbackToken;
};

export type FetchTranscriptMessage = AnalysisQueueMessage & {
  __typename?: 'FetchTranscriptMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['String']['output'];
};

export type FirebaseUser = {
  __typename?: 'FirebaseUser';
  accounts?: Maybe<Array<LinkedAccount>>;
  createdAt: Scalars['Float']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  updatedAt: Scalars['Float']['output'];
  welcomeState?: Maybe<WelcomeState>;
};

export type GatedContext = {
  __typename?: 'GatedContext';
  selectionDetail?: Maybe<Scalars['String']['output']>;
  selectionReason: SpecialistSelectionReason;
  stage: Scalars['Int']['output'];
};

export type GenerateCorrectiveActionsInput = {
  profileId: Scalars['String']['input'];
};

export type GenerateCorrectiveActionsResult = {
  __typename?: 'GenerateCorrectiveActionsResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GuardianGroup = {
  __typename?: 'GuardianGroup';
  createdAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  members: Array<GuardianGroupMember>;
  name: Scalars['String']['output'];
  nameIsCustom: Scalars['Boolean']['output'];
  profiles: Array<YouTubeProfile>;
};

export type GuardianGroupMember = {
  __typename?: 'GuardianGroupMember';
  displayName?: Maybe<Scalars['String']['output']>;
  isSelf: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type HarvestedFeedbackToken = {
  __typename?: 'HarvestedFeedbackToken';
  channelName?: Maybe<Scalars['String']['output']>;
  feedbackTokens?: Maybe<FeedbackTokens>;
  videoId: Scalars['String']['output'];
  videoTitle: Scalars['String']['output'];
};

export type HistoryScoresOverTime = {
  __typename?: 'HistoryScoresOverTime';
  dailyScores: Array<DailyScore>;
  weeklyScores: Array<WeeklyScore>;
};

export type HistoryVideo = {
  __typename?: 'HistoryVideo';
  author: Author;
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  feedback?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  is_live?: Maybe<Scalars['Boolean']['output']>;
  is_watched?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['String']['output']>;
  snapshot_date: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  thumbnails: Array<Thumbnail>;
  title: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
  watch_date?: Maybe<Scalars['String']['output']>;
  watch_date_header?: Maybe<Scalars['String']['output']>;
  watched_on: Array<Scalars['String']['output']>;
};

export type HomeCaughtItem = {
  __typename?: 'HomeCaughtItem';
  outcome: Scalars['String']['output'];
  target: Scalars['String']['output'];
  verb: Scalars['String']['output'];
};

export type HomeCaughtSummary = {
  __typename?: 'HomeCaughtSummary';
  channelsAutoBlocked: Scalars['Int']['output'];
  flagged: Scalars['Int']['output'];
  shortsHidden: Scalars['Int']['output'];
};

export type HomeScore = {
  __typename?: 'HomeScore';
  delta: Scalars['Int']['output'];
  direction: Scalars['String']['output'];
  pct?: Maybe<Scalars['Int']['output']>;
  scoredCount: Scalars['Int']['output'];
  watchedCount?: Maybe<Scalars['Int']['output']>;
};

export type HomeTopChannel = {
  __typename?: 'HomeTopChannel';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  flaggedCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  minutesThisWeek: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  videoCount: Scalars['Int']['output'];
};

export type HomeWeeklyImpact = {
  __typename?: 'HomeWeeklyImpact';
  caught?: Maybe<Array<HomeCaughtItem>>;
  prevWeekQualityPct?: Maybe<Scalars['Int']['output']>;
  qualityWatchPct?: Maybe<Scalars['Int']['output']>;
  weeklySparkline?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ImpactAchievement = {
  __typename?: 'ImpactAchievement';
  body: Scalars['String']['output'];
  iconKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum ImpactRange {
  All = 'ALL',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ImpactSummaryResult = {
  __typename?: 'ImpactSummaryResult';
  achievements: Array<ImpactAchievement>;
  baselinePct?: Maybe<Scalars['Float']['output']>;
  cleanBaselinePct?: Maybe<Scalars['Float']['output']>;
  cleanDelta: Scalars['Float']['output'];
  cleanPct?: Maybe<Scalars['Float']['output']>;
  closingLine: Scalars['String']['output'];
  flaggedThisWeek: Scalars['Int']['output'];
  highQualityDelta: Scalars['Float']['output'];
  highQualityPct?: Maybe<Scalars['Float']['output']>;
  kidName: Scalars['String']['output'];
};

export type IngestAckFeedMessage = AnalysisQueueMessage & {
  __typename?: 'IngestAckFeedMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskResult: TaskResult;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type IngestAckGenericMessage = AnalysisQueueMessage & {
  __typename?: 'IngestAckGenericMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskResult: TaskResult;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type IngestAckHistoryMessage = AnalysisQueueMessage & {
  __typename?: 'IngestAckHistoryMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskResult: TaskResult;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type IngestAckRelatedMessage = AnalysisQueueMessage & {
  __typename?: 'IngestAckRelatedMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskResult: TaskResult;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type IngestAckTranscriptMessage = AnalysisQueueMessage & {
  __typename?: 'IngestAckTranscriptMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskResult: TaskResult;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type IngestReparseMessage = AnalysisQueueMessage & {
  __typename?: 'IngestReparseMessage';
  createdAt: Scalars['String']['output'];
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  taskId: Scalars['ID']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvitePreview = {
  __typename?: 'InvitePreview';
  expiresAt?: Maybe<Scalars['Float']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  profiles: Array<YouTubeProfile>;
  source?: Maybe<InviteSource>;
  valid: Scalars['Boolean']['output'];
};

export enum InviteSource {
  Coparent = 'COPARENT',
  Desktop = 'DESKTOP'
}

export type KidProfile = {
  __typename?: 'KidProfile';
  age?: Maybe<Scalars['Int']['output']>;
  bannerBody: Scalars['String']['output'];
  bannerHeadline: Scalars['String']['output'];
  flagged: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  greatFit: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  initial: Scalars['String']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  reviewItems: Array<KidProfileReviewItem>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  watched: Scalars['Int']['output'];
};

export type KidProfileReviewItem = {
  __typename?: 'KidProfileReviewItem';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LlmCostSummary = {
  __typename?: 'LLMCostSummary';
  byAgent: Array<CostByAgent>;
  byModel: Array<CostByModel>;
  callCount: Scalars['Int']['output'];
  daily: Array<CostDailyBucket>;
  generatedAt: Scalars['String']['output'];
  since: Scalars['String']['output'];
  totalCostUSD: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
  until: Scalars['String']['output'];
};

export type LlmRequest = {
  __typename?: 'LLMRequest';
  messages: Array<ChatCompletionMessageParam>;
  model: Scalars['String']['output'];
  temperature?: Maybe<Scalars['Float']['output']>;
  tools?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type LlmUsage = {
  __typename?: 'LLMUsage';
  completionTokens?: Maybe<Scalars['Int']['output']>;
  promptTokens?: Maybe<Scalars['Int']['output']>;
  totalTokens?: Maybe<Scalars['Int']['output']>;
};

export type LanguageFacts = {
  __typename?: 'LanguageFacts';
  code: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  secondary?: Maybe<Scalars['String']['output']>;
  source: LanguageSource;
};

export enum LanguagePolicyMode {
  AllowAll = 'ALLOW_ALL',
  AllowListed = 'ALLOW_LISTED',
  BlockListed = 'BLOCK_LISTED'
}

export enum LanguageSource {
  Metadata = 'METADATA',
  TitleDescription = 'TITLE_DESCRIPTION',
  Transcript = 'TRANSCRIPT'
}

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  linkedAt: Scalars['Float']['output'];
  profileId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  ackTask: Scalars['Boolean']['output'];
  addEvalTestCase: EvalTestCase;
  adminDeleteSession: AdminDeleteSessionResult;
  adminPurgeProfile: AdminPurgeProfileResult;
  adminRecomputeCorrectiveActions: AdminRecomputeCorrectiveActionsResult;
  adminRerunScoringPipeline: AdminRerunScoringPipelineResult;
  adminResetAllVideoScores: AdminResetAllVideoScoresResult;
  adminResetAllVideoSummaries: AdminResetAllVideoSummariesResult;
  adminResetVideoScores: AdminResetVideoScoresResult;
  adminResetVideoSummary: AdminResetVideoSummaryResult;
  adminRunPipelineEval: AdminEnqueuePipelineEvalResult;
  adminSeedClaudeAuthoredPrompts: AdminSeedPromptsResult;
  adminSweepProfileSessions: AdminSweepProfileSessionsResult;
  adminTestAgentScoring: AdminScoringTestResult;
  adminTestInsightNotification: AdminInsightTestResult;
  applyAllCorrectiveActions: ApplyCorrectiveActionResult;
  applyCorrectiveAction: ApplyCorrectiveActionResult;
  applySuggestion: ApplySuggestionResult;
  cancelBullmqJob: Scalars['Boolean']['output'];
  claimDevicePairing: DevicePairingClaimResult;
  createCoparentInvite: CreateInviteResult;
  createDesktopInvite: CreateInviteResult;
  createFeedTask: CreateFeedTaskResult;
  createGuardianGroup: GuardianGroup;
  createSession: UserSession;
  deleteAgentPrompt: Scalars['Boolean']['output'];
  deleteEdgeTask: DeleteEdgeTaskResult;
  deleteEdgeTasks: DeleteEdgeTasksResult;
  deleteEdgeTasksByIds: DeleteEdgeTasksResult;
  deleteEvalReport: Scalars['Boolean']['output'];
  deleteEvalTestCase: Scalars['Boolean']['output'];
  desktopHeartbeat: DesktopHeartbeatResult;
  dismissCorrectiveAction: ApplyCorrectiveActionResult;
  dismissSuggestion: Suggestion;
  evolveAgentPrompt: EnqueueJobResult;
  flagSuggestionWrong: Suggestion;
  forkAgentPrompt: AgentPromptEntry;
  generateCorrectiveActions: GenerateCorrectiveActionsResult;
  linkSessionToUser: SessionLinkResult;
  markWelcomeStep: WelcomeState;
  migrateLegacyBlobs: BlobMigrationResult;
  primeEdgeTasks: PrimeEdgeTasksResult;
  redeemInviteAutoLogin: RedeemInviteResult;
  redeemInviteForCurrentUser: RedeemInviteResult;
  refreshDeviceGrant?: Maybe<DeviceGrant>;
  registerDevice: Device;
  registerPushToken: Device;
  removeBullmqJobs: Scalars['Int']['output'];
  renameDevice: Device;
  renameGuardianGroup: GuardianGroup;
  reprocessLastTasks: ReprocessTasksBatchResult;
  reprocessTask: ReprocessTaskResult;
  rescoreVideosAsync: EnqueueJobResult;
  resetEdgeTask: ResetEdgeTaskResult;
  resetEdgeTasksByIds: ResetEdgeTasksResult;
  resetWelcomeSkip: WelcomeState;
  retractCorrectiveAction: RetractResult;
  retractVerdict: RetractResult;
  retryAllFailedEdgeTaskExtractions: RetryAllFailedExtractionsResult;
  retryEdgeTaskExtraction: EnqueueJobResult;
  retryFailedEdgeTaskExtractions: RetryFailedExtractionsResult;
  runEval: EnqueueJobResult;
  runMultiModelEval: EnqueueJobResult;
  saveAgentPrompt: AgentPromptEntry;
  scoreVideo: ScoreVideoResult;
  seedEvalTestCasesFromScores: SeedTestCasesResult;
  setGuardianDisplayName: Scalars['Boolean']['output'];
  setGuardianTimezone: Scalars['Boolean']['output'];
  setProfilePreferences: ProfilePreferences;
  skipCorrectiveAction: ApplyCorrectiveActionResult;
  skipWelcome: WelcomeState;
  snoozeSuggestion: Suggestion;
  startDevicePairing: DevicePairing;
  subscribeDeviceToProfile: Device;
  unlinkSessionFromUser: SessionLinkResult;
  unsubscribeDeviceFromProfile: Device;
  updateEvalTestCase: EvalTestCase;
};


export type MutationAckTaskArgs = {
  result: TaskResultInput;
  taskId: Scalars['ID']['input'];
};


export type MutationAddEvalTestCaseArgs = {
  input: EvalTestCaseInput;
};


export type MutationAdminDeleteSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationAdminPurgeProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type MutationAdminRecomputeCorrectiveActionsArgs = {
  profileId: Scalars['ID']['input'];
};


export type MutationAdminRerunScoringPipelineArgs = {
  sourceTaskId: Scalars['ID']['input'];
};


export type MutationAdminResetVideoScoresArgs = {
  videoIds: Array<Scalars['String']['input']>;
};


export type MutationAdminResetVideoSummaryArgs = {
  videoId: Scalars['String']['input'];
};


export type MutationAdminRunPipelineEvalArgs = {
  input: AdminEvalPipelineInput;
};


export type MutationAdminSweepProfileSessionsArgs = {
  profileId: Scalars['ID']['input'];
  states: Array<AdminCcSessionState>;
};


export type MutationAdminTestAgentScoringArgs = {
  agent: AgentIdInput;
  overrides?: InputMaybe<AgentParameterOverrides>;
  videoId: Scalars['String']['input'];
};


export type MutationAdminTestInsightNotificationArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  profileId: Scalars['ID']['input'];
};


export type MutationApplyAllCorrectiveActionsArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationApplyCorrectiveActionArgs = {
  input: ApplyCorrectiveActionInput;
};


export type MutationApplySuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationCancelBullmqJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationClaimDevicePairingArgs = {
  code: Scalars['String']['input'];
};


export type MutationCreateCoparentInviteArgs = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateDesktopInviteArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFeedTaskArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationCreateGuardianGroupArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  profileIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateSessionArgs = {
  accountEmailHint?: InputMaybe<Scalars['String']['input']>;
  cookies: Array<CookieInput>;
  forceReparse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAgentPromptArgs = {
  id: Scalars['String']['input'];
  kind: AgentPromptKind;
  version: Scalars['String']['input'];
};


export type MutationDeleteEdgeTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type MutationDeleteEdgeTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<TaskState>>;
  taskType?: InputMaybe<EdgeQueueTaskType>;
};


export type MutationDeleteEdgeTasksByIdsArgs = {
  taskIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEvalReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEvalTestCaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDesktopHeartbeatArgs = {
  profiles: Array<DesktopProfileHeartbeat>;
};


export type MutationDismissCorrectiveActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationDismissSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationEvolveAgentPromptArgs = {
  input: EvolveAgentPromptInput;
};


export type MutationFlagSuggestionWrongArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  suggestionId: Scalars['ID']['input'];
};


export type MutationForkAgentPromptArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  fromVersion: Scalars['String']['input'];
  id: Scalars['String']['input'];
  kind: AgentPromptKind;
  newVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateCorrectiveActionsArgs = {
  input: GenerateCorrectiveActionsInput;
};


export type MutationLinkSessionToUserArgs = {
  sessionToken: Scalars['String']['input'];
};


export type MutationMarkWelcomeStepArgs = {
  step: WelcomeStep;
};


export type MutationMigrateLegacyBlobsArgs = {
  collection: BlobMigrationCollection;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPrimeEdgeTasksArgs = {
  profileIds: Array<Scalars['ID']['input']>;
};


export type MutationRedeemInviteAutoLoginArgs = {
  token: Scalars['String']['input'];
};


export type MutationRedeemInviteForCurrentUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationRefreshDeviceGrantArgs = {
  token: Scalars['String']['input'];
};


export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput;
};


export type MutationRegisterPushTokenArgs = {
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRemoveBullmqJobsArgs = {
  states: Array<BullmqJobState>;
};


export type MutationRenameDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameGuardianGroupArgs = {
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationReprocessLastTasksArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  taskType: EdgeQueueTaskType;
};


export type MutationReprocessTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type MutationRescoreVideosAsyncArgs = {
  input: RescoreVideosInput;
};


export type MutationResetEdgeTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type MutationResetEdgeTasksByIdsArgs = {
  taskIds: Array<Scalars['ID']['input']>;
};


export type MutationRetractCorrectiveActionArgs = {
  actionId: Scalars['String']['input'];
};


export type MutationRetractVerdictArgs = {
  profileId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type MutationRetryAllFailedEdgeTaskExtractionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sinceMs?: InputMaybe<Scalars['Float']['input']>;
  taskTypes?: InputMaybe<Array<EdgeQueueTaskType>>;
};


export type MutationRetryEdgeTaskExtractionArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};


export type MutationRetryFailedEdgeTaskExtractionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  taskType: EdgeQueueTaskType;
};


export type MutationRunEvalArgs = {
  input: RunEvalInput;
};


export type MutationRunMultiModelEvalArgs = {
  input: RunMultiModelEvalInput;
};


export type MutationSaveAgentPromptArgs = {
  input: SaveAgentPromptInput;
};


export type MutationScoreVideoArgs = {
  profileId: Scalars['String']['input'];
  verdict: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type MutationSeedEvalTestCasesFromScoresArgs = {
  count: Scalars['Int']['input'];
};


export type MutationSetGuardianDisplayNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationSetGuardianTimezoneArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationSetProfilePreferencesArgs = {
  input: ProfilePreferencesInput;
  profileId: Scalars['ID']['input'];
};


export type MutationSkipCorrectiveActionArgs = {
  actionId: Scalars['ID']['input'];
  skipDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSnoozeSuggestionArgs = {
  days: Scalars['Int']['input'];
  suggestionId: Scalars['ID']['input'];
};


export type MutationStartDevicePairingArgs = {
  deviceType: Scalars['String']['input'];
};


export type MutationSubscribeDeviceToProfileArgs = {
  deviceId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationUnlinkSessionFromUserArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationUnsubscribeDeviceFromProfileArgs = {
  deviceId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateEvalTestCaseArgs = {
  id: Scalars['ID']['input'];
  input: EvalTestCaseInput;
};

export type OpenRouterModelEntry = {
  __typename?: 'OpenRouterModelEntry';
  contextLength?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  inputPer1M?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  outputPer1M?: Maybe<Scalars['Float']['output']>;
  provider: Scalars['String']['output'];
};

export type PolicyAdjustment = {
  __typename?: 'PolicyAdjustment';
  ratingAfter: VideoRating;
  reason: Scalars['String']['output'];
  specialization: AgentSpecialization;
};

export type PoliticsFacts = {
  __typename?: 'PoliticsFacts';
  confidence?: Maybe<Scalars['Float']['output']>;
  detected: Scalars['Boolean']['output'];
  mode?: Maybe<PoliticsMode>;
  severity?: Maybe<ContentSeverity>;
  stance?: Maybe<PoliticsStance>;
};

export enum PoliticsMode {
  CivicEducation = 'CIVIC_EDUCATION',
  Inciting = 'INCITING',
  NewsReporting = 'NEWS_REPORTING',
  OpinionAdvocacy = 'OPINION_ADVOCACY',
  Partisan = 'PARTISAN'
}

export enum PoliticsPolicyMode {
  Allow = 'ALLOW',
  Block = 'BLOCK'
}

export enum PoliticsStance {
  Apolitical = 'APOLITICAL',
  Centrist = 'CENTRIST',
  Left = 'LEFT',
  Mixed = 'MIXED',
  Right = 'RIGHT'
}

export enum PreviewKind {
  Info = 'INFO',
  Minus = 'MINUS',
  Plus = 'PLUS'
}

export type PrimeEdgeTasksResult = {
  __typename?: 'PrimeEdgeTasksResult';
  minted: Scalars['Int']['output'];
  profilesPrimed: Scalars['Int']['output'];
};

export type ProcessFeedMessage = AnalysisQueueMessage & {
  __typename?: 'ProcessFeedMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  sourceTaskId: Scalars['ID']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
  videoIds: Array<Scalars['String']['output']>;
};

export type ProcessHistoryMessage = AnalysisQueueMessage & {
  __typename?: 'ProcessHistoryMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  sourceTaskId: Scalars['ID']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
  videoIds: Array<Scalars['String']['output']>;
};

export enum ProfileGender {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type ProfilePreferences = {
  __typename?: 'ProfilePreferences';
  age?: Maybe<Scalars['Int']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<ProfileGender>;
  languageList: Array<Scalars['String']['output']>;
  languagePolicyMode: LanguagePolicyMode;
  politicsPolicyMode: PoliticsPolicyMode;
  profileId: Scalars['ID']['output'];
  religionOwnFaith?: Maybe<ReligionFaith>;
  religionPolicyMode: ReligionPolicyMode;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ProfilePreferencesInput = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<ProfileGender>;
  languageList?: InputMaybe<Array<Scalars['String']['input']>>;
  languagePolicyMode?: InputMaybe<LanguagePolicyMode>;
  politicsPolicyMode?: InputMaybe<PoliticsPolicyMode>;
  religionOwnFaith?: InputMaybe<ReligionFaith>;
  religionPolicyMode?: InputMaybe<ReligionPolicyMode>;
};

export type ProfileSummary = {
  __typename?: 'ProfileSummary';
  allTimeCount: Scalars['Int']['output'];
  caughtSummary?: Maybe<HomeCaughtSummary>;
  feedScore?: Maybe<HomeScore>;
  historyScore?: Maybe<HomeScore>;
  profileId: Scalars['String']['output'];
  queueCount: Scalars['Int']['output'];
  queueEstMinutes: Scalars['Int']['output'];
  streakDays: Scalars['Int']['output'];
  todayBorderline: Scalars['Int']['output'];
  todayFlagged: Scalars['Int']['output'];
  todayMet: Scalars['Int']['output'];
  todayUnscored: Scalars['Int']['output'];
  todayWatched: Scalars['Int']['output'];
  topChannels?: Maybe<Array<HomeTopChannel>>;
  verbalWeeklyVerdict?: Maybe<Scalars['String']['output']>;
  weekCount: Scalars['Int']['output'];
  weeklyImpact?: Maybe<HomeWeeklyImpact>;
};

export type ProfileVideoVerdict = {
  __typename?: 'ProfileVideoVerdict';
  explanation: Scalars['String']['output'];
  policyAdjustments: Array<PolicyAdjustment>;
  rating: VideoRating;
  score: Scalars['Float']['output'];
};

export type ProfileWorker = {
  __typename?: 'ProfileWorker';
  appVersion?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSeenAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProgressActions = {
  __typename?: 'ProgressActions';
  applied: Scalars['Int']['output'];
  approved: Scalars['Int']['output'];
  channelsBlocked: Scalars['Int']['output'];
  channelsFollowed: Scalars['Int']['output'];
  shortsHidden: Scalars['Int']['output'];
  videosDownranked: Scalars['Int']['output'];
};

export enum ProgressRange {
  AllTime = 'ALL_TIME',
  FourWeeks = 'FOUR_WEEKS',
  TwelveWeeks = 'TWELVE_WEEKS'
}

export type ProgressTrends = {
  __typename?: 'ProgressTrends';
  actions?: Maybe<ProgressActions>;
  blocked: Array<ChannelEvolution>;
  feed: Array<Scalars['Int']['output']>;
  feedDelta: Scalars['Int']['output'];
  feedNow?: Maybe<Scalars['Int']['output']>;
  followed: Array<ChannelEvolution>;
  history: Array<Scalars['Int']['output']>;
  historyDelta: Scalars['Int']['output'];
  historyNow?: Maybe<Scalars['Int']['output']>;
  narrative: Scalars['String']['output'];
  rangeLabel: Scalars['String']['output'];
  weekLabels: Array<Scalars['String']['output']>;
};

export type Prompt = {
  __typename?: 'Prompt';
  messages: Array<ChatCompletionMessageParam>;
};

export type QualityBreakdown = {
  __typename?: 'QualityBreakdown';
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  activityFeed: Array<ActivityEvent>;
  adminInsightCandidates: AdminInsightCandidateList;
  adminReplayAccountInfo?: Maybe<AdminAccountInfoReplay>;
  claimTranscriptionWork: Array<EdgeQueueTask>;
  edgeProfileStats: EdgeProfileStats;
  edgeRecentWatches: Array<EdgeRecentWatch>;
  estimateRescoreCost: RescoreCostEstimate;
  executedActions: Array<ExecutedAction>;
  getAdminCommandCenter?: Maybe<AdminCommandCenter>;
  getAdminTasks: Array<EdgeQueueTask>;
  getAdminVideoTranscript?: Maybe<VideoTranscript>;
  getAgentAnalysisChatLog?: Maybe<AgentAnalysisChatLog>;
  getAgents: Array<Agent>;
  getAggregateScoreForAuthor?: Maybe<AuthorAggregateScore>;
  getAggregateScoreForVideo?: Maybe<AgentAggregateScore>;
  getAggregateScoreForVideos: Array<AgentAggregateScore>;
  getAllAgentScores: Array<AgentScore>;
  getAllFeedbackForVideo: Array<FeedbackLog>;
  getAllVideos: Array<Video>;
  getAllYouTubeProfiles?: Maybe<Array<Maybe<YouTubeProfile>>>;
  getAuthorAggregateScores: Array<AuthorAggregateScore>;
  getAuthors: Array<Author>;
  getBullmqJobsByIds?: Maybe<Array<Maybe<BullmqJobEntry>>>;
  getBullmqWorkers: BullmqWorkersSnapshot;
  getCachedVideos: Array<Video>;
  getChannelFeedbackQuality?: Maybe<ChannelFeedbackQuality>;
  getCorrectiveActionEvents: Array<CorrectiveActionEvent>;
  getCorrectiveActionsFor: Array<CorrectiveActionUnion>;
  getCurrentUser?: Maybe<FirebaseUser>;
  getEdgeTask?: Maybe<EdgeQueueTask>;
  getEvalReport?: Maybe<EvalReport>;
  getEvalReports: Array<EvalReport>;
  getEvalReportsForAgent: Array<EvalReport>;
  getEvalTestCases: Array<EvalTestCase>;
  getFailedTasks: Array<EdgeQueueTask>;
  getHighConfidenceBadChannels: Array<Author>;
  getHighScoreVideos: ScoredVideosResult;
  getHistoryScoresOverTime: HistoryScoresOverTime;
  getLLMCostSummary: LlmCostSummary;
  getLinkedAccounts?: Maybe<Array<LinkedAccount>>;
  getLowScoreVideos: ScoredVideosResult;
  getMyDevices: Array<Device>;
  getMyYouTubeProfiles?: Maybe<Array<YouTubeProfile>>;
  getOneYouTubeProfileFeed: Array<FeedVideo>;
  getOneYouTubeProfileHistory: YoutubeHistorySnapshot;
  getPendingCorrectiveActions: Array<CorrectiveActionUnion>;
  getPipelineEvalRun?: Maybe<AdminEvalPipelineResult>;
  getProfilePreferences?: Maybe<ProfilePreferences>;
  getProfileVideoVerdict?: Maybe<ProfileVideoVerdict>;
  getScoresByAgent: Array<AgentScore>;
  getScoresForVideo: Array<AgentScore>;
  getServiceHealth: Array<ServiceHealth>;
  getSessionCookiesForTask: Array<SessionCookie>;
  getSessionInfo?: Maybe<UserSession>;
  getTaskDebugInfo?: Maybe<TaskDebugInfo>;
  getTaskResultRaw?: Maybe<Scalars['String']['output']>;
  getTasks: Array<EdgeQueueTask>;
  getVideoLanguage?: Maybe<LanguageFacts>;
  getVideoScoringStates: Array<VideoScoringState>;
  getVideoStats: VideoStats;
  getVideosWithScores: VideosWithScores;
  getWeeklyBuckets: WeeklyBuckets;
  getWorkerFirestoreStats: Array<WorkerFirestoreStatRow>;
  getYouTubeProfiles?: Maybe<Array<Maybe<YouTubeProfile>>>;
  impactSummary: ImpactSummaryResult;
  invitePreview: InvitePreview;
  kidProfile?: Maybe<KidProfile>;
  listAgentPrompts: Array<AgentPromptEntry>;
  listBullmqJobs: Array<BullmqJobEntry>;
  listEvalAgents: Array<EvalAgentEntry>;
  listOpenRouterModels: Array<OpenRouterModelEntry>;
  myGuardianGroups: Array<GuardianGroup>;
  myVotes: Array<Vote>;
  pendingSuggestions: Array<Suggestion>;
  pollDevicePairing: DevicePairingStatus;
  previewReviewSelector: ReviewSelectorPreview;
  profileSummary: ProfileSummary;
  progressTrends: ProgressTrends;
  recentActivity: Array<ActivityRow>;
  reviewCard?: Maybe<ReviewQueueCard>;
  reviewQueue: ReviewQueueResult;
  suggestionByActionId?: Maybe<Suggestion>;
  videoAIReport?: Maybe<ReviewQueueCard>;
  videoFactorBreakdown: VideoFactorBreakdown;
  voteSummary: VoteSummary;
  waitlistEntries: Array<WaitlistEntry>;
  weeklyImpact: WeeklyImpact;
};


export type QueryActivityFeedArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['String']['input'];
};


export type QueryAdminInsightCandidatesArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryAdminReplayAccountInfoArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryClaimTranscriptionWorkArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEdgeProfileStatsArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryEdgeRecentWatchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['ID']['input'];
};


export type QueryEstimateRescoreCostArgs = {
  input?: InputMaybe<RescoreCostEstimateInput>;
};


export type QueryExecutedActionsArgs = {
  profileId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetAdminTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<TaskState>>;
  taskTypes?: InputMaybe<Array<EdgeQueueTaskType>>;
};


export type QueryGetAdminVideoTranscriptArgs = {
  videoId: Scalars['String']['input'];
};


export type QueryGetAgentAnalysisChatLogArgs = {
  cache_llm_id: Scalars['ID']['input'];
};


export type QueryGetAggregateScoreForAuthorArgs = {
  authorId: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAggregateScoreForVideoArgs = {
  childAge?: InputMaybe<Scalars['Int']['input']>;
  videoId: Scalars['String']['input'];
};


export type QueryGetAggregateScoreForVideosArgs = {
  childAge?: InputMaybe<Scalars['Int']['input']>;
  videoIds: Array<Scalars['String']['input']>;
};


export type QueryGetAllAgentScoresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllFeedbackForVideoArgs = {
  videoId: Scalars['String']['input'];
};


export type QueryGetAllVideosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAuthorAggregateScoresArgs = {
  authorIds: Array<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAuthorsArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryGetBullmqJobsByIdsArgs = {
  jobIds: Array<Scalars['ID']['input']>;
};


export type QueryGetCachedVideosArgs = {
  videoIds: Array<Scalars['String']['input']>;
};


export type QueryGetChannelFeedbackQualityArgs = {
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCorrectiveActionEventsArgs = {
  actionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCorrectiveActionsForArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<CorrectiveActionStatus>>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEdgeTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetEvalReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEvalReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEvalReportsForAgentArgs = {
  agentSpec: AgentSpecialization;
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEvalTestCasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFailedTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  taskType?: InputMaybe<EdgeQueueTaskType>;
};


export type QueryGetHighScoreVideosArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetHistoryScoresOverTimeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLlmCostSummaryArgs = {
  since: Scalars['String']['input'];
  until: Scalars['String']['input'];
};


export type QueryGetLowScoreVideosArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOneYouTubeProfileFeedArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOneYouTubeProfileHistoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPendingCorrectiveActionsArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryGetPipelineEvalRunArgs = {
  evalRunId: Scalars['ID']['input'];
};


export type QueryGetProfilePreferencesArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryGetProfileVideoVerdictArgs = {
  profileId: Scalars['ID']['input'];
  videoId: Scalars['String']['input'];
};


export type QueryGetScoresByAgentArgs = {
  agent: AgentIdInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetScoresForVideoArgs = {
  videoId: Scalars['String']['input'];
};


export type QueryGetSessionCookiesForTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetSessionInfoArgs = {
  sessionToken: Scalars['String']['input'];
};


export type QueryGetTaskDebugInfoArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryGetTaskResultRawArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryGetTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  longPoll?: InputMaybe<Scalars['Boolean']['input']>;
  profileId: Scalars['ID']['input'];
};


export type QueryGetVideoLanguageArgs = {
  videoId: Scalars['String']['input'];
};


export type QueryGetVideoScoringStatesArgs = {
  videoIds: Array<Scalars['String']['input']>;
};


export type QueryGetVideoStatsArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryGetVideosWithScoresArgs = {
  videoIds: Array<Scalars['String']['input']>;
};


export type QueryGetWeeklyBucketsArgs = {
  profileId: Scalars['ID']['input'];
};


export type QueryGetWorkerFirestoreStatsArgs = {
  sinceHours?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetYouTubeProfilesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryImpactSummaryArgs = {
  profileId: Scalars['String']['input'];
  range?: InputMaybe<ImpactRange>;
};


export type QueryInvitePreviewArgs = {
  token: Scalars['String']['input'];
};


export type QueryKidProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryListAgentPromptsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<AgentPromptKind>;
};


export type QueryListBullmqJobsArgs = {
  excludeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  includeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  queues?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<BullmqJobState>>;
};


export type QueryMyVotesArgs = {
  profileId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPendingSuggestionsArgs = {
  filter?: InputMaybe<SuggestionVerb>;
  profileId: Scalars['ID']['input'];
};


export type QueryPollDevicePairingArgs = {
  pairingId: Scalars['ID']['input'];
};


export type QueryPreviewReviewSelectorArgs = {
  input: ReviewSelectorPreviewInput;
};


export type QueryProfileSummaryArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryProgressTrendsArgs = {
  profileId: Scalars['String']['input'];
  range?: InputMaybe<ProgressRange>;
};


export type QueryRecentActivityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['String']['input'];
};


export type QueryReviewCardArgs = {
  profileId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type QueryReviewQueueArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
};


export type QuerySuggestionByActionIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVideoAiReportArgs = {
  profileId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};


export type QueryVideoFactorBreakdownArgs = {
  videoId: Scalars['String']['input'];
};


export type QueryVoteSummaryArgs = {
  profileId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryWaitlistEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWeeklyImpactArgs = {
  profileId: Scalars['ID']['input'];
};

export type RedeemInviteResult = {
  __typename?: 'RedeemInviteResult';
  customToken?: Maybe<Scalars['String']['output']>;
  linkedProfileIds: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RegisterDeviceInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ReligionFacts = {
  __typename?: 'ReligionFacts';
  confidence?: Maybe<Scalars['Float']['output']>;
  detected: Scalars['Boolean']['output'];
  faith?: Maybe<ReligionFaith>;
  mode?: Maybe<ReligionMode>;
  severity?: Maybe<ContentSeverity>;
};

export enum ReligionFaith {
  Buddhist = 'BUDDHIST',
  Christian = 'CHRISTIAN',
  Hindu = 'HINDU',
  Islamic = 'ISLAMIC',
  Jewish = 'JEWISH',
  Mixed = 'MIXED',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

export enum ReligionMode {
  Cultural = 'CULTURAL',
  Devotional = 'DEVOTIONAL',
  Educational = 'EDUCATIONAL',
  Harmful = 'HARMFUL',
  Instructional = 'INSTRUCTIONAL',
  Proselytizing = 'PROSELYTIZING'
}

export enum ReligionPolicyMode {
  AllowAll = 'ALLOW_ALL',
  AllowOwnFaith = 'ALLOW_OWN_FAITH',
  AllowOwnFaithAndEducational = 'ALLOW_OWN_FAITH_AND_EDUCATIONAL',
  BlockAll = 'BLOCK_ALL'
}

export type ReprocessTaskResult = {
  __typename?: 'ReprocessTaskResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  task?: Maybe<EdgeQueueTask>;
};

export type ReprocessTasksBatchResult = {
  __typename?: 'ReprocessTasksBatchResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tasks: Array<EdgeQueueTask>;
  tasksReprocessed: Scalars['Int']['output'];
};

export type RescoreCostBreakdownRow = {
  __typename?: 'RescoreCostBreakdownRow';
  avgCostUSD: Scalars['Float']['output'];
  callsPerVideo: Scalars['Float']['output'];
  estimatedCostUSD: Scalars['Float']['output'];
  stage: Scalars['String']['output'];
};

export type RescoreCostEstimate = {
  __typename?: 'RescoreCostEstimate';
  breakdown: Array<RescoreCostBreakdownRow>;
  channelGatedCount: Scalars['Int']['output'];
  estimatedCostUSD: Scalars['Float']['output'];
  generatedAt: Scalars['String']['output'];
  llmCallCount: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
  videoCount: Scalars['Int']['output'];
};

export type RescoreCostEstimateInput = {
  maxVideosPerChannel?: InputMaybe<Scalars['Int']['input']>;
  minExplorationPerChannel?: InputMaybe<Scalars['Int']['input']>;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
  unscoredOnly?: InputMaybe<Scalars['Boolean']['input']>;
  videoIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RescorePerAgentStat = {
  __typename?: 'RescorePerAgentStat';
  cacheHits: Scalars['Int']['output'];
  costUSD: Scalars['Float']['output'];
  errors: Scalars['Int']['output'];
  scored: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  specialization: AgentSpecialization;
  tokens: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type RescoreVideosInput = {
  agents?: InputMaybe<Array<AgentIdInput>>;
  bottomBias?: InputMaybe<Scalars['Float']['input']>;
  maxVideosPerChannel?: InputMaybe<Scalars['Int']['input']>;
  minExplorationPerChannel?: InputMaybe<Scalars['Int']['input']>;
  resetFirst?: InputMaybe<Scalars['Boolean']['input']>;
  sampleSize: Scalars['Int']['input'];
  selectorPoolSize?: InputMaybe<Scalars['Int']['input']>;
  skipExisting?: InputMaybe<Scalars['Boolean']['input']>;
  topBias?: InputMaybe<Scalars['Float']['input']>;
  unscoredOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useReviewSelector?: InputMaybe<Scalars['Boolean']['input']>;
  videoIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RescoreVideosResult = {
  __typename?: 'RescoreVideosResult';
  cacheHits: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  perAgent: Array<RescorePerAgentStat>;
  scoresCreated: Scalars['Int']['output'];
  scoresSkipped: Scalars['Int']['output'];
  totalCostUSD: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
  videosConsidered: Scalars['Int']['output'];
  videosProcessed: Scalars['Int']['output'];
};

export type ResetEdgeTaskResult = {
  __typename?: 'ResetEdgeTaskResult';
  reset: Scalars['Boolean']['output'];
};

export type ResetEdgeTasksResult = {
  __typename?: 'ResetEdgeTasksResult';
  reset: Scalars['Int']['output'];
};

export type RetractResult = {
  __typename?: 'RetractResult';
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  partial?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RetryAllFailedExtractionsResult = {
  __typename?: 'RetryAllFailedExtractionsResult';
  enqueueFailures: Scalars['Int']['output'];
  enqueued: Scalars['Int']['output'];
  jobIds: Array<Scalars['String']['output']>;
  perTypeCounts: Array<RetryPerTypeCount>;
  scanned: Scalars['Int']['output'];
};

export type RetryFailedExtractionsResult = {
  __typename?: 'RetryFailedExtractionsResult';
  enqueued: Scalars['Int']['output'];
  jobIds: Array<Scalars['String']['output']>;
};

export type RetryPerTypeCount = {
  __typename?: 'RetryPerTypeCount';
  enqueueFailures: Scalars['Int']['output'];
  enqueued: Scalars['Int']['output'];
  scanned: Scalars['Int']['output'];
  taskType: EdgeQueueTaskType;
};

export type ReviewQueueCard = {
  __typename?: 'ReviewQueueCard';
  actionId?: Maybe<Scalars['String']['output']>;
  actionTitle?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['String']['output']>;
  aiExplanation?: Maybe<Scalars['String']['output']>;
  aiRating?: Maybe<Scalars['String']['output']>;
  aiReport?: Maybe<Scalars['String']['output']>;
  aiScore?: Maybe<Scalars['Float']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  durationLabel?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['String']['output']>;
  factors: Array<ReviewQueueFactor>;
  id: Scalars['ID']['output'];
  imageKind?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  recommendedAt?: Maybe<Scalars['String']['output']>;
  scoredAt?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  skipUntil?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tokenStatus?: Maybe<Scalars['String']['output']>;
  verdictSummary?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
  votedAt?: Maybe<Scalars['Float']['output']>;
  watchedAt?: Maybe<Scalars['String']['output']>;
  worthNoting: Array<Scalars['String']['output']>;
};

export type ReviewQueueFactor = {
  __typename?: 'ReviewQueueFactor';
  detail?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  note: Scalars['String']['output'];
  tone: Scalars['String']['output'];
  valueLabel: Scalars['String']['output'];
};

export type ReviewQueueResult = {
  __typename?: 'ReviewQueueResult';
  cards: Array<ReviewQueueCard>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum ReviewSelectorBucket {
  Bottom = 'BOTTOM',
  Mid = 'MID',
  Top = 'TOP'
}

export type ReviewSelectorClassification = {
  __typename?: 'ReviewSelectorClassification';
  bucket: ReviewSelectorBucket;
  channelName: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type ReviewSelectorPreview = {
  __typename?: 'ReviewSelectorPreview';
  bottomCount: Scalars['Int']['output'];
  classifications: Array<ReviewSelectorClassification>;
  durationMs: Scalars['Int']['output'];
  estimatedCostUSD?: Maybe<Scalars['Float']['output']>;
  midCount: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  poolSize: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
  selectedIds: Array<Scalars['String']['output']>;
  tokenUsage: TokenUsageInfo;
  topCount: Scalars['Int']['output'];
};

export type ReviewSelectorPreviewInput = {
  bottomBias?: InputMaybe<Scalars['Float']['input']>;
  poolSize?: InputMaybe<Scalars['Int']['input']>;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
  topBias?: InputMaybe<Scalars['Float']['input']>;
  videoIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RunEvalInput = {
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['input'];
  modelName?: InputMaybe<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  sampleLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type RunMultiModelEvalInput = {
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['input'];
  modelNames: Array<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  sampleLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveAgentPromptInput = {
  body: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  kind: AgentPromptKind;
  origin?: InputMaybe<Scalars['String']['input']>;
  parentVersion?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ScoreBase = {
  agent: AgentId;
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: ScoreKind;
  rating: VideoRating;
  score: Scalars['Float']['output'];
  scoreDirection: ScoreDirection;
  type: AgentType;
  videoId: Scalars['String']['output'];
};

export enum ScoreConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export enum ScoreDirection {
  HigherIsBetter = 'HIGHER_IS_BETTER',
  LowerIsBetter = 'LOWER_IS_BETTER'
}

export type ScoreDistribution = {
  __typename?: 'ScoreDistribution';
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  veryHigh: Scalars['Int']['output'];
  veryLow: Scalars['Int']['output'];
};

export enum ScoreKind {
  Agent = 'AGENT',
  UserFeedback = 'USER_FEEDBACK'
}

export type ScoreVideoResult = {
  __typename?: 'ScoreVideoResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ScoredVideosResult = {
  __typename?: 'ScoredVideosResult';
  scores: Array<AgentAggregateScore>;
  videos: Array<Video>;
};

export type ScoringAnalyzeVideoMessage = AnalysisQueueMessage & {
  __typename?: 'ScoringAnalyzeVideoMessage';
  createdAt: Scalars['String']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['String']['output'];
};

export type ScoringEvalAgentCellMessage = AnalysisQueueMessage & {
  __typename?: 'ScoringEvalAgentCellMessage';
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  sampleLimit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoringEvalAgentFanoutMessage = AnalysisQueueMessage & {
  __typename?: 'ScoringEvalAgentFanoutMessage';
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  modelNames: Array<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  sampleLimit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoringEvalPipelineMessage = AnalysisQueueMessage & {
  __typename?: 'ScoringEvalPipelineMessage';
  childAge?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  detectorModel?: Maybe<Scalars['String']['output']>;
  evalRunId: Scalars['ID']['output'];
  finalizeModel?: Maybe<Scalars['String']['output']>;
  specialistModel?: Maybe<Scalars['String']['output']>;
  triageModel?: Maybe<Scalars['String']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['String']['output'];
};

export type ScoringEvolvePromptMessage = AnalysisQueueMessage & {
  __typename?: 'ScoringEvolvePromptMessage';
  agentSpec: AgentSpecialization;
  agentVersion: Scalars['String']['output'];
  autoEvalAfter?: Maybe<Scalars['Boolean']['output']>;
  autoEvalModel?: Maybe<Scalars['String']['output']>;
  basePromptVersion: Scalars['String']['output'];
  coachModel: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  sampleLimit?: Maybe<Scalars['Int']['output']>;
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ScoringRescoreLibraryMessage = AnalysisQueueMessage & {
  __typename?: 'ScoringRescoreLibraryMessage';
  agentSelectionJson?: Maybe<Scalars['String']['output']>;
  bottomBias?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  maxVideosPerChannel?: Maybe<Scalars['Int']['output']>;
  minExplorationPerChannel?: Maybe<Scalars['Int']['output']>;
  resetFirst?: Maybe<Scalars['Boolean']['output']>;
  sampleSize: Scalars['Int']['output'];
  selectorPoolSize?: Maybe<Scalars['Int']['output']>;
  skipExisting: Scalars['Boolean']['output'];
  topBias?: Maybe<Scalars['Float']['output']>;
  type: AnalysisQueueMessageType;
  unscoredOnly?: Maybe<Scalars['Boolean']['output']>;
  useReviewSelector?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  videoIdsJson?: Maybe<Scalars['String']['output']>;
};

export enum ScoringSource {
  Feed = 'FEED',
  History = 'HISTORY'
}

export type SeedTestCasesResult = {
  __typename?: 'SeedTestCasesResult';
  created: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  testCaseIds: Array<Scalars['ID']['output']>;
};

export type ServiceHealth = {
  __typename?: 'ServiceHealth';
  bootedAt: Scalars['String']['output'];
  branch: Scalars['String']['output'];
  builtAt: Scalars['String']['output'];
  commitDate: Scalars['String']['output'];
  dirty: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  lastSeenAt: Scalars['String']['output'];
  sha: Scalars['String']['output'];
  shortSha: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type SessionCookie = {
  __typename?: 'SessionCookie';
  domain?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SessionLinkResult = {
  __typename?: 'SessionLinkResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<FirebaseUser>;
};

export enum SpecialistSelectionReason {
  Always = 'ALWAYS',
  CategoryTag = 'CATEGORY_TAG',
  ChannelGate = 'CHANNEL_GATE',
  Final = 'FINAL',
  Legacy = 'LEGACY',
  RiskFlag = 'RISK_FLAG',
  Triage = 'TRIAGE'
}

export type SpecializedScore = {
  specialization?: Maybe<AgentSpecialization>;
};

export type Suggestion = {
  __typename?: 'Suggestion';
  actionHelpers: ActionHelpers;
  bullets: Array<Scalars['String']['output']>;
  createdAt: Scalars['Float']['output'];
  evaluatedAt?: Maybe<Scalars['Float']['output']>;
  evidence: Evidence;
  eyebrow?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  profileId: Scalars['ID']['output'];
  snoozedUntil?: Maybe<Scalars['Float']['output']>;
  state: SuggestionState;
  target: SuggestionTarget;
  verb: SuggestionVerb;
  videoCount: Scalars['Int']['output'];
};

export enum SuggestionState {
  Applied = 'APPLIED',
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Snoozed = 'SNOOZED'
}

export type SuggestionTarget = Author | Video;

export enum SuggestionVerb {
  Block = 'BLOCK',
  Boost = 'BOOST',
  Follow = 'FOLLOW',
  Skip = 'SKIP'
}

export enum SummarizationNeed {
  Detailed = 'DETAILED',
  MetadataOnly = 'METADATA_ONLY',
  RawTranscript = 'RAW_TRANSCRIPT',
  Unified = 'UNIFIED'
}

export type TaskDebugInfo = {
  __typename?: 'TaskDebugInfo';
  parseErrors?: Maybe<Array<TaskParseError>>;
  rawDataJson?: Maybe<Scalars['String']['output']>;
  task: EdgeQueueTask;
};

export enum TaskFailureReason {
  CookieExpired = 'COOKIE_EXPIRED',
  Network = 'NETWORK',
  ParserDrift = 'PARSER_DRIFT',
  ParserRejected = 'PARSER_REJECTED',
  SignedOut = 'SIGNED_OUT',
  Unknown = 'UNKNOWN',
  WorkerError = 'WORKER_ERROR',
  YoutubeInvalidResponse = 'YOUTUBE_INVALID_RESPONSE',
  YoutubeRateLimit = 'YOUTUBE_RATE_LIMIT'
}

export enum TaskFailureStage {
  Enqueue = 'ENQUEUE',
  Extract = 'EXTRACT',
  Fetch = 'FETCH',
  Timeout = 'TIMEOUT'
}

export type TaskFirestoreCount = {
  __typename?: 'TaskFirestoreCount';
  byCollection: Array<CollectionFirestoreCount>;
  deletes: Scalars['Int']['output'];
  jobCount: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  taskType: Scalars['String']['output'];
  totalDurationMs: Scalars['Int']['output'];
  writes: Scalars['Int']['output'];
};

export type TaskFirestoreCounters = {
  __typename?: 'TaskFirestoreCounters';
  deletes: Scalars['Int']['output'];
  jobCount: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  totalDurationMs: Scalars['Int']['output'];
  writes: Scalars['Int']['output'];
};

export type TaskParseError = {
  __typename?: 'TaskParseError';
  context?: Maybe<Scalars['JSON']['output']>;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TaskResult = {
  __typename?: 'TaskResult';
  data?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  parseErrors?: Maybe<Array<TaskParseError>>;
  sha?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status: TaskResultStatus;
  storagePath?: Maybe<Scalars['String']['output']>;
  undoToken?: Maybe<Scalars['String']['output']>;
};

export type TaskResultInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  executedBy?: InputMaybe<Scalars['String']['input']>;
  handledVia?: InputMaybe<Scalars['String']['input']>;
  status: TaskResultStatus;
  undoToken?: InputMaybe<Scalars['String']['input']>;
};

export enum TaskResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum TaskState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  Fetching = 'FETCHING',
  Queued = 'QUEUED'
}

export enum ThresholdDirection {
  Above = 'ABOVE',
  Below = 'BELOW'
}

export type Thumbnail = {
  __typename?: 'Thumbnail';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum TokenStatus {
  Awaiting = 'AWAITING',
  Present = 'PRESENT'
}

export type TokenUsageInfo = {
  __typename?: 'TokenUsageInfo';
  input: Scalars['Int']['output'];
  output: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TotalFeedStats = {
  __typename?: 'TotalFeedStats';
  overallAverageScore: Scalars['Float']['output'];
  scoreDistribution: ScoreDistribution;
  scoreOverTime: Array<DailyScore>;
  totalVideosProcessed: Scalars['Int']['output'];
  totalVideosScoredCount: Scalars['Int']['output'];
};

export type TotalHistoryStats = {
  __typename?: 'TotalHistoryStats';
  averageDurationPerVideo: Scalars['Float']['output'];
  overallAverageScore: Scalars['Float']['output'];
  scoreDistribution: ScoreDistribution;
  scoreOverTime: Array<DailyScore>;
  totalDurationWatched: Scalars['Int']['output'];
  totalVideosProcessed: Scalars['Int']['output'];
  totalVideosScoredCount: Scalars['Int']['output'];
};

export type TotalObjectionableStats = {
  __typename?: 'TotalObjectionableStats';
  objectionableRecommendedPercentage: Scalars['Float']['output'];
  objectionableWatchPercentage: Scalars['Float']['output'];
  totalObjectionableVideosRecommended: Scalars['Int']['output'];
  totalObjectionableVideosWatched: Scalars['Int']['output'];
};

export type TotalSessionStats = {
  __typename?: 'TotalSessionStats';
  feedStats: TotalFeedStats;
  historyStats: TotalHistoryStats;
  objectionableStats: TotalObjectionableStats;
};

export type TriageOutput = {
  __typename?: 'TriageOutput';
  categoryTags: Array<AgentCategoryTag>;
  confidence: Scalars['Float']['output'];
  riskFlags: Array<AgentRiskFlag>;
  shortCircuitReason?: Maybe<Scalars['String']['output']>;
  shortCircuited: Scalars['Boolean']['output'];
  verdict: TriageVerdict;
};

export enum TriageVerdict {
  Beneficial = 'BENEFICIAL',
  Harmful = 'HARMFUL',
  Inconclusive = 'INCONCLUSIVE',
  Neutral = 'NEUTRAL'
}

export type TriageVideosMessage = AnalysisQueueMessage & {
  __typename?: 'TriageVideosMessage';
  createdAt: Scalars['String']['output'];
  profileId: Scalars['String']['output'];
  source: ScoringSource;
  sourceTaskId: Scalars['ID']['output'];
  type: AnalysisQueueMessageType;
  userId?: Maybe<Scalars['String']['output']>;
  videoIds: Array<Scalars['String']['output']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  accountInfo: AccountInfo;
  expiresAt: Scalars['Float']['output'];
  profileId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
};

export type Video = {
  __typename?: 'Video';
  author: Author;
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  feedback?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  is_live?: Maybe<Scalars['Boolean']['output']>;
  is_watched?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['String']['output']>;
  snapshot_date: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  thumbnails: Array<Thumbnail>;
  title: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['Int']['output']>;
  watch_date?: Maybe<Scalars['String']['output']>;
};

export type VideoCorrectiveAction = CorrectiveAction & {
  __typename?: 'VideoCorrectiveAction';
  algorithmVersion?: Maybe<CorrectiveActionAlgorithmVersion>;
  appliedAt?: Maybe<Scalars['Float']['output']>;
  autoApplyEligible: Scalars['Boolean']['output'];
  confidence?: Maybe<ScoreConfidence>;
  confidenceReason?: Maybe<ConfidenceReason>;
  createdAt: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['Float']['output']>;
  events?: Maybe<Array<CorrectiveActionEvent>>;
  evidenceFingerprint?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Float']['output']>;
  feedbackTokens?: Maybe<FeedbackTokens>;
  id: Scalars['ID']['output'];
  kind: CorrectiveActionKind;
  profileId: Scalars['String']['output'];
  severity?: Maybe<CorrectiveActionSeverity>;
  skipUntil?: Maybe<Scalars['Float']['output']>;
  sourceVideoIds?: Maybe<Array<Scalars['String']['output']>>;
  status: CorrectiveActionStatus;
  takenAt?: Maybe<Scalars['Float']['output']>;
  takenBy?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tokenStatus: TokenStatus;
  trigger: CorrectiveActionTrigger;
  type: CorrectiveActionType;
  video?: Maybe<Video>;
  videoScore?: Maybe<Scalars['Float']['output']>;
};

export type VideoFactorBreakdown = {
  __typename?: 'VideoFactorBreakdown';
  factors: Array<ReviewQueueFactor>;
  transcriptBacked: Scalars['Boolean']['output'];
  videoId: Scalars['String']['output'];
  worthNoting: Array<Scalars['String']['output']>;
};

export type VideoLanguage = {
  __typename?: 'VideoLanguage';
  code: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  secondary?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export enum VideoRating {
  Beneficial = 'BENEFICIAL',
  Harmful = 'HARMFUL',
  Neutral = 'NEUTRAL'
}

export type VideoScoringState = {
  __typename?: 'VideoScoringState';
  hasAgentScore: Scalars['Boolean']['output'];
  hasFeedback: Scalars['Boolean']['output'];
  inheritedFromChannel: Scalars['Boolean']['output'];
  videoId: Scalars['String']['output'];
};

export type VideoStats = {
  __typename?: 'VideoStats';
  correctiveActions: CorrectiveActionStats;
  recommendedQuality: QualityBreakdown;
  totalFeedScoredVideos: Scalars['Int']['output'];
  totalHistoryScoredVideos: Scalars['Int']['output'];
  totalVideosScored: Scalars['Int']['output'];
  totalVideosWatched: Scalars['Int']['output'];
  watchedQuality: QualityBreakdown;
};

export type VideoTranscript = {
  __typename?: 'VideoTranscript';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<VideoLanguage>;
  transcript?: Maybe<Scalars['String']['output']>;
};

export type VideosWithScores = {
  __typename?: 'VideosWithScores';
  scores: Array<AgentScore>;
  videos: Array<Video>;
};

export type Vote = {
  __typename?: 'Vote';
  createdAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  profileId: Scalars['ID']['output'];
  rationale?: Maybe<Scalars['String']['output']>;
  source?: Maybe<VoteSource>;
  suggestionId?: Maybe<Scalars['ID']['output']>;
  target: SuggestionTarget;
  verb: SuggestionVerb;
};

export enum VoteSource {
  ReviewQueue = 'REVIEW_QUEUE',
  SelfInitiated = 'SELF_INITIATED',
  SkipMarker = 'SKIP_MARKER',
  SuggestionSnoozed = 'SUGGESTION_SNOOZED',
  SuggestionTaken = 'SUGGESTION_TAKEN'
}

export type VoteSummary = {
  __typename?: 'VoteSummary';
  agreed: Scalars['Int']['output'];
  blockCount: Scalars['Int']['output'];
  boostCount: Scalars['Int']['output'];
  disagreed: Scalars['Int']['output'];
  followCount: Scalars['Int']['output'];
  since: Scalars['Float']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WaitlistEntry = {
  __typename?: 'WaitlistEntry';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  source: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
};

export type WeeklyBuckets = {
  __typename?: 'WeeklyBuckets';
  borderline: Scalars['Int']['output'];
  flagged: Scalars['Int']['output'];
  greatFit: Scalars['Int']['output'];
  watched: Scalars['Int']['output'];
  windowDays: Scalars['Int']['output'];
};

export type WeeklyImpact = {
  __typename?: 'WeeklyImpact';
  candidatesQueued: Scalars['Int']['output'];
  videosRemoved: Scalars['Int']['output'];
  videosSurfaced: Scalars['Int']['output'];
};

export type WeeklyScore = {
  __typename?: 'WeeklyScore';
  score: Scalars['Float']['output'];
  weekStart: Scalars['String']['output'];
};

export type WelcomeState = {
  __typename?: 'WelcomeState';
  completedAt?: Maybe<Scalars['Float']['output']>;
  desktopInstalled: Scalars['Boolean']['output'];
  googleAccountSetUp: Scalars['Boolean']['output'];
  kidSignedIn: Scalars['Boolean']['output'];
  principlesAcknowledged: Scalars['Boolean']['output'];
  skippedAt?: Maybe<Scalars['Float']['output']>;
};

export enum WelcomeStep {
  DesktopInstalled = 'DESKTOP_INSTALLED',
  GoogleAccount = 'GOOGLE_ACCOUNT',
  KidSignedIn = 'KID_SIGNED_IN',
  Principles = 'PRINCIPLES'
}

export type WorkerFirestoreStatRow = {
  __typename?: 'WorkerFirestoreStatRow';
  byCollection: Array<CollectionFirestoreCount>;
  firstSeenAt: Scalars['String']['output'];
  hourBucket: Scalars['String']['output'];
  lastSeenAt: Scalars['String']['output'];
  taskCounts: Array<TaskFirestoreCount>;
  totals: TaskFirestoreCounters;
  worker: WorkerInfoLite;
  workerId: Scalars['String']['output'];
};

export type WorkerInfoLite = {
  __typename?: 'WorkerInfoLite';
  bootedAt: Scalars['String']['output'];
  branch: Scalars['String']['output'];
  serviceKey?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
  shortSha: Scalars['String']['output'];
  workerId: Scalars['String']['output'];
};

export type YtCredentials = {
  __typename?: 'YTCredentials';
  cookies?: Maybe<Array<Maybe<Cookie>>>;
  expiry_date: Scalars['Int']['output'];
};

export type YouTubeProfile = {
  __typename?: 'YouTubeProfile';
  activeWorkers: Array<ProfileWorker>;
  channel_handle?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<YtCredentials>;
  desktopLastSeenAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  has_channel?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastTaskAt?: Maybe<Scalars['String']['output']>;
  lastTaskType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  preferences?: Maybe<ProfilePreferences>;
  thumbnails?: Maybe<Array<Maybe<Thumbnail>>>;
  youtubeSessionInvalidReason?: Maybe<Scalars['String']['output']>;
  youtubeSessionLastCheckedAt?: Maybe<Scalars['String']['output']>;
  youtubeSessionValid?: Maybe<Scalars['Boolean']['output']>;
  youtubeSignedOut?: Maybe<Scalars['Boolean']['output']>;
  youtubeSignedOutAt?: Maybe<Scalars['String']['output']>;
  youtubeSignedOutReason?: Maybe<Scalars['String']['output']>;
};

export type YoutubeFeedSnapshot = {
  __typename?: 'YoutubeFeedSnapshot';
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  profileId: Scalars['String']['output'];
  task_id?: Maybe<Scalars['String']['output']>;
  videos: Array<Video>;
};

export type YoutubeHistorySnapshot = {
  __typename?: 'YoutubeHistorySnapshot';
  profileId: Scalars['String']['output'];
  task_id?: Maybe<Scalars['String']['output']>;
  videos: Array<HistoryVideo>;
};

export type YoutubeRelatedSnapshot = {
  __typename?: 'YoutubeRelatedSnapshot';
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  profileId: Scalars['String']['output'];
  sourceVideoId: Scalars['String']['output'];
  task_id: Scalars['String']['output'];
  videos: Array<Video>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  AnalysisQueue:
    | ( AggregateChannelMessage )
    | ( AggregateProfileChannelFeedbackMessage )
    | ( BindFeedbackTokensMessage )
    | ( ControlHeartbeatSessionsMessage )
    | ( ControlSendInsightNotificationsMessage )
    | ( ControlSweepChannelMarksMessage )
    | ( ControlSweepChannelRescoresMessage )
    | ( ControlSweepEvaluateChannelMarksMessage )
    | ( ControlSweepEvaluateVideoMarksMessage )
    | ( ControlSweepProfileChannelOverlayMarksMessage )
    | ( ControlSweepProfileMarksMessage )
    | ( ControlSweepReevaluateAllMessage )
    | ( ControlSweepRetryStuckActionsMessage )
    | ( ControlSweepReviewInboxMessage )
    | ( ControlSweepStaleAlgorithmVersionMessage )
    | ( ControlSweepSubscriptionsMessage )
    | ( EvaluateChannelActionsMessage )
    | ( EvaluateProfileActionsMessage )
    | ( EvaluateVideoActionsMessage )
    | ( FetchTranscriptMessage )
    | ( IngestAckFeedMessage )
    | ( IngestAckGenericMessage )
    | ( IngestAckHistoryMessage )
    | ( IngestAckRelatedMessage )
    | ( IngestAckTranscriptMessage )
    | ( IngestReparseMessage )
    | ( ProcessFeedMessage )
    | ( ProcessHistoryMessage )
    | ( ScoringAnalyzeVideoMessage )
    | ( ScoringEvalAgentCellMessage )
    | ( ScoringEvalAgentFanoutMessage )
    | ( ScoringEvalPipelineMessage )
    | ( ScoringEvolvePromptMessage )
    | ( ScoringRescoreLibraryMessage )
    | ( TriageVideosMessage )
  ;
  ChatCompletionMessageParam:
    | ( ChatCompletionAssistantMessageParam )
    | ( ChatCompletionDeveloperMessageParam )
    | ( ChatCompletionFunctionMessageParam )
    | ( ChatCompletionSystemMessageParam )
    | ( ChatCompletionToolMessageParam )
    | ( ChatCompletionUserMessageParam )
  ;
  CorrectiveActionUnion:
    | ( ChannelCorrectiveAction )
    | ( FeedCorrectiveAction )
    | ( VideoCorrectiveAction )
  ;
  SuggestionTarget:
    | ( Author )
    | ( Video )
  ;
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  AnalysisQueueMessage:
    | ( AggregateChannelMessage )
    | ( AggregateProfileChannelFeedbackMessage )
    | ( BindFeedbackTokensMessage )
    | ( ControlHeartbeatSessionsMessage )
    | ( ControlSendInsightNotificationsMessage )
    | ( ControlSweepChannelMarksMessage )
    | ( ControlSweepChannelRescoresMessage )
    | ( ControlSweepEvaluateChannelMarksMessage )
    | ( ControlSweepEvaluateVideoMarksMessage )
    | ( ControlSweepProfileChannelOverlayMarksMessage )
    | ( ControlSweepProfileMarksMessage )
    | ( ControlSweepReevaluateAllMessage )
    | ( ControlSweepRetryStuckActionsMessage )
    | ( ControlSweepReviewInboxMessage )
    | ( ControlSweepStaleAlgorithmVersionMessage )
    | ( ControlSweepSubscriptionsMessage )
    | ( EvaluateChannelActionsMessage )
    | ( EvaluateProfileActionsMessage )
    | ( EvaluateVideoActionsMessage )
    | ( FetchTranscriptMessage )
    | ( IngestAckFeedMessage )
    | ( IngestAckGenericMessage )
    | ( IngestAckHistoryMessage )
    | ( IngestAckRelatedMessage )
    | ( IngestAckTranscriptMessage )
    | ( IngestReparseMessage )
    | ( ProcessFeedMessage )
    | ( ProcessHistoryMessage )
    | ( ScoringAnalyzeVideoMessage )
    | ( ScoringEvalAgentCellMessage )
    | ( ScoringEvalAgentFanoutMessage )
    | ( ScoringEvalPipelineMessage )
    | ( ScoringEvolvePromptMessage )
    | ( ScoringRescoreLibraryMessage )
    | ( TriageVideosMessage )
  ;
  CorrectiveAction:
    | ( ChannelCorrectiveAction )
    | ( FeedCorrectiveAction )
    | ( VideoCorrectiveAction )
  ;
  ScoreBase:
    | ( AgentScore )
    | ( FeedbackLog )
  ;
  SpecializedScore: never;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AIAnalysis: ResolverTypeWrapper<Omit<AiAnalysis, 'prompt'> & { prompt?: Maybe<ResolversTypes['Prompt']> }>;
  AccountInfo: ResolverTypeWrapper<AccountInfo>;
  ActionHelpers: ResolverTypeWrapper<ActionHelpers>;
  ActionMetrics: ResolverTypeWrapper<ActionMetrics>;
  ActivityEvent: ResolverTypeWrapper<ActivityEvent>;
  ActivityRow: ResolverTypeWrapper<ActivityRow>;
  AdminAccountInfoReplay: ResolverTypeWrapper<AdminAccountInfoReplay>;
  AdminCcDevice: ResolverTypeWrapper<AdminCcDevice>;
  AdminCcOwner: ResolverTypeWrapper<AdminCcOwner>;
  AdminCcProfile: ResolverTypeWrapper<AdminCcProfile>;
  AdminCcProfileDevice: ResolverTypeWrapper<AdminCcProfileDevice>;
  AdminCcProfileStatus: ResolverTypeWrapper<AdminCcProfileStatus>;
  AdminCcSession: ResolverTypeWrapper<AdminCcSession>;
  AdminCcSessionState: AdminCcSessionState;
  AdminCcTotals: ResolverTypeWrapper<AdminCcTotals>;
  AdminCommandCenter: ResolverTypeWrapper<AdminCommandCenter>;
  AdminDeleteSessionResult: ResolverTypeWrapper<AdminDeleteSessionResult>;
  AdminEnqueuePipelineEvalResult: ResolverTypeWrapper<AdminEnqueuePipelineEvalResult>;
  AdminEvalFailedSpecialist: ResolverTypeWrapper<AdminEvalFailedSpecialist>;
  AdminEvalFinalizeResult: ResolverTypeWrapper<AdminEvalFinalizeResult>;
  AdminEvalPipelineInput: AdminEvalPipelineInput;
  AdminEvalPipelineProgress: ResolverTypeWrapper<AdminEvalPipelineProgress>;
  AdminEvalPipelineResult: ResolverTypeWrapper<AdminEvalPipelineResult>;
  AdminEvalRunStatus: AdminEvalRunStatus;
  AdminEvalSkippedSpecialist: ResolverTypeWrapper<AdminEvalSkippedSpecialist>;
  AdminEvalSpecialistResult: ResolverTypeWrapper<AdminEvalSpecialistResult>;
  AdminEvalTriageResult: ResolverTypeWrapper<AdminEvalTriageResult>;
  AdminInsightCandidate: ResolverTypeWrapper<AdminInsightCandidate>;
  AdminInsightCandidateList: ResolverTypeWrapper<AdminInsightCandidateList>;
  AdminInsightTestResult: ResolverTypeWrapper<AdminInsightTestResult>;
  AdminPurgeProfileResult: ResolverTypeWrapper<AdminPurgeProfileResult>;
  AdminRecomputeCorrectiveActionsResult: ResolverTypeWrapper<AdminRecomputeCorrectiveActionsResult>;
  AdminRerunScoringPipelineResult: ResolverTypeWrapper<AdminRerunScoringPipelineResult>;
  AdminResetAllVideoScoresResult: ResolverTypeWrapper<AdminResetAllVideoScoresResult>;
  AdminResetAllVideoSummariesResult: ResolverTypeWrapper<AdminResetAllVideoSummariesResult>;
  AdminResetVideoScoresResult: ResolverTypeWrapper<AdminResetVideoScoresResult>;
  AdminResetVideoSummaryResult: ResolverTypeWrapper<AdminResetVideoSummaryResult>;
  AdminScoringTestResult: ResolverTypeWrapper<Omit<AdminScoringTestResult, 'request'> & { request: ResolversTypes['LLMRequest'] }>;
  AdminSeedPromptsResult: ResolverTypeWrapper<AdminSeedPromptsResult>;
  AdminSeededPrompt: ResolverTypeWrapper<AdminSeededPrompt>;
  AdminSweepProfileSessionsResult: ResolverTypeWrapper<AdminSweepProfileSessionsResult>;
  AgeBand: AgeBand;
  AgeBandVerdict: ResolverTypeWrapper<AgeBandVerdict>;
  Agent: ResolverTypeWrapper<Agent>;
  AgentAggregateScore: ResolverTypeWrapper<AgentAggregateScore>;
  AgentAnalysisChatLog: ResolverTypeWrapper<Omit<AgentAnalysisChatLog, 'request'> & { request: ResolversTypes['LLMRequest'] }>;
  AgentCategoryTag: AgentCategoryTag;
  AgentId: ResolverTypeWrapper<AgentId>;
  AgentIdInput: AgentIdInput;
  AgentParameterOverrides: AgentParameterOverrides;
  AgentPromptEntry: ResolverTypeWrapper<AgentPromptEntry>;
  AgentPromptKind: AgentPromptKind;
  AgentRiskFlag: AgentRiskFlag;
  AgentScore: ResolverTypeWrapper<AgentScore>;
  AgentSpecialization: AgentSpecialization;
  AgentTriggers: ResolverTypeWrapper<AgentTriggers>;
  AgentType: AgentType;
  AggregateChannelMessage: ResolverTypeWrapper<AggregateChannelMessage>;
  AggregateProfileChannelFeedbackMessage: ResolverTypeWrapper<AggregateProfileChannelFeedbackMessage>;
  AgreementType: AgreementType;
  AnalysisFailureReason: AnalysisFailureReason;
  AnalysisQueue: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AnalysisQueue']>;
  AnalysisQueueMessage: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AnalysisQueueMessage']>;
  AnalysisQueueMessageType: AnalysisQueueMessageType;
  AnalysisState: AnalysisState;
  AnalysisVersion: AnalysisVersion;
  ApplyCorrectiveActionInput: ApplyCorrectiveActionInput;
  ApplyCorrectiveActionResult: ResolverTypeWrapper<Omit<ApplyCorrectiveActionResult, 'action'> & { action?: Maybe<ResolversTypes['CorrectiveActionUnion']> }>;
  ApplySuggestionResult: ResolverTypeWrapper<Omit<ApplySuggestionResult, 'executedAction' | 'suggestion'> & { executedAction?: Maybe<ResolversTypes['ExecutedAction']>, suggestion: ResolversTypes['Suggestion'] }>;
  Author: ResolverTypeWrapper<Author>;
  AuthorAggregateScore: ResolverTypeWrapper<AuthorAggregateScore>;
  AuthorVideoScore: ResolverTypeWrapper<AuthorVideoScore>;
  BindFeedbackTokensMessage: ResolverTypeWrapper<BindFeedbackTokensMessage>;
  BlobMigrationCollection: BlobMigrationCollection;
  BlobMigrationResult: ResolverTypeWrapper<BlobMigrationResult>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BullmqJobEntry: ResolverTypeWrapper<BullmqJobEntry>;
  BullmqJobState: BullmqJobState;
  BullmqQueueConcurrency: ResolverTypeWrapper<BullmqQueueConcurrency>;
  BullmqWorker: ResolverTypeWrapper<BullmqWorker>;
  BullmqWorkersSnapshot: ResolverTypeWrapper<BullmqWorkersSnapshot>;
  ChannelCorrectiveAction: ResolverTypeWrapper<ChannelCorrectiveAction>;
  ChannelEvolution: ResolverTypeWrapper<ChannelEvolution>;
  ChannelFeedbackQuality: ResolverTypeWrapper<ChannelFeedbackQuality>;
  ChannelFeedbackRow: ResolverTypeWrapper<ChannelFeedbackRow>;
  ChatCompletionAssistantMessageParam: ResolverTypeWrapper<ChatCompletionAssistantMessageParam>;
  ChatCompletionChoice: ResolverTypeWrapper<ChatCompletionChoice>;
  ChatCompletionCreateParamsBase: ResolverTypeWrapper<Omit<ChatCompletionCreateParamsBase, 'messages'> & { messages: Array<ResolversTypes['ChatCompletionMessageParam']> }>;
  ChatCompletionDeveloperMessageParam: ResolverTypeWrapper<ChatCompletionDeveloperMessageParam>;
  ChatCompletionFunctionMessageParam: ResolverTypeWrapper<ChatCompletionFunctionMessageParam>;
  ChatCompletionMessage: ResolverTypeWrapper<ChatCompletionMessage>;
  ChatCompletionMessageParam: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ChatCompletionMessageParam']>;
  ChatCompletionResponse: ResolverTypeWrapper<ChatCompletionResponse>;
  ChatCompletionSystemMessageParam: ResolverTypeWrapper<ChatCompletionSystemMessageParam>;
  ChatCompletionToolMessageParam: ResolverTypeWrapper<ChatCompletionToolMessageParam>;
  ChatCompletionUsage: ResolverTypeWrapper<ChatCompletionUsage>;
  ChatCompletionUserMessageParam: ResolverTypeWrapper<ChatCompletionUserMessageParam>;
  ChatModel: ChatModel;
  CollectionFirestoreCount: ResolverTypeWrapper<CollectionFirestoreCount>;
  ConfidenceReason: ConfidenceReason;
  ContentSeverity: ContentSeverity;
  ControlHeartbeatSessionsMessage: ResolverTypeWrapper<ControlHeartbeatSessionsMessage>;
  ControlSendInsightNotificationsMessage: ResolverTypeWrapper<ControlSendInsightNotificationsMessage>;
  ControlSweepChannelMarksMessage: ResolverTypeWrapper<ControlSweepChannelMarksMessage>;
  ControlSweepChannelRescoresMessage: ResolverTypeWrapper<ControlSweepChannelRescoresMessage>;
  ControlSweepEvaluateChannelMarksMessage: ResolverTypeWrapper<ControlSweepEvaluateChannelMarksMessage>;
  ControlSweepEvaluateVideoMarksMessage: ResolverTypeWrapper<ControlSweepEvaluateVideoMarksMessage>;
  ControlSweepProfileChannelOverlayMarksMessage: ResolverTypeWrapper<ControlSweepProfileChannelOverlayMarksMessage>;
  ControlSweepProfileMarksMessage: ResolverTypeWrapper<ControlSweepProfileMarksMessage>;
  ControlSweepReevaluateAllMessage: ResolverTypeWrapper<ControlSweepReevaluateAllMessage>;
  ControlSweepRetryStuckActionsMessage: ResolverTypeWrapper<ControlSweepRetryStuckActionsMessage>;
  ControlSweepReviewInboxMessage: ResolverTypeWrapper<ControlSweepReviewInboxMessage>;
  ControlSweepStaleAlgorithmVersionMessage: ResolverTypeWrapper<ControlSweepStaleAlgorithmVersionMessage>;
  ControlSweepSubscriptionsMessage: ResolverTypeWrapper<ControlSweepSubscriptionsMessage>;
  Cookie: ResolverTypeWrapper<Cookie>;
  CookieInput: CookieInput;
  CorrectiveAction: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CorrectiveAction']>;
  CorrectiveActionAlgorithmVersion: CorrectiveActionAlgorithmVersion;
  CorrectiveActionEvent: ResolverTypeWrapper<CorrectiveActionEvent>;
  CorrectiveActionEventActor: CorrectiveActionEventActor;
  CorrectiveActionEventKind: CorrectiveActionEventKind;
  CorrectiveActionKind: CorrectiveActionKind;
  CorrectiveActionSeverity: CorrectiveActionSeverity;
  CorrectiveActionStats: ResolverTypeWrapper<CorrectiveActionStats>;
  CorrectiveActionStatus: CorrectiveActionStatus;
  CorrectiveActionTrigger: CorrectiveActionTrigger;
  CorrectiveActionType: CorrectiveActionType;
  CorrectiveActionUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CorrectiveActionUnion']>;
  CostByAgent: ResolverTypeWrapper<CostByAgent>;
  CostByModel: ResolverTypeWrapper<CostByModel>;
  CostDailyBucket: ResolverTypeWrapper<CostDailyBucket>;
  CostEstimateInfo: ResolverTypeWrapper<CostEstimateInfo>;
  CreateFeedTaskResult: ResolverTypeWrapper<CreateFeedTaskResult>;
  CreateInviteResult: ResolverTypeWrapper<CreateInviteResult>;
  Criterion: ResolverTypeWrapper<Criterion>;
  DailyFeedStats: ResolverTypeWrapper<DailyFeedStats>;
  DailyHistoryStats: ResolverTypeWrapper<DailyHistoryStats>;
  DailyObjectionableStats: ResolverTypeWrapper<DailyObjectionableStats>;
  DailyScore: ResolverTypeWrapper<DailyScore>;
  DataRequirement: DataRequirement;
  DateRange: ResolverTypeWrapper<DateRange>;
  DeleteEdgeTaskResult: ResolverTypeWrapper<DeleteEdgeTaskResult>;
  DeleteEdgeTasksResult: ResolverTypeWrapper<DeleteEdgeTasksResult>;
  DesktopHeartbeatResult: ResolverTypeWrapper<DesktopHeartbeatResult>;
  DesktopProfileHeartbeat: DesktopProfileHeartbeat;
  Device: ResolverTypeWrapper<Device>;
  DeviceGrant: ResolverTypeWrapper<DeviceGrant>;
  DevicePairing: ResolverTypeWrapper<DevicePairing>;
  DevicePairingClaimResult: ResolverTypeWrapper<DevicePairingClaimResult>;
  DevicePairingStatus: ResolverTypeWrapper<DevicePairingStatus>;
  EdgeProfileStats: ResolverTypeWrapper<EdgeProfileStats>;
  EdgeQueueTask: ResolverTypeWrapper<EdgeQueueTask>;
  EdgeQueueTaskType: EdgeQueueTaskType;
  EdgeRecentWatch: ResolverTypeWrapper<EdgeRecentWatch>;
  EnqueueJobResult: ResolverTypeWrapper<EnqueueJobResult>;
  EvalAgentEntry: ResolverTypeWrapper<EvalAgentEntry>;
  EvalExpectedPerAgentInput: EvalExpectedPerAgentInput;
  EvalFieldAccuracy: ResolverTypeWrapper<EvalFieldAccuracy>;
  EvalFieldCategoricalAccuracy: ResolverTypeWrapper<EvalFieldCategoricalAccuracy>;
  EvalFieldScoreAccuracy: ResolverTypeWrapper<EvalFieldScoreAccuracy>;
  EvalReport: ResolverTypeWrapper<EvalReport>;
  EvalTestCase: ResolverTypeWrapper<EvalTestCase>;
  EvalTestCaseInput: EvalTestCaseInput;
  EvaluateChannelActionsMessage: ResolverTypeWrapper<EvaluateChannelActionsMessage>;
  EvaluateProfileActionsMessage: ResolverTypeWrapper<EvaluateProfileActionsMessage>;
  EvaluateVideoActionsMessage: ResolverTypeWrapper<EvaluateVideoActionsMessage>;
  Evidence: ResolverTypeWrapper<Evidence>;
  EvidenceFactor: ResolverTypeWrapper<EvidenceFactor>;
  EvidenceFactorSummary: ResolverTypeWrapper<EvidenceFactorSummary>;
  EvidencePreview: ResolverTypeWrapper<EvidencePreview>;
  EvidencePreviewBullet: ResolverTypeWrapper<EvidencePreviewBullet>;
  EvidenceScoring: ResolverTypeWrapper<EvidenceScoring>;
  EvidenceVideo: ResolverTypeWrapper<EvidenceVideo>;
  EvolveAgentPromptInput: EvolveAgentPromptInput;
  ExecutedAction: ResolverTypeWrapper<Omit<ExecutedAction, 'metricsDelta' | 'target'> & { metricsDelta?: Maybe<ResolversTypes['ActionMetrics']>, target: ResolversTypes['SuggestionTarget'] }>;
  FeedCorrectiveAction: ResolverTypeWrapper<FeedCorrectiveAction>;
  FeedVideo: ResolverTypeWrapper<FeedVideo>;
  FeedbackLog: ResolverTypeWrapper<FeedbackLog>;
  FeedbackToken: ResolverTypeWrapper<FeedbackToken>;
  FeedbackTokens: ResolverTypeWrapper<FeedbackTokens>;
  FetchTranscriptMessage: ResolverTypeWrapper<FetchTranscriptMessage>;
  FirebaseUser: ResolverTypeWrapper<FirebaseUser>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GatedContext: ResolverTypeWrapper<GatedContext>;
  GenerateCorrectiveActionsInput: GenerateCorrectiveActionsInput;
  GenerateCorrectiveActionsResult: ResolverTypeWrapper<GenerateCorrectiveActionsResult>;
  GuardianGroup: ResolverTypeWrapper<GuardianGroup>;
  GuardianGroupMember: ResolverTypeWrapper<GuardianGroupMember>;
  HarvestedFeedbackToken: ResolverTypeWrapper<HarvestedFeedbackToken>;
  HistoryScoresOverTime: ResolverTypeWrapper<HistoryScoresOverTime>;
  HistoryVideo: ResolverTypeWrapper<HistoryVideo>;
  HomeCaughtItem: ResolverTypeWrapper<HomeCaughtItem>;
  HomeCaughtSummary: ResolverTypeWrapper<HomeCaughtSummary>;
  HomeScore: ResolverTypeWrapper<HomeScore>;
  HomeTopChannel: ResolverTypeWrapper<HomeTopChannel>;
  HomeWeeklyImpact: ResolverTypeWrapper<HomeWeeklyImpact>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ImpactAchievement: ResolverTypeWrapper<ImpactAchievement>;
  ImpactRange: ImpactRange;
  ImpactSummaryResult: ResolverTypeWrapper<ImpactSummaryResult>;
  IngestAckFeedMessage: ResolverTypeWrapper<IngestAckFeedMessage>;
  IngestAckGenericMessage: ResolverTypeWrapper<IngestAckGenericMessage>;
  IngestAckHistoryMessage: ResolverTypeWrapper<IngestAckHistoryMessage>;
  IngestAckRelatedMessage: ResolverTypeWrapper<IngestAckRelatedMessage>;
  IngestAckTranscriptMessage: ResolverTypeWrapper<IngestAckTranscriptMessage>;
  IngestReparseMessage: ResolverTypeWrapper<IngestReparseMessage>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvitePreview: ResolverTypeWrapper<InvitePreview>;
  InviteSource: InviteSource;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  KidProfile: ResolverTypeWrapper<KidProfile>;
  KidProfileReviewItem: ResolverTypeWrapper<KidProfileReviewItem>;
  LLMCostSummary: ResolverTypeWrapper<LlmCostSummary>;
  LLMRequest: ResolverTypeWrapper<Omit<LlmRequest, 'messages'> & { messages: Array<ResolversTypes['ChatCompletionMessageParam']> }>;
  LLMUsage: ResolverTypeWrapper<LlmUsage>;
  LanguageFacts: ResolverTypeWrapper<LanguageFacts>;
  LanguagePolicyMode: LanguagePolicyMode;
  LanguageSource: LanguageSource;
  LinkedAccount: ResolverTypeWrapper<LinkedAccount>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  OpenRouterModelEntry: ResolverTypeWrapper<OpenRouterModelEntry>;
  PolicyAdjustment: ResolverTypeWrapper<PolicyAdjustment>;
  PoliticsFacts: ResolverTypeWrapper<PoliticsFacts>;
  PoliticsMode: PoliticsMode;
  PoliticsPolicyMode: PoliticsPolicyMode;
  PoliticsStance: PoliticsStance;
  PreviewKind: PreviewKind;
  PrimeEdgeTasksResult: ResolverTypeWrapper<PrimeEdgeTasksResult>;
  ProcessFeedMessage: ResolverTypeWrapper<ProcessFeedMessage>;
  ProcessHistoryMessage: ResolverTypeWrapper<ProcessHistoryMessage>;
  ProfileGender: ProfileGender;
  ProfilePreferences: ResolverTypeWrapper<ProfilePreferences>;
  ProfilePreferencesInput: ProfilePreferencesInput;
  ProfileSummary: ResolverTypeWrapper<ProfileSummary>;
  ProfileVideoVerdict: ResolverTypeWrapper<ProfileVideoVerdict>;
  ProfileWorker: ResolverTypeWrapper<ProfileWorker>;
  ProgressActions: ResolverTypeWrapper<ProgressActions>;
  ProgressRange: ProgressRange;
  ProgressTrends: ResolverTypeWrapper<ProgressTrends>;
  Prompt: ResolverTypeWrapper<Omit<Prompt, 'messages'> & { messages: Array<ResolversTypes['ChatCompletionMessageParam']> }>;
  QualityBreakdown: ResolverTypeWrapper<QualityBreakdown>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RedeemInviteResult: ResolverTypeWrapper<RedeemInviteResult>;
  RegisterDeviceInput: RegisterDeviceInput;
  ReligionFacts: ResolverTypeWrapper<ReligionFacts>;
  ReligionFaith: ReligionFaith;
  ReligionMode: ReligionMode;
  ReligionPolicyMode: ReligionPolicyMode;
  ReprocessTaskResult: ResolverTypeWrapper<ReprocessTaskResult>;
  ReprocessTasksBatchResult: ResolverTypeWrapper<ReprocessTasksBatchResult>;
  RescoreCostBreakdownRow: ResolverTypeWrapper<RescoreCostBreakdownRow>;
  RescoreCostEstimate: ResolverTypeWrapper<RescoreCostEstimate>;
  RescoreCostEstimateInput: RescoreCostEstimateInput;
  RescorePerAgentStat: ResolverTypeWrapper<RescorePerAgentStat>;
  RescoreVideosInput: RescoreVideosInput;
  RescoreVideosResult: ResolverTypeWrapper<RescoreVideosResult>;
  ResetEdgeTaskResult: ResolverTypeWrapper<ResetEdgeTaskResult>;
  ResetEdgeTasksResult: ResolverTypeWrapper<ResetEdgeTasksResult>;
  RetractResult: ResolverTypeWrapper<RetractResult>;
  RetryAllFailedExtractionsResult: ResolverTypeWrapper<RetryAllFailedExtractionsResult>;
  RetryFailedExtractionsResult: ResolverTypeWrapper<RetryFailedExtractionsResult>;
  RetryPerTypeCount: ResolverTypeWrapper<RetryPerTypeCount>;
  ReviewQueueCard: ResolverTypeWrapper<ReviewQueueCard>;
  ReviewQueueFactor: ResolverTypeWrapper<ReviewQueueFactor>;
  ReviewQueueResult: ResolverTypeWrapper<ReviewQueueResult>;
  ReviewSelectorBucket: ReviewSelectorBucket;
  ReviewSelectorClassification: ResolverTypeWrapper<ReviewSelectorClassification>;
  ReviewSelectorPreview: ResolverTypeWrapper<ReviewSelectorPreview>;
  ReviewSelectorPreviewInput: ReviewSelectorPreviewInput;
  RunEvalInput: RunEvalInput;
  RunMultiModelEvalInput: RunMultiModelEvalInput;
  SaveAgentPromptInput: SaveAgentPromptInput;
  ScoreBase: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ScoreBase']>;
  ScoreConfidence: ScoreConfidence;
  ScoreDirection: ScoreDirection;
  ScoreDistribution: ResolverTypeWrapper<ScoreDistribution>;
  ScoreKind: ScoreKind;
  ScoreVideoResult: ResolverTypeWrapper<ScoreVideoResult>;
  ScoredVideosResult: ResolverTypeWrapper<ScoredVideosResult>;
  ScoringAnalyzeVideoMessage: ResolverTypeWrapper<ScoringAnalyzeVideoMessage>;
  ScoringEvalAgentCellMessage: ResolverTypeWrapper<ScoringEvalAgentCellMessage>;
  ScoringEvalAgentFanoutMessage: ResolverTypeWrapper<ScoringEvalAgentFanoutMessage>;
  ScoringEvalPipelineMessage: ResolverTypeWrapper<ScoringEvalPipelineMessage>;
  ScoringEvolvePromptMessage: ResolverTypeWrapper<ScoringEvolvePromptMessage>;
  ScoringRescoreLibraryMessage: ResolverTypeWrapper<ScoringRescoreLibraryMessage>;
  ScoringSource: ScoringSource;
  SeedTestCasesResult: ResolverTypeWrapper<SeedTestCasesResult>;
  ServiceHealth: ResolverTypeWrapper<ServiceHealth>;
  SessionCookie: ResolverTypeWrapper<SessionCookie>;
  SessionLinkResult: ResolverTypeWrapper<SessionLinkResult>;
  SpecialistSelectionReason: SpecialistSelectionReason;
  SpecializedScore: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SpecializedScore']>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Suggestion: ResolverTypeWrapper<Omit<Suggestion, 'actionHelpers' | 'target'> & { actionHelpers: ResolversTypes['ActionHelpers'], target: ResolversTypes['SuggestionTarget'] }>;
  SuggestionState: SuggestionState;
  SuggestionTarget: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SuggestionTarget']>;
  SuggestionVerb: SuggestionVerb;
  SummarizationNeed: SummarizationNeed;
  TaskDebugInfo: ResolverTypeWrapper<TaskDebugInfo>;
  TaskFailureReason: TaskFailureReason;
  TaskFailureStage: TaskFailureStage;
  TaskFirestoreCount: ResolverTypeWrapper<TaskFirestoreCount>;
  TaskFirestoreCounters: ResolverTypeWrapper<TaskFirestoreCounters>;
  TaskParseError: ResolverTypeWrapper<TaskParseError>;
  TaskResult: ResolverTypeWrapper<TaskResult>;
  TaskResultInput: TaskResultInput;
  TaskResultStatus: TaskResultStatus;
  TaskState: TaskState;
  ThresholdDirection: ThresholdDirection;
  Thumbnail: ResolverTypeWrapper<Thumbnail>;
  TokenStatus: TokenStatus;
  TokenUsageInfo: ResolverTypeWrapper<TokenUsageInfo>;
  TotalFeedStats: ResolverTypeWrapper<TotalFeedStats>;
  TotalHistoryStats: ResolverTypeWrapper<TotalHistoryStats>;
  TotalObjectionableStats: ResolverTypeWrapper<TotalObjectionableStats>;
  TotalSessionStats: ResolverTypeWrapper<TotalSessionStats>;
  TriageOutput: ResolverTypeWrapper<TriageOutput>;
  TriageVerdict: TriageVerdict;
  TriageVideosMessage: ResolverTypeWrapper<TriageVideosMessage>;
  UserSession: ResolverTypeWrapper<UserSession>;
  Video: ResolverTypeWrapper<Video>;
  VideoCorrectiveAction: ResolverTypeWrapper<VideoCorrectiveAction>;
  VideoFactorBreakdown: ResolverTypeWrapper<VideoFactorBreakdown>;
  VideoLanguage: ResolverTypeWrapper<VideoLanguage>;
  VideoRating: VideoRating;
  VideoScoringState: ResolverTypeWrapper<VideoScoringState>;
  VideoStats: ResolverTypeWrapper<VideoStats>;
  VideoTranscript: ResolverTypeWrapper<VideoTranscript>;
  VideosWithScores: ResolverTypeWrapper<VideosWithScores>;
  Vote: ResolverTypeWrapper<Omit<Vote, 'target'> & { target: ResolversTypes['SuggestionTarget'] }>;
  VoteSource: VoteSource;
  VoteSummary: ResolverTypeWrapper<VoteSummary>;
  WaitlistEntry: ResolverTypeWrapper<WaitlistEntry>;
  WeeklyBuckets: ResolverTypeWrapper<WeeklyBuckets>;
  WeeklyImpact: ResolverTypeWrapper<WeeklyImpact>;
  WeeklyScore: ResolverTypeWrapper<WeeklyScore>;
  WelcomeState: ResolverTypeWrapper<WelcomeState>;
  WelcomeStep: WelcomeStep;
  WorkerFirestoreStatRow: ResolverTypeWrapper<WorkerFirestoreStatRow>;
  WorkerInfoLite: ResolverTypeWrapper<WorkerInfoLite>;
  YTCredentials: ResolverTypeWrapper<YtCredentials>;
  YouTubeProfile: ResolverTypeWrapper<YouTubeProfile>;
  YoutubeFeedSnapshot: ResolverTypeWrapper<YoutubeFeedSnapshot>;
  YoutubeHistorySnapshot: ResolverTypeWrapper<YoutubeHistorySnapshot>;
  YoutubeRelatedSnapshot: ResolverTypeWrapper<YoutubeRelatedSnapshot>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AIAnalysis: Omit<AiAnalysis, 'prompt'> & { prompt?: Maybe<ResolversParentTypes['Prompt']> };
  AccountInfo: AccountInfo;
  ActionHelpers: ActionHelpers;
  ActionMetrics: ActionMetrics;
  ActivityEvent: ActivityEvent;
  ActivityRow: ActivityRow;
  AdminAccountInfoReplay: AdminAccountInfoReplay;
  AdminCcDevice: AdminCcDevice;
  AdminCcOwner: AdminCcOwner;
  AdminCcProfile: AdminCcProfile;
  AdminCcProfileDevice: AdminCcProfileDevice;
  AdminCcProfileStatus: AdminCcProfileStatus;
  AdminCcSession: AdminCcSession;
  AdminCcTotals: AdminCcTotals;
  AdminCommandCenter: AdminCommandCenter;
  AdminDeleteSessionResult: AdminDeleteSessionResult;
  AdminEnqueuePipelineEvalResult: AdminEnqueuePipelineEvalResult;
  AdminEvalFailedSpecialist: AdminEvalFailedSpecialist;
  AdminEvalFinalizeResult: AdminEvalFinalizeResult;
  AdminEvalPipelineInput: AdminEvalPipelineInput;
  AdminEvalPipelineProgress: AdminEvalPipelineProgress;
  AdminEvalPipelineResult: AdminEvalPipelineResult;
  AdminEvalSkippedSpecialist: AdminEvalSkippedSpecialist;
  AdminEvalSpecialistResult: AdminEvalSpecialistResult;
  AdminEvalTriageResult: AdminEvalTriageResult;
  AdminInsightCandidate: AdminInsightCandidate;
  AdminInsightCandidateList: AdminInsightCandidateList;
  AdminInsightTestResult: AdminInsightTestResult;
  AdminPurgeProfileResult: AdminPurgeProfileResult;
  AdminRecomputeCorrectiveActionsResult: AdminRecomputeCorrectiveActionsResult;
  AdminRerunScoringPipelineResult: AdminRerunScoringPipelineResult;
  AdminResetAllVideoScoresResult: AdminResetAllVideoScoresResult;
  AdminResetAllVideoSummariesResult: AdminResetAllVideoSummariesResult;
  AdminResetVideoScoresResult: AdminResetVideoScoresResult;
  AdminResetVideoSummaryResult: AdminResetVideoSummaryResult;
  AdminScoringTestResult: Omit<AdminScoringTestResult, 'request'> & { request: ResolversParentTypes['LLMRequest'] };
  AdminSeedPromptsResult: AdminSeedPromptsResult;
  AdminSeededPrompt: AdminSeededPrompt;
  AdminSweepProfileSessionsResult: AdminSweepProfileSessionsResult;
  AgeBandVerdict: AgeBandVerdict;
  Agent: Agent;
  AgentAggregateScore: AgentAggregateScore;
  AgentAnalysisChatLog: Omit<AgentAnalysisChatLog, 'request'> & { request: ResolversParentTypes['LLMRequest'] };
  AgentId: AgentId;
  AgentIdInput: AgentIdInput;
  AgentParameterOverrides: AgentParameterOverrides;
  AgentPromptEntry: AgentPromptEntry;
  AgentScore: AgentScore;
  AgentTriggers: AgentTriggers;
  AggregateChannelMessage: AggregateChannelMessage;
  AggregateProfileChannelFeedbackMessage: AggregateProfileChannelFeedbackMessage;
  AnalysisQueue: ResolversUnionTypes<ResolversParentTypes>['AnalysisQueue'];
  AnalysisQueueMessage: ResolversInterfaceTypes<ResolversParentTypes>['AnalysisQueueMessage'];
  ApplyCorrectiveActionInput: ApplyCorrectiveActionInput;
  ApplyCorrectiveActionResult: Omit<ApplyCorrectiveActionResult, 'action'> & { action?: Maybe<ResolversParentTypes['CorrectiveActionUnion']> };
  ApplySuggestionResult: Omit<ApplySuggestionResult, 'executedAction' | 'suggestion'> & { executedAction?: Maybe<ResolversParentTypes['ExecutedAction']>, suggestion: ResolversParentTypes['Suggestion'] };
  Author: Author;
  AuthorAggregateScore: AuthorAggregateScore;
  AuthorVideoScore: AuthorVideoScore;
  BindFeedbackTokensMessage: BindFeedbackTokensMessage;
  BlobMigrationResult: BlobMigrationResult;
  Boolean: Scalars['Boolean']['output'];
  BullmqJobEntry: BullmqJobEntry;
  BullmqQueueConcurrency: BullmqQueueConcurrency;
  BullmqWorker: BullmqWorker;
  BullmqWorkersSnapshot: BullmqWorkersSnapshot;
  ChannelCorrectiveAction: ChannelCorrectiveAction;
  ChannelEvolution: ChannelEvolution;
  ChannelFeedbackQuality: ChannelFeedbackQuality;
  ChannelFeedbackRow: ChannelFeedbackRow;
  ChatCompletionAssistantMessageParam: ChatCompletionAssistantMessageParam;
  ChatCompletionChoice: ChatCompletionChoice;
  ChatCompletionCreateParamsBase: Omit<ChatCompletionCreateParamsBase, 'messages'> & { messages: Array<ResolversParentTypes['ChatCompletionMessageParam']> };
  ChatCompletionDeveloperMessageParam: ChatCompletionDeveloperMessageParam;
  ChatCompletionFunctionMessageParam: ChatCompletionFunctionMessageParam;
  ChatCompletionMessage: ChatCompletionMessage;
  ChatCompletionMessageParam: ResolversUnionTypes<ResolversParentTypes>['ChatCompletionMessageParam'];
  ChatCompletionResponse: ChatCompletionResponse;
  ChatCompletionSystemMessageParam: ChatCompletionSystemMessageParam;
  ChatCompletionToolMessageParam: ChatCompletionToolMessageParam;
  ChatCompletionUsage: ChatCompletionUsage;
  ChatCompletionUserMessageParam: ChatCompletionUserMessageParam;
  CollectionFirestoreCount: CollectionFirestoreCount;
  ControlHeartbeatSessionsMessage: ControlHeartbeatSessionsMessage;
  ControlSendInsightNotificationsMessage: ControlSendInsightNotificationsMessage;
  ControlSweepChannelMarksMessage: ControlSweepChannelMarksMessage;
  ControlSweepChannelRescoresMessage: ControlSweepChannelRescoresMessage;
  ControlSweepEvaluateChannelMarksMessage: ControlSweepEvaluateChannelMarksMessage;
  ControlSweepEvaluateVideoMarksMessage: ControlSweepEvaluateVideoMarksMessage;
  ControlSweepProfileChannelOverlayMarksMessage: ControlSweepProfileChannelOverlayMarksMessage;
  ControlSweepProfileMarksMessage: ControlSweepProfileMarksMessage;
  ControlSweepReevaluateAllMessage: ControlSweepReevaluateAllMessage;
  ControlSweepRetryStuckActionsMessage: ControlSweepRetryStuckActionsMessage;
  ControlSweepReviewInboxMessage: ControlSweepReviewInboxMessage;
  ControlSweepStaleAlgorithmVersionMessage: ControlSweepStaleAlgorithmVersionMessage;
  ControlSweepSubscriptionsMessage: ControlSweepSubscriptionsMessage;
  Cookie: Cookie;
  CookieInput: CookieInput;
  CorrectiveAction: ResolversInterfaceTypes<ResolversParentTypes>['CorrectiveAction'];
  CorrectiveActionEvent: CorrectiveActionEvent;
  CorrectiveActionStats: CorrectiveActionStats;
  CorrectiveActionUnion: ResolversUnionTypes<ResolversParentTypes>['CorrectiveActionUnion'];
  CostByAgent: CostByAgent;
  CostByModel: CostByModel;
  CostDailyBucket: CostDailyBucket;
  CostEstimateInfo: CostEstimateInfo;
  CreateFeedTaskResult: CreateFeedTaskResult;
  CreateInviteResult: CreateInviteResult;
  Criterion: Criterion;
  DailyFeedStats: DailyFeedStats;
  DailyHistoryStats: DailyHistoryStats;
  DailyObjectionableStats: DailyObjectionableStats;
  DailyScore: DailyScore;
  DateRange: DateRange;
  DeleteEdgeTaskResult: DeleteEdgeTaskResult;
  DeleteEdgeTasksResult: DeleteEdgeTasksResult;
  DesktopHeartbeatResult: DesktopHeartbeatResult;
  DesktopProfileHeartbeat: DesktopProfileHeartbeat;
  Device: Device;
  DeviceGrant: DeviceGrant;
  DevicePairing: DevicePairing;
  DevicePairingClaimResult: DevicePairingClaimResult;
  DevicePairingStatus: DevicePairingStatus;
  EdgeProfileStats: EdgeProfileStats;
  EdgeQueueTask: EdgeQueueTask;
  EdgeRecentWatch: EdgeRecentWatch;
  EnqueueJobResult: EnqueueJobResult;
  EvalAgentEntry: EvalAgentEntry;
  EvalExpectedPerAgentInput: EvalExpectedPerAgentInput;
  EvalFieldAccuracy: EvalFieldAccuracy;
  EvalFieldCategoricalAccuracy: EvalFieldCategoricalAccuracy;
  EvalFieldScoreAccuracy: EvalFieldScoreAccuracy;
  EvalReport: EvalReport;
  EvalTestCase: EvalTestCase;
  EvalTestCaseInput: EvalTestCaseInput;
  EvaluateChannelActionsMessage: EvaluateChannelActionsMessage;
  EvaluateProfileActionsMessage: EvaluateProfileActionsMessage;
  EvaluateVideoActionsMessage: EvaluateVideoActionsMessage;
  Evidence: Evidence;
  EvidenceFactor: EvidenceFactor;
  EvidenceFactorSummary: EvidenceFactorSummary;
  EvidencePreview: EvidencePreview;
  EvidencePreviewBullet: EvidencePreviewBullet;
  EvidenceScoring: EvidenceScoring;
  EvidenceVideo: EvidenceVideo;
  EvolveAgentPromptInput: EvolveAgentPromptInput;
  ExecutedAction: Omit<ExecutedAction, 'metricsDelta' | 'target'> & { metricsDelta?: Maybe<ResolversParentTypes['ActionMetrics']>, target: ResolversParentTypes['SuggestionTarget'] };
  FeedCorrectiveAction: FeedCorrectiveAction;
  FeedVideo: FeedVideo;
  FeedbackLog: FeedbackLog;
  FeedbackToken: FeedbackToken;
  FeedbackTokens: FeedbackTokens;
  FetchTranscriptMessage: FetchTranscriptMessage;
  FirebaseUser: FirebaseUser;
  Float: Scalars['Float']['output'];
  GatedContext: GatedContext;
  GenerateCorrectiveActionsInput: GenerateCorrectiveActionsInput;
  GenerateCorrectiveActionsResult: GenerateCorrectiveActionsResult;
  GuardianGroup: GuardianGroup;
  GuardianGroupMember: GuardianGroupMember;
  HarvestedFeedbackToken: HarvestedFeedbackToken;
  HistoryScoresOverTime: HistoryScoresOverTime;
  HistoryVideo: HistoryVideo;
  HomeCaughtItem: HomeCaughtItem;
  HomeCaughtSummary: HomeCaughtSummary;
  HomeScore: HomeScore;
  HomeTopChannel: HomeTopChannel;
  HomeWeeklyImpact: HomeWeeklyImpact;
  ID: Scalars['ID']['output'];
  ImpactAchievement: ImpactAchievement;
  ImpactSummaryResult: ImpactSummaryResult;
  IngestAckFeedMessage: IngestAckFeedMessage;
  IngestAckGenericMessage: IngestAckGenericMessage;
  IngestAckHistoryMessage: IngestAckHistoryMessage;
  IngestAckRelatedMessage: IngestAckRelatedMessage;
  IngestAckTranscriptMessage: IngestAckTranscriptMessage;
  IngestReparseMessage: IngestReparseMessage;
  Int: Scalars['Int']['output'];
  InvitePreview: InvitePreview;
  JSON: Scalars['JSON']['output'];
  JSONObject: Scalars['JSONObject']['output'];
  KidProfile: KidProfile;
  KidProfileReviewItem: KidProfileReviewItem;
  LLMCostSummary: LlmCostSummary;
  LLMRequest: Omit<LlmRequest, 'messages'> & { messages: Array<ResolversParentTypes['ChatCompletionMessageParam']> };
  LLMUsage: LlmUsage;
  LanguageFacts: LanguageFacts;
  LinkedAccount: LinkedAccount;
  Mutation: Record<PropertyKey, never>;
  OpenRouterModelEntry: OpenRouterModelEntry;
  PolicyAdjustment: PolicyAdjustment;
  PoliticsFacts: PoliticsFacts;
  PrimeEdgeTasksResult: PrimeEdgeTasksResult;
  ProcessFeedMessage: ProcessFeedMessage;
  ProcessHistoryMessage: ProcessHistoryMessage;
  ProfilePreferences: ProfilePreferences;
  ProfilePreferencesInput: ProfilePreferencesInput;
  ProfileSummary: ProfileSummary;
  ProfileVideoVerdict: ProfileVideoVerdict;
  ProfileWorker: ProfileWorker;
  ProgressActions: ProgressActions;
  ProgressTrends: ProgressTrends;
  Prompt: Omit<Prompt, 'messages'> & { messages: Array<ResolversParentTypes['ChatCompletionMessageParam']> };
  QualityBreakdown: QualityBreakdown;
  Query: Record<PropertyKey, never>;
  RedeemInviteResult: RedeemInviteResult;
  RegisterDeviceInput: RegisterDeviceInput;
  ReligionFacts: ReligionFacts;
  ReprocessTaskResult: ReprocessTaskResult;
  ReprocessTasksBatchResult: ReprocessTasksBatchResult;
  RescoreCostBreakdownRow: RescoreCostBreakdownRow;
  RescoreCostEstimate: RescoreCostEstimate;
  RescoreCostEstimateInput: RescoreCostEstimateInput;
  RescorePerAgentStat: RescorePerAgentStat;
  RescoreVideosInput: RescoreVideosInput;
  RescoreVideosResult: RescoreVideosResult;
  ResetEdgeTaskResult: ResetEdgeTaskResult;
  ResetEdgeTasksResult: ResetEdgeTasksResult;
  RetractResult: RetractResult;
  RetryAllFailedExtractionsResult: RetryAllFailedExtractionsResult;
  RetryFailedExtractionsResult: RetryFailedExtractionsResult;
  RetryPerTypeCount: RetryPerTypeCount;
  ReviewQueueCard: ReviewQueueCard;
  ReviewQueueFactor: ReviewQueueFactor;
  ReviewQueueResult: ReviewQueueResult;
  ReviewSelectorClassification: ReviewSelectorClassification;
  ReviewSelectorPreview: ReviewSelectorPreview;
  ReviewSelectorPreviewInput: ReviewSelectorPreviewInput;
  RunEvalInput: RunEvalInput;
  RunMultiModelEvalInput: RunMultiModelEvalInput;
  SaveAgentPromptInput: SaveAgentPromptInput;
  ScoreBase: ResolversInterfaceTypes<ResolversParentTypes>['ScoreBase'];
  ScoreDistribution: ScoreDistribution;
  ScoreVideoResult: ScoreVideoResult;
  ScoredVideosResult: ScoredVideosResult;
  ScoringAnalyzeVideoMessage: ScoringAnalyzeVideoMessage;
  ScoringEvalAgentCellMessage: ScoringEvalAgentCellMessage;
  ScoringEvalAgentFanoutMessage: ScoringEvalAgentFanoutMessage;
  ScoringEvalPipelineMessage: ScoringEvalPipelineMessage;
  ScoringEvolvePromptMessage: ScoringEvolvePromptMessage;
  ScoringRescoreLibraryMessage: ScoringRescoreLibraryMessage;
  SeedTestCasesResult: SeedTestCasesResult;
  ServiceHealth: ServiceHealth;
  SessionCookie: SessionCookie;
  SessionLinkResult: SessionLinkResult;
  SpecializedScore: ResolversInterfaceTypes<ResolversParentTypes>['SpecializedScore'];
  String: Scalars['String']['output'];
  Suggestion: Omit<Suggestion, 'actionHelpers' | 'target'> & { actionHelpers: ResolversParentTypes['ActionHelpers'], target: ResolversParentTypes['SuggestionTarget'] };
  SuggestionTarget: ResolversUnionTypes<ResolversParentTypes>['SuggestionTarget'];
  TaskDebugInfo: TaskDebugInfo;
  TaskFirestoreCount: TaskFirestoreCount;
  TaskFirestoreCounters: TaskFirestoreCounters;
  TaskParseError: TaskParseError;
  TaskResult: TaskResult;
  TaskResultInput: TaskResultInput;
  Thumbnail: Thumbnail;
  TokenUsageInfo: TokenUsageInfo;
  TotalFeedStats: TotalFeedStats;
  TotalHistoryStats: TotalHistoryStats;
  TotalObjectionableStats: TotalObjectionableStats;
  TotalSessionStats: TotalSessionStats;
  TriageOutput: TriageOutput;
  TriageVideosMessage: TriageVideosMessage;
  UserSession: UserSession;
  Video: Video;
  VideoCorrectiveAction: VideoCorrectiveAction;
  VideoFactorBreakdown: VideoFactorBreakdown;
  VideoLanguage: VideoLanguage;
  VideoScoringState: VideoScoringState;
  VideoStats: VideoStats;
  VideoTranscript: VideoTranscript;
  VideosWithScores: VideosWithScores;
  Vote: Omit<Vote, 'target'> & { target: ResolversParentTypes['SuggestionTarget'] };
  VoteSummary: VoteSummary;
  WaitlistEntry: WaitlistEntry;
  WeeklyBuckets: WeeklyBuckets;
  WeeklyImpact: WeeklyImpact;
  WeeklyScore: WeeklyScore;
  WelcomeState: WelcomeState;
  WorkerFirestoreStatRow: WorkerFirestoreStatRow;
  WorkerInfoLite: WorkerInfoLite;
  YTCredentials: YtCredentials;
  YouTubeProfile: YouTubeProfile;
  YoutubeFeedSnapshot: YoutubeFeedSnapshot;
  YoutubeHistorySnapshot: YoutubeHistorySnapshot;
  YoutubeRelatedSnapshot: YoutubeRelatedSnapshot;
};

export type AdminDirectiveArgs = { };

export type AdminDirectiveResolver<Result, Parent, ContextType = any, Args = AdminDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AiAnalysisResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIAnalysis'] = ResolversParentTypes['AIAnalysis']> = {
  _v?: Resolver<ResolversTypes['AnalysisVersion'], ParentType, ContextType>;
  analysis?: Resolver<Maybe<Array<ResolversTypes['Criterion']>>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['AnalysisFailureReason']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prompt?: Resolver<Maybe<ResolversTypes['Prompt']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['AnalysisState'], ParentType, ContextType>;
};

export type AccountInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountInfo'] = ResolversParentTypes['AccountInfo']> = {
  channelHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasChannel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
};

export type ActionHelpersResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionHelpers'] = ResolversParentTypes['ActionHelpers']> = {
  approve?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  skip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  undo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ActionMetricsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionMetrics'] = ResolversParentTypes['ActionMetrics']> = {
  candidatesQueued?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videosRemoved?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videosSurfaced?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ActivityEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityEvent'] = ResolversParentTypes['ActivityEvent']> = {
  actionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  subLine?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verb?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ActivityRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityRow'] = ResolversParentTypes['ActivityRow']> = {
  actionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminAccountInfoReplayResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminAccountInfoReplay'] = ResolversParentTypes['AdminAccountInfoReplay']> = {
  capturedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parseError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parsedChannelHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parsedEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parsedHasChannel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  parsedName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parsedThumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawJson?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rawStoragePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AdminCcDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcDevice'] = ResolversParentTypes['AdminCcDevice']> = {
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registeredAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscribedProfileIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminCcOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcOwner'] = ResolversParentTypes['AdminCcOwner']> = {
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AdminCcProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcProfile'] = ResolversParentTypes['AdminCcProfile']> = {
  channelHandle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['AdminCcProfileDevice']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['AdminCcOwner']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sessions?: Resolver<Array<ResolversTypes['AdminCcSession']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AdminCcProfileStatus'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminCcProfileDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcProfileDevice'] = ResolversParentTypes['AdminCcProfileDevice']> = {
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminCcProfileStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcProfileStatus'] = ResolversParentTypes['AdminCcProfileStatus']> = {
  lastTaskAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastTaskType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeSessionInvalidReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeSessionLastCheckedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeSessionValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  youtubeSignedOut?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  youtubeSignedOutAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminCcSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcSession'] = ResolversParentTypes['AdminCcSession']> = {
  expiresAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['AdminCcSessionState'], ParentType, ContextType>;
};

export type AdminCcTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCcTotals'] = ResolversParentTypes['AdminCcTotals']> = {
  activeSessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expiredSessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  idleSessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  newSessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  orphanSessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ownersWithProfiles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profiles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profilesWithActiveDevice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  signedOutProfiles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unclaimedProfiles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminCommandCenterResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminCommandCenter'] = ResolversParentTypes['AdminCommandCenter']> = {
  devices?: Resolver<Array<ResolversTypes['AdminCcDevice']>, ParentType, ContextType>;
  generatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orphanSessions?: Resolver<Array<ResolversTypes['AdminCcSession']>, ParentType, ContextType>;
  profiles?: Resolver<Array<ResolversTypes['AdminCcProfile']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['AdminCcTotals'], ParentType, ContextType>;
};

export type AdminDeleteSessionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminDeleteSessionResult'] = ResolversParentTypes['AdminDeleteSessionResult']> = {
  errors?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  sessionDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tasksDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminEnqueuePipelineEvalResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEnqueuePipelineEvalResult'] = ResolversParentTypes['AdminEnqueuePipelineEvalResult']> = {
  evalRunId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AdminEvalFailedSpecialistResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalFailedSpecialist'] = ResolversParentTypes['AdminEvalFailedSpecialist']> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEvalFinalizeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalFinalizeResult'] = ResolversParentTypes['AdminEvalFinalizeResult']> = {
  ageBandVerdicts?: Resolver<Array<ResolversTypes['AgeBandVerdict']>, ParentType, ContextType>;
  costEstimate?: Resolver<Maybe<ResolversTypes['CostEstimateInfo']>, ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tokenUsage?: Resolver<ResolversTypes['TokenUsageInfo'], ParentType, ContextType>;
};

export type AdminEvalPipelineProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalPipelineProgress'] = ResolversParentTypes['AdminEvalPipelineProgress']> = {
  completed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phase?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminEvalPipelineResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalPipelineResult'] = ResolversParentTypes['AdminEvalPipelineResult']> = {
  enqueuedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evalRunId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failedSpecialists?: Resolver<Array<ResolversTypes['AdminEvalFailedSpecialist']>, ParentType, ContextType>;
  finalize?: Resolver<Maybe<ResolversTypes['AdminEvalFinalizeResult']>, ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['AdminEvalPipelineProgress']>, ParentType, ContextType>;
  skippedSpecialists?: Resolver<Array<ResolversTypes['AdminEvalSkippedSpecialist']>, ParentType, ContextType>;
  specialists?: Resolver<Array<ResolversTypes['AdminEvalSpecialistResult']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AdminEvalRunStatus'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCostUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  triage?: Resolver<Maybe<ResolversTypes['AdminEvalTriageResult']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEvalSkippedSpecialistResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalSkippedSpecialist'] = ResolversParentTypes['AdminEvalSkippedSpecialist']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminEvalSpecialistResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalSpecialistResult'] = ResolversParentTypes['AdminEvalSpecialistResult']> = {
  agentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  costEstimate?: Resolver<Maybe<ResolversTypes['CostEstimateInfo']>, ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  politicsFacts?: Resolver<Maybe<ResolversTypes['PoliticsFacts']>, ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  religionFacts?: Resolver<Maybe<ResolversTypes['ReligionFacts']>, ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenUsage?: Resolver<ResolversTypes['TokenUsageInfo'], ParentType, ContextType>;
};

export type AdminEvalTriageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminEvalTriageResult'] = ResolversParentTypes['AdminEvalTriageResult']> = {
  categoryTags?: Resolver<Array<ResolversTypes['AgentCategoryTag']>, ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  costEstimate?: Resolver<Maybe<ResolversTypes['CostEstimateInfo']>, ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  riskFlags?: Resolver<Array<ResolversTypes['AgentRiskFlag']>, ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tokenUsage?: Resolver<ResolversTypes['TokenUsageInfo'], ParentType, ContextType>;
  verdict?: Resolver<ResolversTypes['TriageVerdict'], ParentType, ContextType>;
};

export type AdminInsightCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminInsightCandidate'] = ResolversParentTypes['AdminInsightCandidate']> = {
  aiConfidence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  alreadyNotified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  included?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastWatchAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rankPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreCapped?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  scoreRecency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminInsightCandidateListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminInsightCandidateList'] = ResolversParentTypes['AdminInsightCandidateList']> = {
  candidates?: Resolver<Array<ResolversTypes['AdminInsightCandidate']>, ParentType, ContextType>;
  chosenVideoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excludedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  includedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  notes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scanned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminInsightTestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminInsightTestResult'] = ResolversParentTypes['AdminInsightTestResult']> = {
  chosenRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenSeverity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenVideoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicesTargeted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  notes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pushErrors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pushOk?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scanned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminPurgeProfileResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminPurgeProfileResult'] = ResolversParentTypes['AdminPurgeProfileResult']> = {
  cacheProfileFeedDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  correctiveActionsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  feedSnapshotsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feedbackDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  historySnapshotsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profileExisted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileStatusDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  relatedSnapshotsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sessionsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasksDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminRecomputeCorrectiveActionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRecomputeCorrectiveActionsResult'] = ResolversParentTypes['AdminRecomputeCorrectiveActionsResult']> = {
  channelsMarked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  videoMarked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminRerunScoringPipelineResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminRerunScoringPipelineResult'] = ResolversParentTypes['AdminRerunScoringPipelineResult']> = {
  jobId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceTaskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminResetAllVideoScoresResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminResetAllVideoScoresResult'] = ResolversParentTypes['AdminResetAllVideoScoresResult']> = {
  scoresDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosAffected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminResetAllVideoSummariesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminResetAllVideoSummariesResult'] = ResolversParentTypes['AdminResetAllVideoSummariesResult']> = {
  summariesDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosAffected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminResetVideoScoresResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminResetVideoScoresResult'] = ResolversParentTypes['AdminResetVideoScoresResult']> = {
  scoresDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosConsidered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminResetVideoSummaryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminResetVideoSummaryResult'] = ResolversParentTypes['AdminResetVideoSummaryResult']> = {
  summariesDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminScoringTestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminScoringTestResult'] = ResolversParentTypes['AdminScoringTestResult']> = {
  cacheLLMId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  request?: Resolver<ResolversTypes['LLMRequest'], ParentType, ContextType>;
  response?: Resolver<ResolversTypes['ChatCompletionResponse'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type AdminSeedPromptsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminSeedPromptsResult'] = ResolversParentTypes['AdminSeedPromptsResult']> = {
  prompts?: Resolver<Array<ResolversTypes['AdminSeededPrompt']>, ParentType, ContextType>;
  seeded?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AdminSeededPromptResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminSeededPrompt'] = ResolversParentTypes['AdminSeededPrompt']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdminSweepProfileSessionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminSweepProfileSessionsResult'] = ResolversParentTypes['AdminSweepProfileSessionsResult']> = {
  deletedSessionIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sessionsDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasksDeleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AgeBandVerdictResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgeBandVerdict'] = ResolversParentTypes['AgeBandVerdict']> = {
  band?: Resolver<ResolversTypes['AgeBand'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type AgentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agent'] = ResolversParentTypes['Agent']> = {
  data_requirement?: Resolver<ResolversTypes['DataRequirement'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  max_age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  min_age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scoreDirection?: Resolver<ResolversTypes['ScoreDirection'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  summarization_need?: Resolver<Maybe<ResolversTypes['SummarizationNeed']>, ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
  triggers?: Resolver<Maybe<ResolversTypes['AgentTriggers']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgentType'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AgentAggregateScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentAggregateScore'] = ResolversParentTypes['AgentAggregateScore']> = {
  confidence?: Resolver<ResolversTypes['ScoreConfidence'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overriddenAgents?: Resolver<Maybe<Array<ResolversTypes['AgentId']>>, ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  restricted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  restrictingAgents?: Resolver<Maybe<Array<ResolversTypes['AgentId']>>, ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  transcriptLen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AgentAnalysisChatLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentAnalysisChatLog'] = ResolversParentTypes['AgentAnalysisChatLog']> = {
  agent_id?: Resolver<Maybe<ResolversTypes['AgentId']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  request?: Resolver<ResolversTypes['LLMRequest'], ParentType, ContextType>;
  response?: Resolver<ResolversTypes['ChatCompletionResponse'], ParentType, ContextType>;
  response_format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AgentIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentId'] = ResolversParentTypes['AgentId']> = {
  specialization?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AgentPromptEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentPromptEntry'] = ResolversParentTypes['AgentPromptEntry']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['AgentPromptKind'], ParentType, ContextType>;
  lastEvalScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AgentScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentScore'] = ResolversParentTypes['AgentScore']> = {
  ageBandVerdicts?: Resolver<Maybe<Array<ResolversTypes['AgeBandVerdict']>>, ParentType, ContextType>;
  agent?: Resolver<ResolversTypes['AgentId'], ParentType, ContextType>;
  cacheHit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cache_llm_id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  costEstimate?: Resolver<Maybe<ResolversTypes['CostEstimateInfo']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gatedContext?: Resolver<Maybe<ResolversTypes['GatedContext']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['ScoreKind'], ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  politicsFacts?: Resolver<Maybe<ResolversTypes['PoliticsFacts']>, ParentType, ContextType>;
  promptVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  religionFacts?: Resolver<Maybe<ResolversTypes['ReligionFacts']>, ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreDirection?: Resolver<ResolversTypes['ScoreDirection'], ParentType, ContextType>;
  tokenUsage?: Resolver<Maybe<ResolversTypes['TokenUsageInfo']>, ParentType, ContextType>;
  transcriptLen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  triageOutput?: Resolver<Maybe<ResolversTypes['TriageOutput']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgentType'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgentTriggersResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentTriggers'] = ResolversParentTypes['AgentTriggers']> = {
  always?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  categoryTags?: Resolver<Maybe<Array<ResolversTypes['AgentCategoryTag']>>, ParentType, ContextType>;
  riskFlags?: Resolver<Maybe<Array<ResolversTypes['AgentRiskFlag']>>, ParentType, ContextType>;
};

export type AggregateChannelMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregateChannelMessage'] = ResolversParentTypes['AggregateChannelMessage']> = {
  channelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregateProfileChannelFeedbackMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AggregateProfileChannelFeedbackMessage'] = ResolversParentTypes['AggregateProfileChannelFeedbackMessage']> = {
  channelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalysisQueueResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalysisQueue'] = ResolversParentTypes['AnalysisQueue']> = {
  __resolveType: TypeResolveFn<'AggregateChannelMessage' | 'AggregateProfileChannelFeedbackMessage' | 'BindFeedbackTokensMessage' | 'ControlHeartbeatSessionsMessage' | 'ControlSendInsightNotificationsMessage' | 'ControlSweepChannelMarksMessage' | 'ControlSweepChannelRescoresMessage' | 'ControlSweepEvaluateChannelMarksMessage' | 'ControlSweepEvaluateVideoMarksMessage' | 'ControlSweepProfileChannelOverlayMarksMessage' | 'ControlSweepProfileMarksMessage' | 'ControlSweepReevaluateAllMessage' | 'ControlSweepRetryStuckActionsMessage' | 'ControlSweepReviewInboxMessage' | 'ControlSweepStaleAlgorithmVersionMessage' | 'ControlSweepSubscriptionsMessage' | 'EvaluateChannelActionsMessage' | 'EvaluateProfileActionsMessage' | 'EvaluateVideoActionsMessage' | 'FetchTranscriptMessage' | 'IngestAckFeedMessage' | 'IngestAckGenericMessage' | 'IngestAckHistoryMessage' | 'IngestAckRelatedMessage' | 'IngestAckTranscriptMessage' | 'IngestReparseMessage' | 'ProcessFeedMessage' | 'ProcessHistoryMessage' | 'ScoringAnalyzeVideoMessage' | 'ScoringEvalAgentCellMessage' | 'ScoringEvalAgentFanoutMessage' | 'ScoringEvalPipelineMessage' | 'ScoringEvolvePromptMessage' | 'ScoringRescoreLibraryMessage' | 'TriageVideosMessage', ParentType, ContextType>;
};

export type AnalysisQueueMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalysisQueueMessage'] = ResolversParentTypes['AnalysisQueueMessage']> = {
  __resolveType: TypeResolveFn<'AggregateChannelMessage' | 'AggregateProfileChannelFeedbackMessage' | 'BindFeedbackTokensMessage' | 'ControlHeartbeatSessionsMessage' | 'ControlSendInsightNotificationsMessage' | 'ControlSweepChannelMarksMessage' | 'ControlSweepChannelRescoresMessage' | 'ControlSweepEvaluateChannelMarksMessage' | 'ControlSweepEvaluateVideoMarksMessage' | 'ControlSweepProfileChannelOverlayMarksMessage' | 'ControlSweepProfileMarksMessage' | 'ControlSweepReevaluateAllMessage' | 'ControlSweepRetryStuckActionsMessage' | 'ControlSweepReviewInboxMessage' | 'ControlSweepStaleAlgorithmVersionMessage' | 'ControlSweepSubscriptionsMessage' | 'EvaluateChannelActionsMessage' | 'EvaluateProfileActionsMessage' | 'EvaluateVideoActionsMessage' | 'FetchTranscriptMessage' | 'IngestAckFeedMessage' | 'IngestAckGenericMessage' | 'IngestAckHistoryMessage' | 'IngestAckRelatedMessage' | 'IngestAckTranscriptMessage' | 'IngestReparseMessage' | 'ProcessFeedMessage' | 'ProcessHistoryMessage' | 'ScoringAnalyzeVideoMessage' | 'ScoringEvalAgentCellMessage' | 'ScoringEvalAgentFanoutMessage' | 'ScoringEvalPipelineMessage' | 'ScoringEvolvePromptMessage' | 'ScoringRescoreLibraryMessage' | 'TriageVideosMessage', ParentType, ContextType>;
};

export type ApplyCorrectiveActionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplyCorrectiveActionResult'] = ResolversParentTypes['ApplyCorrectiveActionResult']> = {
  action?: Resolver<Maybe<ResolversTypes['CorrectiveActionUnion']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ApplySuggestionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplySuggestionResult'] = ResolversParentTypes['ApplySuggestionResult']> = {
  executedAction?: Resolver<Maybe<ResolversTypes['ExecutedAction']>, ParentType, ContextType>;
  suggestion?: Resolver<ResolversTypes['Suggestion'], ParentType, ContextType>;
};

export type AuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Author'] = ResolversParentTypes['Author']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_moderator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_verified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_verified_artist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorAggregateScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorAggregateScore'] = ResolversParentTypes['AuthorAggregateScore']> = {
  allScoresFromFeedback?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  authorId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['ScoreConfidence'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  recommended?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
  restricted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  restrictedVideoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalOverriddenAgents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['AuthorVideoScore']>, ParentType, ContextType>;
  videosWithFeedback?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  watched?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
};

export type AuthorVideoScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorVideoScore'] = ResolversParentTypes['AuthorVideoScore']> = {
  confidence?: Resolver<Maybe<ResolversTypes['ScoreConfidence']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rating?: Resolver<Maybe<ResolversTypes['VideoRating']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  video?: Resolver<ResolversTypes['Video'], ParentType, ContextType>;
};

export type BindFeedbackTokensMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BindFeedbackTokensMessage'] = ResolversParentTypes['BindFeedbackTokensMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  triggerSnapshotId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlobMigrationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlobMigrationResult'] = ResolversParentTypes['BlobMigrationResult']> = {
  collection?: Resolver<ResolversTypes['BlobMigrationCollection'], ParentType, ContextType>;
  errors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  finished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  migrated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scanned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type BullmqJobEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BullmqJobEntry'] = ResolversParentTypes['BullmqJobEntry']> = {
  attempts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataJson?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  failedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progressJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnValueJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['BullmqJobState'], ParentType, ContextType>;
};

export type BullmqQueueConcurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BullmqQueueConcurrency'] = ResolversParentTypes['BullmqQueueConcurrency']> = {
  concurrency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BullmqWorkerResolvers<ContextType = any, ParentType extends ResolversParentTypes['BullmqWorker'] = ResolversParentTypes['BullmqWorker']> = {
  activeJobs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  addr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ageSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  idleSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queueName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BullmqWorkersSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['BullmqWorkersSnapshot'] = ResolversParentTypes['BullmqWorkersSnapshot']> = {
  concurrencyByQueue?: Resolver<Array<ResolversTypes['BullmqQueueConcurrency']>, ParentType, ContextType>;
  concurrencyPerWorker?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rateLimitDurationMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rateLimitMax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalActiveJobs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalWorkers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  workers?: Resolver<Array<ResolversTypes['BullmqWorker']>, ParentType, ContextType>;
};

export type ChannelCorrectiveActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelCorrectiveAction'] = ResolversParentTypes['ChannelCorrectiveAction']> = {
  algorithmVersion?: Resolver<Maybe<ResolversTypes['CorrectiveActionAlgorithmVersion']>, ParentType, ContextType>;
  appliedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  autoApplyEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['Author'], ParentType, ContextType>;
  channelScore?: Resolver<ResolversTypes['AuthorAggregateScore'], ParentType, ContextType>;
  confidence?: Resolver<Maybe<ResolversTypes['ScoreConfidence']>, ParentType, ContextType>;
  confidenceReason?: Resolver<Maybe<ResolversTypes['ConfidenceReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  evaluatedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['CorrectiveActionEvent']>>, ParentType, ContextType>;
  evidenceFingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedbackTokens?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['CorrectiveActionKind'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['CorrectiveActionSeverity']>, ParentType, ContextType>;
  skipUntil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceVideoIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CorrectiveActionStatus'], ParentType, ContextType>;
  takenAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  takenBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenStatus?: Resolver<ResolversTypes['TokenStatus'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['CorrectiveActionTrigger'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CorrectiveActionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChannelEvolutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelEvolution'] = ResolversParentTypes['ChannelEvolution']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  changeLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spark?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  tone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ChannelFeedbackQualityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelFeedbackQuality'] = ResolversParentTypes['ChannelFeedbackQuality']> = {
  bad?: Resolver<Array<ResolversTypes['ChannelFeedbackRow']>, ParentType, ContextType>;
  badCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  good?: Resolver<Array<ResolversTypes['ChannelFeedbackRow']>, ParentType, ContextType>;
  goodCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tbd?: Resolver<Array<ResolversTypes['ChannelFeedbackRow']>, ParentType, ContextType>;
  tbdCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ChannelFeedbackRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChannelFeedbackRow'] = ResolversParentTypes['ChannelFeedbackRow']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  channelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channelName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  followed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  netScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  noVotes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipVotes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yesVotes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ChatCompletionAssistantMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionAssistantMessageParam'] = ResolversParentTypes['ChatCompletionAssistantMessageParam']> = {
  audio?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  function_call?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refusal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tool_calls?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatCompletionChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionChoice'] = ResolversParentTypes['ChatCompletionChoice']> = {
  finish_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  index?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  logprobs?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['ChatCompletionMessage'], ParentType, ContextType>;
};

export type ChatCompletionCreateParamsBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionCreateParamsBase'] = ResolversParentTypes['ChatCompletionCreateParamsBase']> = {
  audio?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  frequency_penalty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  function_call?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  functions?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  logit_bias?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  logprobs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  max_completion_tokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ChatCompletionMessageParam']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  modalities?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  n?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parallel_tool_calls?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  prediction?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  presence_penalty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  prompt_cache_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasoning_effort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  response_format?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  safety_identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  service_tier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stop?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  store?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stream?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stream_options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tool_choice?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  tools?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  top_logprobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  top_p?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verbosity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  web_search_options?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type ChatCompletionDeveloperMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionDeveloperMessageParam'] = ResolversParentTypes['ChatCompletionDeveloperMessageParam']> = {
  content?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatCompletionFunctionMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionFunctionMessageParam'] = ResolversParentTypes['ChatCompletionFunctionMessageParam']> = {
  content?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatCompletionMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionMessage'] = ResolversParentTypes['ChatCompletionMessage']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  function_call?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  refusal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tool_calls?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
};

export type ChatCompletionMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionMessageParam'] = ResolversParentTypes['ChatCompletionMessageParam']> = {
  __resolveType: TypeResolveFn<'ChatCompletionAssistantMessageParam' | 'ChatCompletionDeveloperMessageParam' | 'ChatCompletionFunctionMessageParam' | 'ChatCompletionSystemMessageParam' | 'ChatCompletionToolMessageParam' | 'ChatCompletionUserMessageParam', ParentType, ContextType>;
};

export type ChatCompletionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionResponse'] = ResolversParentTypes['ChatCompletionResponse']> = {
  choices?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  object?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  system_fingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usage?: Resolver<Maybe<ResolversTypes['ChatCompletionUsage']>, ParentType, ContextType>;
};

export type ChatCompletionSystemMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionSystemMessageParam'] = ResolversParentTypes['ChatCompletionSystemMessageParam']> = {
  content?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatCompletionToolMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionToolMessageParam'] = ResolversParentTypes['ChatCompletionToolMessageParam']> = {
  content?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tool_call_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatCompletionUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionUsage'] = ResolversParentTypes['ChatCompletionUsage']> = {
  completion_tokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  completion_tokens_details?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  prompt_tokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prompt_tokens_details?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  total_tokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ChatCompletionUserMessageParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCompletionUserMessageParam'] = ResolversParentTypes['ChatCompletionUserMessageParam']> = {
  content?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CollectionFirestoreCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CollectionFirestoreCount'] = ResolversParentTypes['CollectionFirestoreCount']> = {
  collection?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  writes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ControlHeartbeatSessionsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlHeartbeatSessionsMessage'] = ResolversParentTypes['ControlHeartbeatSessionsMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSendInsightNotificationsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSendInsightNotificationsMessage'] = ResolversParentTypes['ControlSendInsightNotificationsMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepChannelMarksMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepChannelMarksMessage'] = ResolversParentTypes['ControlSweepChannelMarksMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepChannelRescoresMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepChannelRescoresMessage'] = ResolversParentTypes['ControlSweepChannelRescoresMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepEvaluateChannelMarksMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepEvaluateChannelMarksMessage'] = ResolversParentTypes['ControlSweepEvaluateChannelMarksMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepEvaluateVideoMarksMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepEvaluateVideoMarksMessage'] = ResolversParentTypes['ControlSweepEvaluateVideoMarksMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepProfileChannelOverlayMarksMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepProfileChannelOverlayMarksMessage'] = ResolversParentTypes['ControlSweepProfileChannelOverlayMarksMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepProfileMarksMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepProfileMarksMessage'] = ResolversParentTypes['ControlSweepProfileMarksMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepReevaluateAllMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepReevaluateAllMessage'] = ResolversParentTypes['ControlSweepReevaluateAllMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepRetryStuckActionsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepRetryStuckActionsMessage'] = ResolversParentTypes['ControlSweepRetryStuckActionsMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepReviewInboxMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepReviewInboxMessage'] = ResolversParentTypes['ControlSweepReviewInboxMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepStaleAlgorithmVersionMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepStaleAlgorithmVersionMessage'] = ResolversParentTypes['ControlSweepStaleAlgorithmVersionMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlSweepSubscriptionsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlSweepSubscriptionsMessage'] = ResolversParentTypes['ControlSweepSubscriptionsMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CookieResolvers<ContextType = any, ParentType extends ResolversParentTypes['Cookie'] = ResolversParentTypes['Cookie']> = {
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CorrectiveActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorrectiveAction'] = ResolversParentTypes['CorrectiveAction']> = {
  __resolveType: TypeResolveFn<'ChannelCorrectiveAction' | 'FeedCorrectiveAction' | 'VideoCorrectiveAction', ParentType, ContextType>;
};

export type CorrectiveActionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorrectiveActionEvent'] = ResolversParentTypes['CorrectiveActionEvent']> = {
  actionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  actor?: Resolver<ResolversTypes['CorrectiveActionEventActor'], ParentType, ContextType>;
  at?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  edgeTaskId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event?: Resolver<ResolversTypes['CorrectiveActionEventKind'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenUsed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  undoToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CorrectiveActionStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorrectiveActionStats'] = ResolversParentTypes['CorrectiveActionStats']> = {
  channelAnalysisTriggered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dontRecommendChannel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  notInterested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recentlyRecommended?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recentlyTaken?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscribe?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDismissed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalFailed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalRecommended?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalTaken?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  undoActions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userFeedbackTriggered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userTriggered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videoAnalysisTriggered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CorrectiveActionUnionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CorrectiveActionUnion'] = ResolversParentTypes['CorrectiveActionUnion']> = {
  __resolveType: TypeResolveFn<'ChannelCorrectiveAction' | 'FeedCorrectiveAction' | 'VideoCorrectiveAction', ParentType, ContextType>;
};

export type CostByAgentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CostByAgent'] = ResolversParentTypes['CostByAgent']> = {
  callCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  costUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CostByModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['CostByModel'] = ResolversParentTypes['CostByModel']> = {
  callCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  costUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CostDailyBucketResolvers<ContextType = any, ParentType extends ResolversParentTypes['CostDailyBucket'] = ResolversParentTypes['CostDailyBucket']> = {
  callCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  costUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CostEstimateInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CostEstimateInfo'] = ResolversParentTypes['CostEstimateInfo']> = {
  inputCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pricingDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type CreateFeedTaskResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFeedTaskResult'] = ResolversParentTypes['CreateFeedTaskResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CreateInviteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInviteResult'] = ResolversParentTypes['CreateInviteResult']> = {
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smsSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CriterionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Criterion'] = ResolversParentTypes['Criterion']> = {
  measure?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reasoning?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DailyFeedStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailyFeedStats'] = ResolversParentTypes['DailyFeedStats']> = {
  averageScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  processedVideos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
  scoreDistribution?: Resolver<ResolversTypes['ScoreDistribution'], ParentType, ContextType>;
  videosProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosScoredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type DailyHistoryStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailyHistoryStats'] = ResolversParentTypes['DailyHistoryStats']> = {
  averageDurationPerVideo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  processedVideos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
  scoreDistribution?: Resolver<ResolversTypes['ScoreDistribution'], ParentType, ContextType>;
  totalDurationWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosScoredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type DailyObjectionableStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailyObjectionableStats'] = ResolversParentTypes['DailyObjectionableStats']> = {
  objectionableVideosRecommended?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectionableVideosWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recommendedObjectionableVideos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
  watchedObjectionableVideos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
};

export type DailyScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailyScore'] = ResolversParentTypes['DailyScore']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type DateRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateRange'] = ResolversParentTypes['DateRange']> = {
  endDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DeleteEdgeTaskResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteEdgeTaskResult'] = ResolversParentTypes['DeleteEdgeTaskResult']> = {
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type DeleteEdgeTasksResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteEdgeTasksResult'] = ResolversParentTypes['DeleteEdgeTasksResult']> = {
  deleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type DesktopHeartbeatResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DesktopHeartbeatResult'] = ResolversParentTypes['DesktopHeartbeatResult']> = {
  acceptedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type DeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']> = {
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registeredAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscribedProfileIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DeviceGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceGrant'] = ResolversParentTypes['DeviceGrant']> = {
  expiresAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DevicePairingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicePairing'] = ResolversParentTypes['DevicePairing']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pairingId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type DevicePairingClaimResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicePairingClaimResult'] = ResolversParentTypes['DevicePairingClaimResult']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type DevicePairingStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicePairingStatus'] = ResolversParentTypes['DevicePairingStatus']> = {
  grant?: Resolver<Maybe<ResolversTypes['DeviceGrant']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EdgeProfileStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EdgeProfileStats'] = ResolversParentTypes['EdgeProfileStats']> = {
  feedEnrichingPct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flagged7d?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  historyEnrichingPct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pendingDecisions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  topChannel7d?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topChannel7dCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videos7d?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosToday?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type EdgeQueueTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['EdgeQueueTask'] = ResolversParentTypes['EdgeQueueTask']> = {
  claimedByDeviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  executedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extractionJobId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failureMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failureReason?: Resolver<Maybe<ResolversTypes['TaskFailureReason']>, ParentType, ContextType>;
  failureStage?: Resolver<Maybe<ResolversTypes['TaskFailureStage']>, ParentType, ContextType>;
  handledVia?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  maxRetries?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parserVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['TaskResult']>, ParentType, ContextType>;
  retryCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['TaskState'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EdgeQueueTaskType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EdgeRecentWatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['EdgeRecentWatch'] = ResolversParentTypes['EdgeRecentWatch']> = {
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  watchedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EnqueueJobResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnqueueJobResult'] = ResolversParentTypes['EnqueueJobResult']> = {
  jobId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type EvalAgentEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalAgentEntry'] = ResolversParentTypes['EvalAgentEntry']> = {
  dataRequirement?: Resolver<ResolversTypes['DataRequirement'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  max_age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  min_age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scoreDirection?: Resolver<ResolversTypes['ScoreDirection'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  summarizationNeed?: Resolver<Maybe<ResolversTypes['SummarizationNeed']>, ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
  triggers?: Resolver<Maybe<ResolversTypes['AgentTriggers']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgentType'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvalFieldAccuracyResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalFieldAccuracy'] = ResolversParentTypes['EvalFieldAccuracy']> = {
  rating?: Resolver<ResolversTypes['EvalFieldCategoricalAccuracy'], ParentType, ContextType>;
  restricted?: Resolver<ResolversTypes['EvalFieldCategoricalAccuracy'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['EvalFieldScoreAccuracy'], ParentType, ContextType>;
};

export type EvalFieldCategoricalAccuracyResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalFieldCategoricalAccuracy'] = ResolversParentTypes['EvalFieldCategoricalAccuracy']> = {
  correct?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type EvalFieldScoreAccuracyResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalFieldScoreAccuracy'] = ResolversParentTypes['EvalFieldScoreAccuracy']> = {
  avgContribution?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  avgDistance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type EvalReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalReport'] = ResolversParentTypes['EvalReport']> = {
  agentSpec?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  agentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldAccuracy?: Resolver<ResolversTypes['EvalFieldAccuracy'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overallScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  passedCases?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  promptVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ranAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  totalCases?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalTokenUsage?: Resolver<ResolversTypes['TokenUsageInfo'], ParentType, ContextType>;
};

export type EvalTestCaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvalTestCase'] = ResolversParentTypes['EvalTestCase']> = {
  addedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expected?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvaluateChannelActionsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvaluateChannelActionsMessage'] = ResolversParentTypes['EvaluateChannelActionsMessage']> = {
  authorId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EvaluateProfileActionsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvaluateProfileActionsMessage'] = ResolversParentTypes['EvaluateProfileActionsMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EvaluateVideoActionsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvaluateVideoActionsMessage'] = ResolversParentTypes['EvaluateVideoActionsMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EvidenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Evidence'] = ResolversParentTypes['Evidence']> = {
  factorSummary?: Resolver<Maybe<Array<ResolversTypes['EvidenceFactorSummary']>>, ParentType, ContextType>;
  oneLine?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preview?: Resolver<ResolversTypes['EvidencePreview'], ParentType, ContextType>;
  scoring?: Resolver<Maybe<ResolversTypes['EvidenceScoring']>, ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['EvidenceVideo']>, ParentType, ContextType>;
};

export type EvidenceFactorResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvidenceFactor'] = ResolversParentTypes['EvidenceFactor']> = {
  contribution?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type EvidenceFactorSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvidenceFactorSummary'] = ResolversParentTypes['EvidenceFactorSummary']> = {
  avgScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lowCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type EvidencePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvidencePreview'] = ResolversParentTypes['EvidencePreview']> = {
  bullets?: Resolver<Array<ResolversTypes['EvidencePreviewBullet']>, ParentType, ContextType>;
  headline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reversibleNote?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvidencePreviewBulletResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvidencePreviewBullet'] = ResolversParentTypes['EvidencePreviewBullet']> = {
  kind?: Resolver<ResolversTypes['PreviewKind'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EvidenceScoringResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvidenceScoring'] = ResolversParentTypes['EvidenceScoring']> = {
  confidencePct?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['ThresholdDirection'], ParentType, ContextType>;
  factors?: Resolver<Array<ResolversTypes['EvidenceFactor']>, ParentType, ContextType>;
  finalScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  modelVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type EvidenceVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvidenceVideo'] = ResolversParentTypes['EvidenceVideo']> = {
  aiRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mins?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parentVerdict?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transcriptBacked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  watched?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ExecutedActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutedAction'] = ResolversParentTypes['ExecutedAction']> = {
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metricsDelta?: Resolver<Maybe<ResolversTypes['ActionMetrics']>, ParentType, ContextType>;
  occurredAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  outcome?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['SuggestionTarget'], ParentType, ContextType>;
  verb?: Resolver<ResolversTypes['SuggestionVerb'], ParentType, ContextType>;
  voteId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type FeedCorrectiveActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedCorrectiveAction'] = ResolversParentTypes['FeedCorrectiveAction']> = {
  algorithmVersion?: Resolver<Maybe<ResolversTypes['CorrectiveActionAlgorithmVersion']>, ParentType, ContextType>;
  appliedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  autoApplyEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confidence?: Resolver<Maybe<ResolversTypes['ScoreConfidence']>, ParentType, ContextType>;
  confidenceReason?: Resolver<Maybe<ResolversTypes['ConfidenceReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  evaluatedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['CorrectiveActionEvent']>>, ParentType, ContextType>;
  evidenceFingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedbackTokens?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['CorrectiveActionKind'], ParentType, ContextType>;
  lastAppliedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reapplyCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['CorrectiveActionSeverity']>, ParentType, ContextType>;
  skipUntil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceVideoIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CorrectiveActionStatus'], ParentType, ContextType>;
  takenAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  takenBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenStatus?: Resolver<ResolversTypes['TokenStatus'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['CorrectiveActionTrigger'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CorrectiveActionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeedVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedVideo'] = ResolversParentTypes['FeedVideo']> = {
  author?: Resolver<ResolversTypes['Author'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_live?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_watched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommended_on?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  snapshot_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transcript?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  view_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watch_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FeedbackLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedbackLog'] = ResolversParentTypes['FeedbackLog']> = {
  agent?: Resolver<ResolversTypes['AgentId'], ParentType, ContextType>;
  agentScoreId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  agreement?: Resolver<Maybe<ResolversTypes['AgreementType']>, ParentType, ContextType>;
  authorId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['ScoreKind'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreDirection?: Resolver<ResolversTypes['ScoreDirection'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgentType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeedbackTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedbackToken'] = ResolversParentTypes['FeedbackToken']> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  undoToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FeedbackTokensResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedbackTokens'] = ResolversParentTypes['FeedbackTokens']> = {
  dontRecommendChannel?: Resolver<ResolversTypes['FeedbackToken'], ParentType, ContextType>;
  notInterested?: Resolver<ResolversTypes['FeedbackToken'], ParentType, ContextType>;
};

export type FetchTranscriptMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FetchTranscriptMessage'] = ResolversParentTypes['FetchTranscriptMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirebaseUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirebaseUser'] = ResolversParentTypes['FirebaseUser']> = {
  accounts?: Resolver<Maybe<Array<ResolversTypes['LinkedAccount']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  welcomeState?: Resolver<Maybe<ResolversTypes['WelcomeState']>, ParentType, ContextType>;
};

export type GatedContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['GatedContext'] = ResolversParentTypes['GatedContext']> = {
  selectionDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selectionReason?: Resolver<ResolversTypes['SpecialistSelectionReason'], ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type GenerateCorrectiveActionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCorrectiveActionsResult'] = ResolversParentTypes['GenerateCorrectiveActionsResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GuardianGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuardianGroup'] = ResolversParentTypes['GuardianGroup']> = {
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['GuardianGroupMember']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameIsCustom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  profiles?: Resolver<Array<ResolversTypes['YouTubeProfile']>, ParentType, ContextType>;
};

export type GuardianGroupMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuardianGroupMember'] = ResolversParentTypes['GuardianGroupMember']> = {
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSelf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type HarvestedFeedbackTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['HarvestedFeedbackToken'] = ResolversParentTypes['HarvestedFeedbackToken']> = {
  channelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feedbackTokens?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type HistoryScoresOverTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoryScoresOverTime'] = ResolversParentTypes['HistoryScoresOverTime']> = {
  dailyScores?: Resolver<Array<ResolversTypes['DailyScore']>, ParentType, ContextType>;
  weeklyScores?: Resolver<Array<ResolversTypes['WeeklyScore']>, ParentType, ContextType>;
};

export type HistoryVideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoryVideo'] = ResolversParentTypes['HistoryVideo']> = {
  author?: Resolver<ResolversTypes['Author'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_live?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_watched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snapshot_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transcript?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  view_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watch_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watch_date_header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watched_on?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type HomeCaughtItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeCaughtItem'] = ResolversParentTypes['HomeCaughtItem']> = {
  outcome?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verb?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type HomeCaughtSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeCaughtSummary'] = ResolversParentTypes['HomeCaughtSummary']> = {
  channelsAutoBlocked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  flagged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shortsHidden?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type HomeScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeScore'] = ResolversParentTypes['HomeScore']> = {
  delta?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scoredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  watchedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type HomeTopChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeTopChannel'] = ResolversParentTypes['HomeTopChannel']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flaggedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minutesThisWeek?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type HomeWeeklyImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeWeeklyImpact'] = ResolversParentTypes['HomeWeeklyImpact']> = {
  caught?: Resolver<Maybe<Array<ResolversTypes['HomeCaughtItem']>>, ParentType, ContextType>;
  prevWeekQualityPct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qualityWatchPct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  weeklySparkline?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
};

export type ImpactAchievementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactAchievement'] = ResolversParentTypes['ImpactAchievement']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iconKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ImpactSummaryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImpactSummaryResult'] = ResolversParentTypes['ImpactSummaryResult']> = {
  achievements?: Resolver<Array<ResolversTypes['ImpactAchievement']>, ParentType, ContextType>;
  baselinePct?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cleanBaselinePct?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cleanDelta?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cleanPct?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  closingLine?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  flaggedThisWeek?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  highQualityDelta?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  highQualityPct?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  kidName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IngestAckFeedMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestAckFeedMessage'] = ResolversParentTypes['IngestAckFeedMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskResult?: Resolver<ResolversTypes['TaskResult'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestAckGenericMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestAckGenericMessage'] = ResolversParentTypes['IngestAckGenericMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskResult?: Resolver<ResolversTypes['TaskResult'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestAckHistoryMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestAckHistoryMessage'] = ResolversParentTypes['IngestAckHistoryMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskResult?: Resolver<ResolversTypes['TaskResult'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestAckRelatedMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestAckRelatedMessage'] = ResolversParentTypes['IngestAckRelatedMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskResult?: Resolver<ResolversTypes['TaskResult'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestAckTranscriptMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestAckTranscriptMessage'] = ResolversParentTypes['IngestAckTranscriptMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskResult?: Resolver<ResolversTypes['TaskResult'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestReparseMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestReparseMessage'] = ResolversParentTypes['IngestReparseMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dryRun?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvitePreview'] = ResolversParentTypes['InvitePreview']> = {
  expiresAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  invitedByName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profiles?: Resolver<Array<ResolversTypes['YouTubeProfile']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['InviteSource']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type KidProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['KidProfile'] = ResolversParentTypes['KidProfile']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bannerBody?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bannerHeadline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  flagged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  greatFit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initial?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastSyncedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewItems?: Resolver<Array<ResolversTypes['KidProfileReviewItem']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type KidProfileReviewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['KidProfileReviewItem'] = ResolversParentTypes['KidProfileReviewItem']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LlmCostSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LLMCostSummary'] = ResolversParentTypes['LLMCostSummary']> = {
  byAgent?: Resolver<Array<ResolversTypes['CostByAgent']>, ParentType, ContextType>;
  byModel?: Resolver<Array<ResolversTypes['CostByModel']>, ParentType, ContextType>;
  callCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  daily?: Resolver<Array<ResolversTypes['CostDailyBucket']>, ParentType, ContextType>;
  generatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  since?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCostUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  until?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LlmRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['LLMRequest'] = ResolversParentTypes['LLMRequest']> = {
  messages?: Resolver<Array<ResolversTypes['ChatCompletionMessageParam']>, ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tools?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type LlmUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['LLMUsage'] = ResolversParentTypes['LLMUsage']> = {
  completionTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  promptTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type LanguageFactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LanguageFacts'] = ResolversParentTypes['LanguageFacts']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  secondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['LanguageSource'], ParentType, ContextType>;
};

export type LinkedAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedAccount'] = ResolversParentTypes['LinkedAccount']> = {
  linkedAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  _empty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ackTask?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAckTaskArgs, 'result' | 'taskId'>>;
  addEvalTestCase?: Resolver<ResolversTypes['EvalTestCase'], ParentType, ContextType, RequireFields<MutationAddEvalTestCaseArgs, 'input'>>;
  adminDeleteSession?: Resolver<ResolversTypes['AdminDeleteSessionResult'], ParentType, ContextType, RequireFields<MutationAdminDeleteSessionArgs, 'sessionId'>>;
  adminPurgeProfile?: Resolver<ResolversTypes['AdminPurgeProfileResult'], ParentType, ContextType, RequireFields<MutationAdminPurgeProfileArgs, 'profileId'>>;
  adminRecomputeCorrectiveActions?: Resolver<ResolversTypes['AdminRecomputeCorrectiveActionsResult'], ParentType, ContextType, RequireFields<MutationAdminRecomputeCorrectiveActionsArgs, 'profileId'>>;
  adminRerunScoringPipeline?: Resolver<ResolversTypes['AdminRerunScoringPipelineResult'], ParentType, ContextType, RequireFields<MutationAdminRerunScoringPipelineArgs, 'sourceTaskId'>>;
  adminResetAllVideoScores?: Resolver<ResolversTypes['AdminResetAllVideoScoresResult'], ParentType, ContextType>;
  adminResetAllVideoSummaries?: Resolver<ResolversTypes['AdminResetAllVideoSummariesResult'], ParentType, ContextType>;
  adminResetVideoScores?: Resolver<ResolversTypes['AdminResetVideoScoresResult'], ParentType, ContextType, RequireFields<MutationAdminResetVideoScoresArgs, 'videoIds'>>;
  adminResetVideoSummary?: Resolver<ResolversTypes['AdminResetVideoSummaryResult'], ParentType, ContextType, RequireFields<MutationAdminResetVideoSummaryArgs, 'videoId'>>;
  adminRunPipelineEval?: Resolver<ResolversTypes['AdminEnqueuePipelineEvalResult'], ParentType, ContextType, RequireFields<MutationAdminRunPipelineEvalArgs, 'input'>>;
  adminSeedClaudeAuthoredPrompts?: Resolver<ResolversTypes['AdminSeedPromptsResult'], ParentType, ContextType>;
  adminSweepProfileSessions?: Resolver<ResolversTypes['AdminSweepProfileSessionsResult'], ParentType, ContextType, RequireFields<MutationAdminSweepProfileSessionsArgs, 'profileId' | 'states'>>;
  adminTestAgentScoring?: Resolver<ResolversTypes['AdminScoringTestResult'], ParentType, ContextType, RequireFields<MutationAdminTestAgentScoringArgs, 'agent' | 'videoId'>>;
  adminTestInsightNotification?: Resolver<ResolversTypes['AdminInsightTestResult'], ParentType, ContextType, RequireFields<MutationAdminTestInsightNotificationArgs, 'profileId'>>;
  applyAllCorrectiveActions?: Resolver<ResolversTypes['ApplyCorrectiveActionResult'], ParentType, ContextType, RequireFields<MutationApplyAllCorrectiveActionsArgs, 'profileId'>>;
  applyCorrectiveAction?: Resolver<ResolversTypes['ApplyCorrectiveActionResult'], ParentType, ContextType, RequireFields<MutationApplyCorrectiveActionArgs, 'input'>>;
  applySuggestion?: Resolver<ResolversTypes['ApplySuggestionResult'], ParentType, ContextType, RequireFields<MutationApplySuggestionArgs, 'suggestionId'>>;
  cancelBullmqJob?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCancelBullmqJobArgs, 'jobId'>>;
  claimDevicePairing?: Resolver<ResolversTypes['DevicePairingClaimResult'], ParentType, ContextType, RequireFields<MutationClaimDevicePairingArgs, 'code'>>;
  createCoparentInvite?: Resolver<ResolversTypes['CreateInviteResult'], ParentType, ContextType, Partial<MutationCreateCoparentInviteArgs>>;
  createDesktopInvite?: Resolver<ResolversTypes['CreateInviteResult'], ParentType, ContextType, Partial<MutationCreateDesktopInviteArgs>>;
  createFeedTask?: Resolver<ResolversTypes['CreateFeedTaskResult'], ParentType, ContextType, RequireFields<MutationCreateFeedTaskArgs, 'sessionId'>>;
  createGuardianGroup?: Resolver<ResolversTypes['GuardianGroup'], ParentType, ContextType, Partial<MutationCreateGuardianGroupArgs>>;
  createSession?: Resolver<ResolversTypes['UserSession'], ParentType, ContextType, RequireFields<MutationCreateSessionArgs, 'cookies'>>;
  deleteAgentPrompt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAgentPromptArgs, 'id' | 'kind' | 'version'>>;
  deleteEdgeTask?: Resolver<ResolversTypes['DeleteEdgeTaskResult'], ParentType, ContextType, RequireFields<MutationDeleteEdgeTaskArgs, 'taskId'>>;
  deleteEdgeTasks?: Resolver<ResolversTypes['DeleteEdgeTasksResult'], ParentType, ContextType, RequireFields<MutationDeleteEdgeTasksArgs, 'limit'>>;
  deleteEdgeTasksByIds?: Resolver<ResolversTypes['DeleteEdgeTasksResult'], ParentType, ContextType, RequireFields<MutationDeleteEdgeTasksByIdsArgs, 'taskIds'>>;
  deleteEvalReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEvalReportArgs, 'id'>>;
  deleteEvalTestCase?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteEvalTestCaseArgs, 'id'>>;
  desktopHeartbeat?: Resolver<ResolversTypes['DesktopHeartbeatResult'], ParentType, ContextType, RequireFields<MutationDesktopHeartbeatArgs, 'profiles'>>;
  dismissCorrectiveAction?: Resolver<ResolversTypes['ApplyCorrectiveActionResult'], ParentType, ContextType, RequireFields<MutationDismissCorrectiveActionArgs, 'actionId'>>;
  dismissSuggestion?: Resolver<ResolversTypes['Suggestion'], ParentType, ContextType, RequireFields<MutationDismissSuggestionArgs, 'suggestionId'>>;
  evolveAgentPrompt?: Resolver<ResolversTypes['EnqueueJobResult'], ParentType, ContextType, RequireFields<MutationEvolveAgentPromptArgs, 'input'>>;
  flagSuggestionWrong?: Resolver<ResolversTypes['Suggestion'], ParentType, ContextType, RequireFields<MutationFlagSuggestionWrongArgs, 'suggestionId'>>;
  forkAgentPrompt?: Resolver<ResolversTypes['AgentPromptEntry'], ParentType, ContextType, RequireFields<MutationForkAgentPromptArgs, 'fromVersion' | 'id' | 'kind'>>;
  generateCorrectiveActions?: Resolver<ResolversTypes['GenerateCorrectiveActionsResult'], ParentType, ContextType, RequireFields<MutationGenerateCorrectiveActionsArgs, 'input'>>;
  linkSessionToUser?: Resolver<ResolversTypes['SessionLinkResult'], ParentType, ContextType, RequireFields<MutationLinkSessionToUserArgs, 'sessionToken'>>;
  markWelcomeStep?: Resolver<ResolversTypes['WelcomeState'], ParentType, ContextType, RequireFields<MutationMarkWelcomeStepArgs, 'step'>>;
  migrateLegacyBlobs?: Resolver<ResolversTypes['BlobMigrationResult'], ParentType, ContextType, RequireFields<MutationMigrateLegacyBlobsArgs, 'collection' | 'limit'>>;
  primeEdgeTasks?: Resolver<ResolversTypes['PrimeEdgeTasksResult'], ParentType, ContextType, RequireFields<MutationPrimeEdgeTasksArgs, 'profileIds'>>;
  redeemInviteAutoLogin?: Resolver<ResolversTypes['RedeemInviteResult'], ParentType, ContextType, RequireFields<MutationRedeemInviteAutoLoginArgs, 'token'>>;
  redeemInviteForCurrentUser?: Resolver<ResolversTypes['RedeemInviteResult'], ParentType, ContextType, RequireFields<MutationRedeemInviteForCurrentUserArgs, 'token'>>;
  refreshDeviceGrant?: Resolver<Maybe<ResolversTypes['DeviceGrant']>, ParentType, ContextType, RequireFields<MutationRefreshDeviceGrantArgs, 'token'>>;
  registerDevice?: Resolver<ResolversTypes['Device'], ParentType, ContextType, RequireFields<MutationRegisterDeviceArgs, 'input'>>;
  registerPushToken?: Resolver<ResolversTypes['Device'], ParentType, ContextType, RequireFields<MutationRegisterPushTokenArgs, 'platform' | 'token'>>;
  removeBullmqJobs?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationRemoveBullmqJobsArgs, 'states'>>;
  renameDevice?: Resolver<ResolversTypes['Device'], ParentType, ContextType, RequireFields<MutationRenameDeviceArgs, 'deviceId' | 'name'>>;
  renameGuardianGroup?: Resolver<ResolversTypes['GuardianGroup'], ParentType, ContextType, RequireFields<MutationRenameGuardianGroupArgs, 'groupId' | 'name'>>;
  reprocessLastTasks?: Resolver<ResolversTypes['ReprocessTasksBatchResult'], ParentType, ContextType, RequireFields<MutationReprocessLastTasksArgs, 'count' | 'taskType'>>;
  reprocessTask?: Resolver<ResolversTypes['ReprocessTaskResult'], ParentType, ContextType, RequireFields<MutationReprocessTaskArgs, 'taskId'>>;
  rescoreVideosAsync?: Resolver<ResolversTypes['EnqueueJobResult'], ParentType, ContextType, RequireFields<MutationRescoreVideosAsyncArgs, 'input'>>;
  resetEdgeTask?: Resolver<ResolversTypes['ResetEdgeTaskResult'], ParentType, ContextType, RequireFields<MutationResetEdgeTaskArgs, 'taskId'>>;
  resetEdgeTasksByIds?: Resolver<ResolversTypes['ResetEdgeTasksResult'], ParentType, ContextType, RequireFields<MutationResetEdgeTasksByIdsArgs, 'taskIds'>>;
  resetWelcomeSkip?: Resolver<ResolversTypes['WelcomeState'], ParentType, ContextType>;
  retractCorrectiveAction?: Resolver<ResolversTypes['RetractResult'], ParentType, ContextType, RequireFields<MutationRetractCorrectiveActionArgs, 'actionId'>>;
  retractVerdict?: Resolver<ResolversTypes['RetractResult'], ParentType, ContextType, RequireFields<MutationRetractVerdictArgs, 'profileId' | 'videoId'>>;
  retryAllFailedEdgeTaskExtractions?: Resolver<ResolversTypes['RetryAllFailedExtractionsResult'], ParentType, ContextType, RequireFields<MutationRetryAllFailedEdgeTaskExtractionsArgs, 'limit'>>;
  retryEdgeTaskExtraction?: Resolver<ResolversTypes['EnqueueJobResult'], ParentType, ContextType, RequireFields<MutationRetryEdgeTaskExtractionArgs, 'taskId'>>;
  retryFailedEdgeTaskExtractions?: Resolver<ResolversTypes['RetryFailedExtractionsResult'], ParentType, ContextType, RequireFields<MutationRetryFailedEdgeTaskExtractionsArgs, 'limit' | 'taskType'>>;
  runEval?: Resolver<ResolversTypes['EnqueueJobResult'], ParentType, ContextType, RequireFields<MutationRunEvalArgs, 'input'>>;
  runMultiModelEval?: Resolver<ResolversTypes['EnqueueJobResult'], ParentType, ContextType, RequireFields<MutationRunMultiModelEvalArgs, 'input'>>;
  saveAgentPrompt?: Resolver<ResolversTypes['AgentPromptEntry'], ParentType, ContextType, RequireFields<MutationSaveAgentPromptArgs, 'input'>>;
  scoreVideo?: Resolver<ResolversTypes['ScoreVideoResult'], ParentType, ContextType, RequireFields<MutationScoreVideoArgs, 'profileId' | 'verdict' | 'videoId'>>;
  seedEvalTestCasesFromScores?: Resolver<ResolversTypes['SeedTestCasesResult'], ParentType, ContextType, RequireFields<MutationSeedEvalTestCasesFromScoresArgs, 'count'>>;
  setGuardianDisplayName?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetGuardianDisplayNameArgs, 'name'>>;
  setGuardianTimezone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetGuardianTimezoneArgs, 'timezone'>>;
  setProfilePreferences?: Resolver<ResolversTypes['ProfilePreferences'], ParentType, ContextType, RequireFields<MutationSetProfilePreferencesArgs, 'input' | 'profileId'>>;
  skipCorrectiveAction?: Resolver<ResolversTypes['ApplyCorrectiveActionResult'], ParentType, ContextType, RequireFields<MutationSkipCorrectiveActionArgs, 'actionId' | 'skipDays'>>;
  skipWelcome?: Resolver<ResolversTypes['WelcomeState'], ParentType, ContextType>;
  snoozeSuggestion?: Resolver<ResolversTypes['Suggestion'], ParentType, ContextType, RequireFields<MutationSnoozeSuggestionArgs, 'days' | 'suggestionId'>>;
  startDevicePairing?: Resolver<ResolversTypes['DevicePairing'], ParentType, ContextType, RequireFields<MutationStartDevicePairingArgs, 'deviceType'>>;
  subscribeDeviceToProfile?: Resolver<ResolversTypes['Device'], ParentType, ContextType, RequireFields<MutationSubscribeDeviceToProfileArgs, 'deviceId' | 'profileId'>>;
  unlinkSessionFromUser?: Resolver<ResolversTypes['SessionLinkResult'], ParentType, ContextType, RequireFields<MutationUnlinkSessionFromUserArgs, 'sessionId'>>;
  unsubscribeDeviceFromProfile?: Resolver<ResolversTypes['Device'], ParentType, ContextType, RequireFields<MutationUnsubscribeDeviceFromProfileArgs, 'deviceId' | 'profileId'>>;
  updateEvalTestCase?: Resolver<ResolversTypes['EvalTestCase'], ParentType, ContextType, RequireFields<MutationUpdateEvalTestCaseArgs, 'id' | 'input'>>;
};

export type OpenRouterModelEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenRouterModelEntry'] = ResolversParentTypes['OpenRouterModelEntry']> = {
  contextLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inputPer1M?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outputPer1M?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PolicyAdjustmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyAdjustment'] = ResolversParentTypes['PolicyAdjustment']> = {
  ratingAfter?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
};

export type PoliticsFactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PoliticsFacts'] = ResolversParentTypes['PoliticsFacts']> = {
  confidence?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  detected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mode?: Resolver<Maybe<ResolversTypes['PoliticsMode']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['ContentSeverity']>, ParentType, ContextType>;
  stance?: Resolver<Maybe<ResolversTypes['PoliticsStance']>, ParentType, ContextType>;
};

export type PrimeEdgeTasksResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrimeEdgeTasksResult'] = ResolversParentTypes['PrimeEdgeTasksResult']> = {
  minted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profilesPrimed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ProcessFeedMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessFeedMessage'] = ResolversParentTypes['ProcessFeedMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceTaskId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessHistoryMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessHistoryMessage'] = ResolversParentTypes['ProcessHistoryMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceTaskId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfilePreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfilePreferences'] = ResolversParentTypes['ProfilePreferences']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  birthdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['ProfileGender']>, ParentType, ContextType>;
  languageList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  languagePolicyMode?: Resolver<ResolversTypes['LanguagePolicyMode'], ParentType, ContextType>;
  politicsPolicyMode?: Resolver<ResolversTypes['PoliticsPolicyMode'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  religionOwnFaith?: Resolver<Maybe<ResolversTypes['ReligionFaith']>, ParentType, ContextType>;
  religionPolicyMode?: Resolver<ResolversTypes['ReligionPolicyMode'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ProfileSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileSummary'] = ResolversParentTypes['ProfileSummary']> = {
  allTimeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  caughtSummary?: Resolver<Maybe<ResolversTypes['HomeCaughtSummary']>, ParentType, ContextType>;
  feedScore?: Resolver<Maybe<ResolversTypes['HomeScore']>, ParentType, ContextType>;
  historyScore?: Resolver<Maybe<ResolversTypes['HomeScore']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  queueCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queueEstMinutes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  streakDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  todayBorderline?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  todayFlagged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  todayMet?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  todayUnscored?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  todayWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  topChannels?: Resolver<Maybe<Array<ResolversTypes['HomeTopChannel']>>, ParentType, ContextType>;
  verbalWeeklyVerdict?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weekCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  weeklyImpact?: Resolver<Maybe<ResolversTypes['HomeWeeklyImpact']>, ParentType, ContextType>;
};

export type ProfileVideoVerdictResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileVideoVerdict'] = ResolversParentTypes['ProfileVideoVerdict']> = {
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  policyAdjustments?: Resolver<Array<ResolversTypes['PolicyAdjustment']>, ParentType, ContextType>;
  rating?: Resolver<ResolversTypes['VideoRating'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type ProfileWorkerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileWorker'] = ResolversParentTypes['ProfileWorker']> = {
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProgressActionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProgressActions'] = ResolversParentTypes['ProgressActions']> = {
  applied?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  approved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  channelsBlocked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  channelsFollowed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  shortsHidden?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosDownranked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ProgressTrendsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProgressTrends'] = ResolversParentTypes['ProgressTrends']> = {
  actions?: Resolver<Maybe<ResolversTypes['ProgressActions']>, ParentType, ContextType>;
  blocked?: Resolver<Array<ResolversTypes['ChannelEvolution']>, ParentType, ContextType>;
  feed?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  feedDelta?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feedNow?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  followed?: Resolver<Array<ResolversTypes['ChannelEvolution']>, ParentType, ContextType>;
  history?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  historyDelta?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  historyNow?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  narrative?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rangeLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weekLabels?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PromptResolvers<ContextType = any, ParentType extends ResolversParentTypes['Prompt'] = ResolversParentTypes['Prompt']> = {
  messages?: Resolver<Array<ResolversTypes['ChatCompletionMessageParam']>, ParentType, ContextType>;
};

export type QualityBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['QualityBreakdown'] = ResolversParentTypes['QualityBreakdown']> = {
  high?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  medium?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _empty?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityFeed?: Resolver<Array<ResolversTypes['ActivityEvent']>, ParentType, ContextType, RequireFields<QueryActivityFeedArgs, 'profileId'>>;
  adminInsightCandidates?: Resolver<ResolversTypes['AdminInsightCandidateList'], ParentType, ContextType, RequireFields<QueryAdminInsightCandidatesArgs, 'profileId'>>;
  adminReplayAccountInfo?: Resolver<Maybe<ResolversTypes['AdminAccountInfoReplay']>, ParentType, ContextType, RequireFields<QueryAdminReplayAccountInfoArgs, 'sessionId'>>;
  claimTranscriptionWork?: Resolver<Array<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType, RequireFields<QueryClaimTranscriptionWorkArgs, 'limit'>>;
  edgeProfileStats?: Resolver<ResolversTypes['EdgeProfileStats'], ParentType, ContextType, RequireFields<QueryEdgeProfileStatsArgs, 'profileId'>>;
  edgeRecentWatches?: Resolver<Array<ResolversTypes['EdgeRecentWatch']>, ParentType, ContextType, RequireFields<QueryEdgeRecentWatchesArgs, 'limit' | 'profileId'>>;
  estimateRescoreCost?: Resolver<ResolversTypes['RescoreCostEstimate'], ParentType, ContextType, Partial<QueryEstimateRescoreCostArgs>>;
  executedActions?: Resolver<Array<ResolversTypes['ExecutedAction']>, ParentType, ContextType, RequireFields<QueryExecutedActionsArgs, 'profileId'>>;
  getAdminCommandCenter?: Resolver<Maybe<ResolversTypes['AdminCommandCenter']>, ParentType, ContextType>;
  getAdminTasks?: Resolver<Array<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType, RequireFields<QueryGetAdminTasksArgs, 'limit'>>;
  getAdminVideoTranscript?: Resolver<Maybe<ResolversTypes['VideoTranscript']>, ParentType, ContextType, RequireFields<QueryGetAdminVideoTranscriptArgs, 'videoId'>>;
  getAgentAnalysisChatLog?: Resolver<Maybe<ResolversTypes['AgentAnalysisChatLog']>, ParentType, ContextType, RequireFields<QueryGetAgentAnalysisChatLogArgs, 'cache_llm_id'>>;
  getAgents?: Resolver<Array<ResolversTypes['Agent']>, ParentType, ContextType>;
  getAggregateScoreForAuthor?: Resolver<Maybe<ResolversTypes['AuthorAggregateScore']>, ParentType, ContextType, RequireFields<QueryGetAggregateScoreForAuthorArgs, 'authorId'>>;
  getAggregateScoreForVideo?: Resolver<Maybe<ResolversTypes['AgentAggregateScore']>, ParentType, ContextType, RequireFields<QueryGetAggregateScoreForVideoArgs, 'videoId'>>;
  getAggregateScoreForVideos?: Resolver<Array<ResolversTypes['AgentAggregateScore']>, ParentType, ContextType, RequireFields<QueryGetAggregateScoreForVideosArgs, 'videoIds'>>;
  getAllAgentScores?: Resolver<Array<ResolversTypes['AgentScore']>, ParentType, ContextType, Partial<QueryGetAllAgentScoresArgs>>;
  getAllFeedbackForVideo?: Resolver<Array<ResolversTypes['FeedbackLog']>, ParentType, ContextType, RequireFields<QueryGetAllFeedbackForVideoArgs, 'videoId'>>;
  getAllVideos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType, Partial<QueryGetAllVideosArgs>>;
  getAllYouTubeProfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['YouTubeProfile']>>>, ParentType, ContextType>;
  getAuthorAggregateScores?: Resolver<Array<ResolversTypes['AuthorAggregateScore']>, ParentType, ContextType, RequireFields<QueryGetAuthorAggregateScoresArgs, 'authorIds'>>;
  getAuthors?: Resolver<Array<ResolversTypes['Author']>, ParentType, ContextType, RequireFields<QueryGetAuthorsArgs, 'uid'>>;
  getBullmqJobsByIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['BullmqJobEntry']>>>, ParentType, ContextType, RequireFields<QueryGetBullmqJobsByIdsArgs, 'jobIds'>>;
  getBullmqWorkers?: Resolver<ResolversTypes['BullmqWorkersSnapshot'], ParentType, ContextType>;
  getCachedVideos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType, RequireFields<QueryGetCachedVideosArgs, 'videoIds'>>;
  getChannelFeedbackQuality?: Resolver<Maybe<ResolversTypes['ChannelFeedbackQuality']>, ParentType, ContextType, Partial<QueryGetChannelFeedbackQualityArgs>>;
  getCorrectiveActionEvents?: Resolver<Array<ResolversTypes['CorrectiveActionEvent']>, ParentType, ContextType, RequireFields<QueryGetCorrectiveActionEventsArgs, 'actionId' | 'limit'>>;
  getCorrectiveActionsFor?: Resolver<Array<ResolversTypes['CorrectiveActionUnion']>, ParentType, ContextType, RequireFields<QueryGetCorrectiveActionsForArgs, 'profileId'>>;
  getCurrentUser?: Resolver<Maybe<ResolversTypes['FirebaseUser']>, ParentType, ContextType>;
  getEdgeTask?: Resolver<Maybe<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType, RequireFields<QueryGetEdgeTaskArgs, 'taskId'>>;
  getEvalReport?: Resolver<Maybe<ResolversTypes['EvalReport']>, ParentType, ContextType, RequireFields<QueryGetEvalReportArgs, 'id'>>;
  getEvalReports?: Resolver<Array<ResolversTypes['EvalReport']>, ParentType, ContextType, Partial<QueryGetEvalReportsArgs>>;
  getEvalReportsForAgent?: Resolver<Array<ResolversTypes['EvalReport']>, ParentType, ContextType, RequireFields<QueryGetEvalReportsForAgentArgs, 'agentSpec'>>;
  getEvalTestCases?: Resolver<Array<ResolversTypes['EvalTestCase']>, ParentType, ContextType, Partial<QueryGetEvalTestCasesArgs>>;
  getFailedTasks?: Resolver<Array<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType, RequireFields<QueryGetFailedTasksArgs, 'limit'>>;
  getHighConfidenceBadChannels?: Resolver<Array<ResolversTypes['Author']>, ParentType, ContextType>;
  getHighScoreVideos?: Resolver<ResolversTypes['ScoredVideosResult'], ParentType, ContextType, RequireFields<QueryGetHighScoreVideosArgs, 'id' | 'limit' | 'threshold'>>;
  getHistoryScoresOverTime?: Resolver<ResolversTypes['HistoryScoresOverTime'], ParentType, ContextType, RequireFields<QueryGetHistoryScoresOverTimeArgs, 'id'>>;
  getLLMCostSummary?: Resolver<ResolversTypes['LLMCostSummary'], ParentType, ContextType, RequireFields<QueryGetLlmCostSummaryArgs, 'since' | 'until'>>;
  getLinkedAccounts?: Resolver<Maybe<Array<ResolversTypes['LinkedAccount']>>, ParentType, ContextType>;
  getLowScoreVideos?: Resolver<ResolversTypes['ScoredVideosResult'], ParentType, ContextType, RequireFields<QueryGetLowScoreVideosArgs, 'id' | 'limit' | 'threshold'>>;
  getMyDevices?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  getMyYouTubeProfiles?: Resolver<Maybe<Array<ResolversTypes['YouTubeProfile']>>, ParentType, ContextType>;
  getOneYouTubeProfileFeed?: Resolver<Array<ResolversTypes['FeedVideo']>, ParentType, ContextType, RequireFields<QueryGetOneYouTubeProfileFeedArgs, 'id'>>;
  getOneYouTubeProfileHistory?: Resolver<ResolversTypes['YoutubeHistorySnapshot'], ParentType, ContextType, RequireFields<QueryGetOneYouTubeProfileHistoryArgs, 'id'>>;
  getPendingCorrectiveActions?: Resolver<Array<ResolversTypes['CorrectiveActionUnion']>, ParentType, ContextType, RequireFields<QueryGetPendingCorrectiveActionsArgs, 'profileId'>>;
  getPipelineEvalRun?: Resolver<Maybe<ResolversTypes['AdminEvalPipelineResult']>, ParentType, ContextType, RequireFields<QueryGetPipelineEvalRunArgs, 'evalRunId'>>;
  getProfilePreferences?: Resolver<Maybe<ResolversTypes['ProfilePreferences']>, ParentType, ContextType, RequireFields<QueryGetProfilePreferencesArgs, 'profileId'>>;
  getProfileVideoVerdict?: Resolver<Maybe<ResolversTypes['ProfileVideoVerdict']>, ParentType, ContextType, RequireFields<QueryGetProfileVideoVerdictArgs, 'profileId' | 'videoId'>>;
  getScoresByAgent?: Resolver<Array<ResolversTypes['AgentScore']>, ParentType, ContextType, RequireFields<QueryGetScoresByAgentArgs, 'agent'>>;
  getScoresForVideo?: Resolver<Array<ResolversTypes['AgentScore']>, ParentType, ContextType, RequireFields<QueryGetScoresForVideoArgs, 'videoId'>>;
  getServiceHealth?: Resolver<Array<ResolversTypes['ServiceHealth']>, ParentType, ContextType>;
  getSessionCookiesForTask?: Resolver<Array<ResolversTypes['SessionCookie']>, ParentType, ContextType, RequireFields<QueryGetSessionCookiesForTaskArgs, 'taskId'>>;
  getSessionInfo?: Resolver<Maybe<ResolversTypes['UserSession']>, ParentType, ContextType, RequireFields<QueryGetSessionInfoArgs, 'sessionToken'>>;
  getTaskDebugInfo?: Resolver<Maybe<ResolversTypes['TaskDebugInfo']>, ParentType, ContextType, RequireFields<QueryGetTaskDebugInfoArgs, 'taskId'>>;
  getTaskResultRaw?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetTaskResultRawArgs, 'taskId'>>;
  getTasks?: Resolver<Array<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType, RequireFields<QueryGetTasksArgs, 'limit' | 'longPoll' | 'profileId'>>;
  getVideoLanguage?: Resolver<Maybe<ResolversTypes['LanguageFacts']>, ParentType, ContextType, RequireFields<QueryGetVideoLanguageArgs, 'videoId'>>;
  getVideoScoringStates?: Resolver<Array<ResolversTypes['VideoScoringState']>, ParentType, ContextType, RequireFields<QueryGetVideoScoringStatesArgs, 'videoIds'>>;
  getVideoStats?: Resolver<ResolversTypes['VideoStats'], ParentType, ContextType, RequireFields<QueryGetVideoStatsArgs, 'profileId'>>;
  getVideosWithScores?: Resolver<ResolversTypes['VideosWithScores'], ParentType, ContextType, RequireFields<QueryGetVideosWithScoresArgs, 'videoIds'>>;
  getWeeklyBuckets?: Resolver<ResolversTypes['WeeklyBuckets'], ParentType, ContextType, RequireFields<QueryGetWeeklyBucketsArgs, 'profileId'>>;
  getWorkerFirestoreStats?: Resolver<Array<ResolversTypes['WorkerFirestoreStatRow']>, ParentType, ContextType, RequireFields<QueryGetWorkerFirestoreStatsArgs, 'sinceHours'>>;
  getYouTubeProfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['YouTubeProfile']>>>, ParentType, ContextType, RequireFields<QueryGetYouTubeProfilesArgs, 'accountId'>>;
  impactSummary?: Resolver<ResolversTypes['ImpactSummaryResult'], ParentType, ContextType, RequireFields<QueryImpactSummaryArgs, 'profileId'>>;
  invitePreview?: Resolver<ResolversTypes['InvitePreview'], ParentType, ContextType, RequireFields<QueryInvitePreviewArgs, 'token'>>;
  kidProfile?: Resolver<Maybe<ResolversTypes['KidProfile']>, ParentType, ContextType, RequireFields<QueryKidProfileArgs, 'profileId'>>;
  listAgentPrompts?: Resolver<Array<ResolversTypes['AgentPromptEntry']>, ParentType, ContextType, Partial<QueryListAgentPromptsArgs>>;
  listBullmqJobs?: Resolver<Array<ResolversTypes['BullmqJobEntry']>, ParentType, ContextType, RequireFields<QueryListBullmqJobsArgs, 'limit'>>;
  listEvalAgents?: Resolver<Array<ResolversTypes['EvalAgentEntry']>, ParentType, ContextType>;
  listOpenRouterModels?: Resolver<Array<ResolversTypes['OpenRouterModelEntry']>, ParentType, ContextType>;
  myGuardianGroups?: Resolver<Array<ResolversTypes['GuardianGroup']>, ParentType, ContextType>;
  myVotes?: Resolver<Array<ResolversTypes['Vote']>, ParentType, ContextType, RequireFields<QueryMyVotesArgs, 'profileId'>>;
  pendingSuggestions?: Resolver<Array<ResolversTypes['Suggestion']>, ParentType, ContextType, RequireFields<QueryPendingSuggestionsArgs, 'profileId'>>;
  pollDevicePairing?: Resolver<ResolversTypes['DevicePairingStatus'], ParentType, ContextType, RequireFields<QueryPollDevicePairingArgs, 'pairingId'>>;
  previewReviewSelector?: Resolver<ResolversTypes['ReviewSelectorPreview'], ParentType, ContextType, RequireFields<QueryPreviewReviewSelectorArgs, 'input'>>;
  profileSummary?: Resolver<ResolversTypes['ProfileSummary'], ParentType, ContextType, RequireFields<QueryProfileSummaryArgs, 'profileId'>>;
  progressTrends?: Resolver<ResolversTypes['ProgressTrends'], ParentType, ContextType, RequireFields<QueryProgressTrendsArgs, 'profileId'>>;
  recentActivity?: Resolver<Array<ResolversTypes['ActivityRow']>, ParentType, ContextType, RequireFields<QueryRecentActivityArgs, 'profileId'>>;
  reviewCard?: Resolver<Maybe<ResolversTypes['ReviewQueueCard']>, ParentType, ContextType, RequireFields<QueryReviewCardArgs, 'profileId' | 'videoId'>>;
  reviewQueue?: Resolver<ResolversTypes['ReviewQueueResult'], ParentType, ContextType, RequireFields<QueryReviewQueueArgs, 'profileId'>>;
  suggestionByActionId?: Resolver<Maybe<ResolversTypes['Suggestion']>, ParentType, ContextType, RequireFields<QuerySuggestionByActionIdArgs, 'id'>>;
  videoAIReport?: Resolver<Maybe<ResolversTypes['ReviewQueueCard']>, ParentType, ContextType, RequireFields<QueryVideoAiReportArgs, 'profileId' | 'videoId'>>;
  videoFactorBreakdown?: Resolver<ResolversTypes['VideoFactorBreakdown'], ParentType, ContextType, RequireFields<QueryVideoFactorBreakdownArgs, 'videoId'>>;
  voteSummary?: Resolver<ResolversTypes['VoteSummary'], ParentType, ContextType, RequireFields<QueryVoteSummaryArgs, 'profileId'>>;
  waitlistEntries?: Resolver<Array<ResolversTypes['WaitlistEntry']>, ParentType, ContextType, RequireFields<QueryWaitlistEntriesArgs, 'limit'>>;
  weeklyImpact?: Resolver<ResolversTypes['WeeklyImpact'], ParentType, ContextType, RequireFields<QueryWeeklyImpactArgs, 'profileId'>>;
};

export type RedeemInviteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RedeemInviteResult'] = ResolversParentTypes['RedeemInviteResult']> = {
  customToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedProfileIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ReligionFactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReligionFacts'] = ResolversParentTypes['ReligionFacts']> = {
  confidence?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  detected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  faith?: Resolver<Maybe<ResolversTypes['ReligionFaith']>, ParentType, ContextType>;
  mode?: Resolver<Maybe<ResolversTypes['ReligionMode']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['ContentSeverity']>, ParentType, ContextType>;
};

export type ReprocessTaskResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReprocessTaskResult'] = ResolversParentTypes['ReprocessTaskResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType>;
};

export type ReprocessTasksBatchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReprocessTasksBatchResult'] = ResolversParentTypes['ReprocessTasksBatchResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tasks?: Resolver<Array<ResolversTypes['EdgeQueueTask']>, ParentType, ContextType>;
  tasksReprocessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type RescoreCostBreakdownRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['RescoreCostBreakdownRow'] = ResolversParentTypes['RescoreCostBreakdownRow']> = {
  avgCostUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  callsPerVideo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  estimatedCostUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RescoreCostEstimateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RescoreCostEstimate'] = ResolversParentTypes['RescoreCostEstimate']> = {
  breakdown?: Resolver<Array<ResolversTypes['RescoreCostBreakdownRow']>, ParentType, ContextType>;
  channelGatedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  estimatedCostUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  generatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  llmCallCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sampleSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type RescorePerAgentStatResolvers<ContextType = any, ParentType extends ResolversParentTypes['RescorePerAgentStat'] = ResolversParentTypes['RescorePerAgentStat']> = {
  cacheHits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  costUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  errors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scored?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  specialization?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  tokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RescoreVideosResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RescoreVideosResult'] = ResolversParentTypes['RescoreVideosResult']> = {
  cacheHits?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  durationMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  errors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  perAgent?: Resolver<Array<ResolversTypes['RescorePerAgentStat']>, ParentType, ContextType>;
  scoresCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scoresSkipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCostUSD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosConsidered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ResetEdgeTaskResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetEdgeTaskResult'] = ResolversParentTypes['ResetEdgeTaskResult']> = {
  reset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ResetEdgeTasksResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResetEdgeTasksResult'] = ResolversParentTypes['ResetEdgeTasksResult']> = {
  reset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type RetractResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetractResult'] = ResolversParentTypes['RetractResult']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type RetryAllFailedExtractionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetryAllFailedExtractionsResult'] = ResolversParentTypes['RetryAllFailedExtractionsResult']> = {
  enqueueFailures?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enqueued?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  perTypeCounts?: Resolver<Array<ResolversTypes['RetryPerTypeCount']>, ParentType, ContextType>;
  scanned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type RetryFailedExtractionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetryFailedExtractionsResult'] = ResolversParentTypes['RetryFailedExtractionsResult']> = {
  enqueued?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type RetryPerTypeCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetryPerTypeCount'] = ResolversParentTypes['RetryPerTypeCount']> = {
  enqueueFailures?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enqueued?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scanned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['EdgeQueueTaskType'], ParentType, ContextType>;
};

export type ReviewQueueCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewQueueCard'] = ResolversParentTypes['ReviewQueueCard']> = {
  actionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  actionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiConfidence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiExplanation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiReport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aiScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  channel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evidence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factors?: Resolver<Array<ResolversTypes['ReviewQueueFactor']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageKind?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoredAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skipUntil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verdictSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  votedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  watchedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  worthNoting?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ReviewQueueFactorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewQueueFactor'] = ResolversParentTypes['ReviewQueueFactor']> = {
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valueLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ReviewQueueResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewQueueResult'] = ResolversParentTypes['ReviewQueueResult']> = {
  cards?: Resolver<Array<ResolversTypes['ReviewQueueCard']>, ParentType, ContextType>;
  nextCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ReviewSelectorClassificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewSelectorClassification'] = ResolversParentTypes['ReviewSelectorClassification']> = {
  bucket?: Resolver<ResolversTypes['ReviewSelectorBucket'], ParentType, ContextType>;
  channelName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ReviewSelectorPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewSelectorPreview'] = ResolversParentTypes['ReviewSelectorPreview']> = {
  bottomCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  classifications?: Resolver<Array<ResolversTypes['ReviewSelectorClassification']>, ParentType, ContextType>;
  durationMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  estimatedCostUSD?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  midCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  poolSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sampleSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tokenUsage?: Resolver<ResolversTypes['TokenUsageInfo'], ParentType, ContextType>;
  topCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ScoreBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreBase'] = ResolversParentTypes['ScoreBase']> = {
  __resolveType: TypeResolveFn<'AgentScore' | 'FeedbackLog', ParentType, ContextType>;
};

export type ScoreDistributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreDistribution'] = ResolversParentTypes['ScoreDistribution']> = {
  high?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  low?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  medium?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  veryHigh?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  veryLow?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ScoreVideoResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoreVideoResult'] = ResolversParentTypes['ScoreVideoResult']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ScoredVideosResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoredVideosResult'] = ResolversParentTypes['ScoredVideosResult']> = {
  scores?: Resolver<Array<ResolversTypes['AgentAggregateScore']>, ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
};

export type ScoringAnalyzeVideoMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoringAnalyzeVideoMessage'] = ResolversParentTypes['ScoringAnalyzeVideoMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoringEvalAgentCellMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoringEvalAgentCellMessage'] = ResolversParentTypes['ScoringEvalAgentCellMessage']> = {
  agentSpec?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  agentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modelName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promptVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoringEvalAgentFanoutMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoringEvalAgentFanoutMessage'] = ResolversParentTypes['ScoringEvalAgentFanoutMessage']> = {
  agentSpec?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  agentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modelNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  promptVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoringEvalPipelineMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoringEvalPipelineMessage'] = ResolversParentTypes['ScoringEvalPipelineMessage']> = {
  childAge?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detectorModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evalRunId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  finalizeModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specialistModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triageModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoringEvolvePromptMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoringEvolvePromptMessage'] = ResolversParentTypes['ScoringEvolvePromptMessage']> = {
  agentSpec?: Resolver<ResolversTypes['AgentSpecialization'], ParentType, ContextType>;
  agentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  autoEvalAfter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  autoEvalModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  basePromptVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coachModel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sampleLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScoringRescoreLibraryMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScoringRescoreLibraryMessage'] = ResolversParentTypes['ScoringRescoreLibraryMessage']> = {
  agentSelectionJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bottomBias?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxVideosPerChannel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minExplorationPerChannel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resetFirst?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sampleSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectorPoolSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skipExisting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  topBias?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  unscoredOnly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  useReviewSelector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoIdsJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeedTestCasesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeedTestCasesResult'] = ResolversParentTypes['SeedTestCasesResult']> = {
  created?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  testCaseIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type ServiceHealthResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceHealth'] = ResolversParentTypes['ServiceHealth']> = {
  bootedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branch?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  builtAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commitDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dirty?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sha?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortSha?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SessionCookieResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionCookie'] = ResolversParentTypes['SessionCookie']> = {
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SessionLinkResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionLinkResult'] = ResolversParentTypes['SessionLinkResult']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['FirebaseUser']>, ParentType, ContextType>;
};

export type SpecializedScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpecializedScore'] = ResolversParentTypes['SpecializedScore']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
};

export type SuggestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Suggestion'] = ResolversParentTypes['Suggestion']> = {
  actionHelpers?: Resolver<ResolversTypes['ActionHelpers'], ParentType, ContextType>;
  bullets?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  evaluatedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evidence?: Resolver<ResolversTypes['Evidence'], ParentType, ContextType>;
  eyebrow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  snoozedUntil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['SuggestionState'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['SuggestionTarget'], ParentType, ContextType>;
  verb?: Resolver<ResolversTypes['SuggestionVerb'], ParentType, ContextType>;
  videoCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type SuggestionTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestionTarget'] = ResolversParentTypes['SuggestionTarget']> = {
  __resolveType: TypeResolveFn<'Author' | 'Video', ParentType, ContextType>;
};

export type TaskDebugInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDebugInfo'] = ResolversParentTypes['TaskDebugInfo']> = {
  parseErrors?: Resolver<Maybe<Array<ResolversTypes['TaskParseError']>>, ParentType, ContextType>;
  rawDataJson?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  task?: Resolver<ResolversTypes['EdgeQueueTask'], ParentType, ContextType>;
};

export type TaskFirestoreCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskFirestoreCount'] = ResolversParentTypes['TaskFirestoreCount']> = {
  byCollection?: Resolver<Array<ResolversTypes['CollectionFirestoreCount']>, ParentType, ContextType>;
  deletes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalDurationMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  writes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TaskFirestoreCountersResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskFirestoreCounters'] = ResolversParentTypes['TaskFirestoreCounters']> = {
  deletes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDurationMs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  writes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TaskParseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskParseError'] = ResolversParentTypes['TaskParseError']> = {
  context?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TaskResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskResult'] = ResolversParentTypes['TaskResult']> = {
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parseErrors?: Resolver<Maybe<Array<ResolversTypes['TaskParseError']>>, ParentType, ContextType>;
  sha?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TaskResultStatus'], ParentType, ContextType>;
  storagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  undoToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ThumbnailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Thumbnail'] = ResolversParentTypes['Thumbnail']> = {
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TokenUsageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenUsageInfo'] = ResolversParentTypes['TokenUsageInfo']> = {
  input?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  output?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TotalFeedStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalFeedStats'] = ResolversParentTypes['TotalFeedStats']> = {
  overallAverageScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreDistribution?: Resolver<ResolversTypes['ScoreDistribution'], ParentType, ContextType>;
  scoreOverTime?: Resolver<Array<ResolversTypes['DailyScore']>, ParentType, ContextType>;
  totalVideosProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalVideosScoredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TotalHistoryStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalHistoryStats'] = ResolversParentTypes['TotalHistoryStats']> = {
  averageDurationPerVideo?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  overallAverageScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  scoreDistribution?: Resolver<ResolversTypes['ScoreDistribution'], ParentType, ContextType>;
  scoreOverTime?: Resolver<Array<ResolversTypes['DailyScore']>, ParentType, ContextType>;
  totalDurationWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalVideosProcessed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalVideosScoredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TotalObjectionableStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalObjectionableStats'] = ResolversParentTypes['TotalObjectionableStats']> = {
  objectionableRecommendedPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  objectionableWatchPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalObjectionableVideosRecommended?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalObjectionableVideosWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type TotalSessionStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalSessionStats'] = ResolversParentTypes['TotalSessionStats']> = {
  feedStats?: Resolver<ResolversTypes['TotalFeedStats'], ParentType, ContextType>;
  historyStats?: Resolver<ResolversTypes['TotalHistoryStats'], ParentType, ContextType>;
  objectionableStats?: Resolver<ResolversTypes['TotalObjectionableStats'], ParentType, ContextType>;
};

export type TriageOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriageOutput'] = ResolversParentTypes['TriageOutput']> = {
  categoryTags?: Resolver<Array<ResolversTypes['AgentCategoryTag']>, ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  riskFlags?: Resolver<Array<ResolversTypes['AgentRiskFlag']>, ParentType, ContextType>;
  shortCircuitReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortCircuited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  verdict?: Resolver<ResolversTypes['TriageVerdict'], ParentType, ContextType>;
};

export type TriageVideosMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriageVideosMessage'] = ResolversParentTypes['TriageVideosMessage']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['ScoringSource'], ParentType, ContextType>;
  sourceTaskId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisQueueMessageType'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSession'] = ResolversParentTypes['UserSession']> = {
  accountInfo?: Resolver<ResolversTypes['AccountInfo'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type VideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Video'] = ResolversParentTypes['Video']> = {
  author?: Resolver<ResolversTypes['Author'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_live?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_watched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snapshot_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnails?: Resolver<Array<ResolversTypes['Thumbnail']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transcript?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  view_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  watch_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoCorrectiveActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoCorrectiveAction'] = ResolversParentTypes['VideoCorrectiveAction']> = {
  algorithmVersion?: Resolver<Maybe<ResolversTypes['CorrectiveActionAlgorithmVersion']>, ParentType, ContextType>;
  appliedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  autoApplyEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confidence?: Resolver<Maybe<ResolversTypes['ScoreConfidence']>, ParentType, ContextType>;
  confidenceReason?: Resolver<Maybe<ResolversTypes['ConfidenceReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  evaluatedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['CorrectiveActionEvent']>>, ParentType, ContextType>;
  evidenceFingerprint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feedbackTokens?: Resolver<Maybe<ResolversTypes['FeedbackTokens']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['CorrectiveActionKind'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<Maybe<ResolversTypes['CorrectiveActionSeverity']>, ParentType, ContextType>;
  skipUntil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceVideoIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CorrectiveActionStatus'], ParentType, ContextType>;
  takenAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  takenBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenStatus?: Resolver<ResolversTypes['TokenStatus'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['CorrectiveActionTrigger'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CorrectiveActionType'], ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  videoScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoFactorBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoFactorBreakdown'] = ResolversParentTypes['VideoFactorBreakdown']> = {
  factors?: Resolver<Array<ResolversTypes['ReviewQueueFactor']>, ParentType, ContextType>;
  transcriptBacked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  worthNoting?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type VideoLanguageResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoLanguage'] = ResolversParentTypes['VideoLanguage']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  confidence?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  secondary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type VideoScoringStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoScoringState'] = ResolversParentTypes['VideoScoringState']> = {
  hasAgentScore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasFeedback?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inheritedFromChannel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  videoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type VideoStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoStats'] = ResolversParentTypes['VideoStats']> = {
  correctiveActions?: Resolver<ResolversTypes['CorrectiveActionStats'], ParentType, ContextType>;
  recommendedQuality?: Resolver<ResolversTypes['QualityBreakdown'], ParentType, ContextType>;
  totalFeedScoredVideos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalHistoryScoredVideos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalVideosScored?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalVideosWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  watchedQuality?: Resolver<ResolversTypes['QualityBreakdown'], ParentType, ContextType>;
};

export type VideoTranscriptResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoTranscript'] = ResolversParentTypes['VideoTranscript']> = {
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['VideoLanguage']>, ParentType, ContextType>;
  transcript?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type VideosWithScoresResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideosWithScores'] = ResolversParentTypes['VideosWithScores']> = {
  scores?: Resolver<Array<ResolversTypes['AgentScore']>, ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
};

export type VoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Vote'] = ResolversParentTypes['Vote']> = {
  createdAt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rationale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['VoteSource']>, ParentType, ContextType>;
  suggestionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  target?: Resolver<ResolversTypes['SuggestionTarget'], ParentType, ContextType>;
  verb?: Resolver<ResolversTypes['SuggestionVerb'], ParentType, ContextType>;
};

export type VoteSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoteSummary'] = ResolversParentTypes['VoteSummary']> = {
  agreed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  boostCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  disagreed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  followCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  since?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  skipped?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type WaitlistEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['WaitlistEntry'] = ResolversParentTypes['WaitlistEntry']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userAgent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type WeeklyBucketsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeeklyBuckets'] = ResolversParentTypes['WeeklyBuckets']> = {
  borderline?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  flagged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  greatFit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  watched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  windowDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type WeeklyImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeeklyImpact'] = ResolversParentTypes['WeeklyImpact']> = {
  candidatesQueued?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosRemoved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  videosSurfaced?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type WeeklyScoreResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeeklyScore'] = ResolversParentTypes['WeeklyScore']> = {
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  weekStart?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type WelcomeStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['WelcomeState'] = ResolversParentTypes['WelcomeState']> = {
  completedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desktopInstalled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  googleAccountSetUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kidSignedIn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  principlesAcknowledged?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skippedAt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type WorkerFirestoreStatRowResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkerFirestoreStatRow'] = ResolversParentTypes['WorkerFirestoreStatRow']> = {
  byCollection?: Resolver<Array<ResolversTypes['CollectionFirestoreCount']>, ParentType, ContextType>;
  firstSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hourBucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastSeenAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskCounts?: Resolver<Array<ResolversTypes['TaskFirestoreCount']>, ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['TaskFirestoreCounters'], ParentType, ContextType>;
  worker?: Resolver<ResolversTypes['WorkerInfoLite'], ParentType, ContextType>;
  workerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type WorkerInfoLiteResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkerInfoLite'] = ResolversParentTypes['WorkerInfoLite']> = {
  bootedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branch?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sha?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortSha?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type YtCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['YTCredentials'] = ResolversParentTypes['YTCredentials']> = {
  cookies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Cookie']>>>, ParentType, ContextType>;
  expiry_date?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type YouTubeProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['YouTubeProfile'] = ResolversParentTypes['YouTubeProfile']> = {
  activeWorkers?: Resolver<Array<ResolversTypes['ProfileWorker']>, ParentType, ContextType>;
  channel_handle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credentials?: Resolver<Maybe<ResolversTypes['YTCredentials']>, ParentType, ContextType>;
  desktopLastSeenAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_channel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastTaskAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastTaskType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['ProfilePreferences']>, ParentType, ContextType>;
  thumbnails?: Resolver<Maybe<Array<Maybe<ResolversTypes['Thumbnail']>>>, ParentType, ContextType>;
  youtubeSessionInvalidReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeSessionLastCheckedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeSessionValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  youtubeSignedOut?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  youtubeSignedOutAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  youtubeSignedOutReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type YoutubeFeedSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['YoutubeFeedSnapshot'] = ResolversParentTypes['YoutubeFeedSnapshot']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  task_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
};

export type YoutubeHistorySnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['YoutubeHistorySnapshot'] = ResolversParentTypes['YoutubeHistorySnapshot']> = {
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  task_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['HistoryVideo']>, ParentType, ContextType>;
};

export type YoutubeRelatedSnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['YoutubeRelatedSnapshot'] = ResolversParentTypes['YoutubeRelatedSnapshot']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceVideoId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  task_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videos?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AIAnalysis?: AiAnalysisResolvers<ContextType>;
  AccountInfo?: AccountInfoResolvers<ContextType>;
  ActionHelpers?: ActionHelpersResolvers<ContextType>;
  ActionMetrics?: ActionMetricsResolvers<ContextType>;
  ActivityEvent?: ActivityEventResolvers<ContextType>;
  ActivityRow?: ActivityRowResolvers<ContextType>;
  AdminAccountInfoReplay?: AdminAccountInfoReplayResolvers<ContextType>;
  AdminCcDevice?: AdminCcDeviceResolvers<ContextType>;
  AdminCcOwner?: AdminCcOwnerResolvers<ContextType>;
  AdminCcProfile?: AdminCcProfileResolvers<ContextType>;
  AdminCcProfileDevice?: AdminCcProfileDeviceResolvers<ContextType>;
  AdminCcProfileStatus?: AdminCcProfileStatusResolvers<ContextType>;
  AdminCcSession?: AdminCcSessionResolvers<ContextType>;
  AdminCcTotals?: AdminCcTotalsResolvers<ContextType>;
  AdminCommandCenter?: AdminCommandCenterResolvers<ContextType>;
  AdminDeleteSessionResult?: AdminDeleteSessionResultResolvers<ContextType>;
  AdminEnqueuePipelineEvalResult?: AdminEnqueuePipelineEvalResultResolvers<ContextType>;
  AdminEvalFailedSpecialist?: AdminEvalFailedSpecialistResolvers<ContextType>;
  AdminEvalFinalizeResult?: AdminEvalFinalizeResultResolvers<ContextType>;
  AdminEvalPipelineProgress?: AdminEvalPipelineProgressResolvers<ContextType>;
  AdminEvalPipelineResult?: AdminEvalPipelineResultResolvers<ContextType>;
  AdminEvalSkippedSpecialist?: AdminEvalSkippedSpecialistResolvers<ContextType>;
  AdminEvalSpecialistResult?: AdminEvalSpecialistResultResolvers<ContextType>;
  AdminEvalTriageResult?: AdminEvalTriageResultResolvers<ContextType>;
  AdminInsightCandidate?: AdminInsightCandidateResolvers<ContextType>;
  AdminInsightCandidateList?: AdminInsightCandidateListResolvers<ContextType>;
  AdminInsightTestResult?: AdminInsightTestResultResolvers<ContextType>;
  AdminPurgeProfileResult?: AdminPurgeProfileResultResolvers<ContextType>;
  AdminRecomputeCorrectiveActionsResult?: AdminRecomputeCorrectiveActionsResultResolvers<ContextType>;
  AdminRerunScoringPipelineResult?: AdminRerunScoringPipelineResultResolvers<ContextType>;
  AdminResetAllVideoScoresResult?: AdminResetAllVideoScoresResultResolvers<ContextType>;
  AdminResetAllVideoSummariesResult?: AdminResetAllVideoSummariesResultResolvers<ContextType>;
  AdminResetVideoScoresResult?: AdminResetVideoScoresResultResolvers<ContextType>;
  AdminResetVideoSummaryResult?: AdminResetVideoSummaryResultResolvers<ContextType>;
  AdminScoringTestResult?: AdminScoringTestResultResolvers<ContextType>;
  AdminSeedPromptsResult?: AdminSeedPromptsResultResolvers<ContextType>;
  AdminSeededPrompt?: AdminSeededPromptResolvers<ContextType>;
  AdminSweepProfileSessionsResult?: AdminSweepProfileSessionsResultResolvers<ContextType>;
  AgeBandVerdict?: AgeBandVerdictResolvers<ContextType>;
  Agent?: AgentResolvers<ContextType>;
  AgentAggregateScore?: AgentAggregateScoreResolvers<ContextType>;
  AgentAnalysisChatLog?: AgentAnalysisChatLogResolvers<ContextType>;
  AgentId?: AgentIdResolvers<ContextType>;
  AgentPromptEntry?: AgentPromptEntryResolvers<ContextType>;
  AgentScore?: AgentScoreResolvers<ContextType>;
  AgentTriggers?: AgentTriggersResolvers<ContextType>;
  AggregateChannelMessage?: AggregateChannelMessageResolvers<ContextType>;
  AggregateProfileChannelFeedbackMessage?: AggregateProfileChannelFeedbackMessageResolvers<ContextType>;
  AnalysisQueue?: AnalysisQueueResolvers<ContextType>;
  AnalysisQueueMessage?: AnalysisQueueMessageResolvers<ContextType>;
  ApplyCorrectiveActionResult?: ApplyCorrectiveActionResultResolvers<ContextType>;
  ApplySuggestionResult?: ApplySuggestionResultResolvers<ContextType>;
  Author?: AuthorResolvers<ContextType>;
  AuthorAggregateScore?: AuthorAggregateScoreResolvers<ContextType>;
  AuthorVideoScore?: AuthorVideoScoreResolvers<ContextType>;
  BindFeedbackTokensMessage?: BindFeedbackTokensMessageResolvers<ContextType>;
  BlobMigrationResult?: BlobMigrationResultResolvers<ContextType>;
  BullmqJobEntry?: BullmqJobEntryResolvers<ContextType>;
  BullmqQueueConcurrency?: BullmqQueueConcurrencyResolvers<ContextType>;
  BullmqWorker?: BullmqWorkerResolvers<ContextType>;
  BullmqWorkersSnapshot?: BullmqWorkersSnapshotResolvers<ContextType>;
  ChannelCorrectiveAction?: ChannelCorrectiveActionResolvers<ContextType>;
  ChannelEvolution?: ChannelEvolutionResolvers<ContextType>;
  ChannelFeedbackQuality?: ChannelFeedbackQualityResolvers<ContextType>;
  ChannelFeedbackRow?: ChannelFeedbackRowResolvers<ContextType>;
  ChatCompletionAssistantMessageParam?: ChatCompletionAssistantMessageParamResolvers<ContextType>;
  ChatCompletionChoice?: ChatCompletionChoiceResolvers<ContextType>;
  ChatCompletionCreateParamsBase?: ChatCompletionCreateParamsBaseResolvers<ContextType>;
  ChatCompletionDeveloperMessageParam?: ChatCompletionDeveloperMessageParamResolvers<ContextType>;
  ChatCompletionFunctionMessageParam?: ChatCompletionFunctionMessageParamResolvers<ContextType>;
  ChatCompletionMessage?: ChatCompletionMessageResolvers<ContextType>;
  ChatCompletionMessageParam?: ChatCompletionMessageParamResolvers<ContextType>;
  ChatCompletionResponse?: ChatCompletionResponseResolvers<ContextType>;
  ChatCompletionSystemMessageParam?: ChatCompletionSystemMessageParamResolvers<ContextType>;
  ChatCompletionToolMessageParam?: ChatCompletionToolMessageParamResolvers<ContextType>;
  ChatCompletionUsage?: ChatCompletionUsageResolvers<ContextType>;
  ChatCompletionUserMessageParam?: ChatCompletionUserMessageParamResolvers<ContextType>;
  CollectionFirestoreCount?: CollectionFirestoreCountResolvers<ContextType>;
  ControlHeartbeatSessionsMessage?: ControlHeartbeatSessionsMessageResolvers<ContextType>;
  ControlSendInsightNotificationsMessage?: ControlSendInsightNotificationsMessageResolvers<ContextType>;
  ControlSweepChannelMarksMessage?: ControlSweepChannelMarksMessageResolvers<ContextType>;
  ControlSweepChannelRescoresMessage?: ControlSweepChannelRescoresMessageResolvers<ContextType>;
  ControlSweepEvaluateChannelMarksMessage?: ControlSweepEvaluateChannelMarksMessageResolvers<ContextType>;
  ControlSweepEvaluateVideoMarksMessage?: ControlSweepEvaluateVideoMarksMessageResolvers<ContextType>;
  ControlSweepProfileChannelOverlayMarksMessage?: ControlSweepProfileChannelOverlayMarksMessageResolvers<ContextType>;
  ControlSweepProfileMarksMessage?: ControlSweepProfileMarksMessageResolvers<ContextType>;
  ControlSweepReevaluateAllMessage?: ControlSweepReevaluateAllMessageResolvers<ContextType>;
  ControlSweepRetryStuckActionsMessage?: ControlSweepRetryStuckActionsMessageResolvers<ContextType>;
  ControlSweepReviewInboxMessage?: ControlSweepReviewInboxMessageResolvers<ContextType>;
  ControlSweepStaleAlgorithmVersionMessage?: ControlSweepStaleAlgorithmVersionMessageResolvers<ContextType>;
  ControlSweepSubscriptionsMessage?: ControlSweepSubscriptionsMessageResolvers<ContextType>;
  Cookie?: CookieResolvers<ContextType>;
  CorrectiveAction?: CorrectiveActionResolvers<ContextType>;
  CorrectiveActionEvent?: CorrectiveActionEventResolvers<ContextType>;
  CorrectiveActionStats?: CorrectiveActionStatsResolvers<ContextType>;
  CorrectiveActionUnion?: CorrectiveActionUnionResolvers<ContextType>;
  CostByAgent?: CostByAgentResolvers<ContextType>;
  CostByModel?: CostByModelResolvers<ContextType>;
  CostDailyBucket?: CostDailyBucketResolvers<ContextType>;
  CostEstimateInfo?: CostEstimateInfoResolvers<ContextType>;
  CreateFeedTaskResult?: CreateFeedTaskResultResolvers<ContextType>;
  CreateInviteResult?: CreateInviteResultResolvers<ContextType>;
  Criterion?: CriterionResolvers<ContextType>;
  DailyFeedStats?: DailyFeedStatsResolvers<ContextType>;
  DailyHistoryStats?: DailyHistoryStatsResolvers<ContextType>;
  DailyObjectionableStats?: DailyObjectionableStatsResolvers<ContextType>;
  DailyScore?: DailyScoreResolvers<ContextType>;
  DateRange?: DateRangeResolvers<ContextType>;
  DeleteEdgeTaskResult?: DeleteEdgeTaskResultResolvers<ContextType>;
  DeleteEdgeTasksResult?: DeleteEdgeTasksResultResolvers<ContextType>;
  DesktopHeartbeatResult?: DesktopHeartbeatResultResolvers<ContextType>;
  Device?: DeviceResolvers<ContextType>;
  DeviceGrant?: DeviceGrantResolvers<ContextType>;
  DevicePairing?: DevicePairingResolvers<ContextType>;
  DevicePairingClaimResult?: DevicePairingClaimResultResolvers<ContextType>;
  DevicePairingStatus?: DevicePairingStatusResolvers<ContextType>;
  EdgeProfileStats?: EdgeProfileStatsResolvers<ContextType>;
  EdgeQueueTask?: EdgeQueueTaskResolvers<ContextType>;
  EdgeRecentWatch?: EdgeRecentWatchResolvers<ContextType>;
  EnqueueJobResult?: EnqueueJobResultResolvers<ContextType>;
  EvalAgentEntry?: EvalAgentEntryResolvers<ContextType>;
  EvalFieldAccuracy?: EvalFieldAccuracyResolvers<ContextType>;
  EvalFieldCategoricalAccuracy?: EvalFieldCategoricalAccuracyResolvers<ContextType>;
  EvalFieldScoreAccuracy?: EvalFieldScoreAccuracyResolvers<ContextType>;
  EvalReport?: EvalReportResolvers<ContextType>;
  EvalTestCase?: EvalTestCaseResolvers<ContextType>;
  EvaluateChannelActionsMessage?: EvaluateChannelActionsMessageResolvers<ContextType>;
  EvaluateProfileActionsMessage?: EvaluateProfileActionsMessageResolvers<ContextType>;
  EvaluateVideoActionsMessage?: EvaluateVideoActionsMessageResolvers<ContextType>;
  Evidence?: EvidenceResolvers<ContextType>;
  EvidenceFactor?: EvidenceFactorResolvers<ContextType>;
  EvidenceFactorSummary?: EvidenceFactorSummaryResolvers<ContextType>;
  EvidencePreview?: EvidencePreviewResolvers<ContextType>;
  EvidencePreviewBullet?: EvidencePreviewBulletResolvers<ContextType>;
  EvidenceScoring?: EvidenceScoringResolvers<ContextType>;
  EvidenceVideo?: EvidenceVideoResolvers<ContextType>;
  ExecutedAction?: ExecutedActionResolvers<ContextType>;
  FeedCorrectiveAction?: FeedCorrectiveActionResolvers<ContextType>;
  FeedVideo?: FeedVideoResolvers<ContextType>;
  FeedbackLog?: FeedbackLogResolvers<ContextType>;
  FeedbackToken?: FeedbackTokenResolvers<ContextType>;
  FeedbackTokens?: FeedbackTokensResolvers<ContextType>;
  FetchTranscriptMessage?: FetchTranscriptMessageResolvers<ContextType>;
  FirebaseUser?: FirebaseUserResolvers<ContextType>;
  GatedContext?: GatedContextResolvers<ContextType>;
  GenerateCorrectiveActionsResult?: GenerateCorrectiveActionsResultResolvers<ContextType>;
  GuardianGroup?: GuardianGroupResolvers<ContextType>;
  GuardianGroupMember?: GuardianGroupMemberResolvers<ContextType>;
  HarvestedFeedbackToken?: HarvestedFeedbackTokenResolvers<ContextType>;
  HistoryScoresOverTime?: HistoryScoresOverTimeResolvers<ContextType>;
  HistoryVideo?: HistoryVideoResolvers<ContextType>;
  HomeCaughtItem?: HomeCaughtItemResolvers<ContextType>;
  HomeCaughtSummary?: HomeCaughtSummaryResolvers<ContextType>;
  HomeScore?: HomeScoreResolvers<ContextType>;
  HomeTopChannel?: HomeTopChannelResolvers<ContextType>;
  HomeWeeklyImpact?: HomeWeeklyImpactResolvers<ContextType>;
  ImpactAchievement?: ImpactAchievementResolvers<ContextType>;
  ImpactSummaryResult?: ImpactSummaryResultResolvers<ContextType>;
  IngestAckFeedMessage?: IngestAckFeedMessageResolvers<ContextType>;
  IngestAckGenericMessage?: IngestAckGenericMessageResolvers<ContextType>;
  IngestAckHistoryMessage?: IngestAckHistoryMessageResolvers<ContextType>;
  IngestAckRelatedMessage?: IngestAckRelatedMessageResolvers<ContextType>;
  IngestAckTranscriptMessage?: IngestAckTranscriptMessageResolvers<ContextType>;
  IngestReparseMessage?: IngestReparseMessageResolvers<ContextType>;
  InvitePreview?: InvitePreviewResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  KidProfile?: KidProfileResolvers<ContextType>;
  KidProfileReviewItem?: KidProfileReviewItemResolvers<ContextType>;
  LLMCostSummary?: LlmCostSummaryResolvers<ContextType>;
  LLMRequest?: LlmRequestResolvers<ContextType>;
  LLMUsage?: LlmUsageResolvers<ContextType>;
  LanguageFacts?: LanguageFactsResolvers<ContextType>;
  LinkedAccount?: LinkedAccountResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  OpenRouterModelEntry?: OpenRouterModelEntryResolvers<ContextType>;
  PolicyAdjustment?: PolicyAdjustmentResolvers<ContextType>;
  PoliticsFacts?: PoliticsFactsResolvers<ContextType>;
  PrimeEdgeTasksResult?: PrimeEdgeTasksResultResolvers<ContextType>;
  ProcessFeedMessage?: ProcessFeedMessageResolvers<ContextType>;
  ProcessHistoryMessage?: ProcessHistoryMessageResolvers<ContextType>;
  ProfilePreferences?: ProfilePreferencesResolvers<ContextType>;
  ProfileSummary?: ProfileSummaryResolvers<ContextType>;
  ProfileVideoVerdict?: ProfileVideoVerdictResolvers<ContextType>;
  ProfileWorker?: ProfileWorkerResolvers<ContextType>;
  ProgressActions?: ProgressActionsResolvers<ContextType>;
  ProgressTrends?: ProgressTrendsResolvers<ContextType>;
  Prompt?: PromptResolvers<ContextType>;
  QualityBreakdown?: QualityBreakdownResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RedeemInviteResult?: RedeemInviteResultResolvers<ContextType>;
  ReligionFacts?: ReligionFactsResolvers<ContextType>;
  ReprocessTaskResult?: ReprocessTaskResultResolvers<ContextType>;
  ReprocessTasksBatchResult?: ReprocessTasksBatchResultResolvers<ContextType>;
  RescoreCostBreakdownRow?: RescoreCostBreakdownRowResolvers<ContextType>;
  RescoreCostEstimate?: RescoreCostEstimateResolvers<ContextType>;
  RescorePerAgentStat?: RescorePerAgentStatResolvers<ContextType>;
  RescoreVideosResult?: RescoreVideosResultResolvers<ContextType>;
  ResetEdgeTaskResult?: ResetEdgeTaskResultResolvers<ContextType>;
  ResetEdgeTasksResult?: ResetEdgeTasksResultResolvers<ContextType>;
  RetractResult?: RetractResultResolvers<ContextType>;
  RetryAllFailedExtractionsResult?: RetryAllFailedExtractionsResultResolvers<ContextType>;
  RetryFailedExtractionsResult?: RetryFailedExtractionsResultResolvers<ContextType>;
  RetryPerTypeCount?: RetryPerTypeCountResolvers<ContextType>;
  ReviewQueueCard?: ReviewQueueCardResolvers<ContextType>;
  ReviewQueueFactor?: ReviewQueueFactorResolvers<ContextType>;
  ReviewQueueResult?: ReviewQueueResultResolvers<ContextType>;
  ReviewSelectorClassification?: ReviewSelectorClassificationResolvers<ContextType>;
  ReviewSelectorPreview?: ReviewSelectorPreviewResolvers<ContextType>;
  ScoreBase?: ScoreBaseResolvers<ContextType>;
  ScoreDistribution?: ScoreDistributionResolvers<ContextType>;
  ScoreVideoResult?: ScoreVideoResultResolvers<ContextType>;
  ScoredVideosResult?: ScoredVideosResultResolvers<ContextType>;
  ScoringAnalyzeVideoMessage?: ScoringAnalyzeVideoMessageResolvers<ContextType>;
  ScoringEvalAgentCellMessage?: ScoringEvalAgentCellMessageResolvers<ContextType>;
  ScoringEvalAgentFanoutMessage?: ScoringEvalAgentFanoutMessageResolvers<ContextType>;
  ScoringEvalPipelineMessage?: ScoringEvalPipelineMessageResolvers<ContextType>;
  ScoringEvolvePromptMessage?: ScoringEvolvePromptMessageResolvers<ContextType>;
  ScoringRescoreLibraryMessage?: ScoringRescoreLibraryMessageResolvers<ContextType>;
  SeedTestCasesResult?: SeedTestCasesResultResolvers<ContextType>;
  ServiceHealth?: ServiceHealthResolvers<ContextType>;
  SessionCookie?: SessionCookieResolvers<ContextType>;
  SessionLinkResult?: SessionLinkResultResolvers<ContextType>;
  SpecializedScore?: SpecializedScoreResolvers<ContextType>;
  Suggestion?: SuggestionResolvers<ContextType>;
  SuggestionTarget?: SuggestionTargetResolvers<ContextType>;
  TaskDebugInfo?: TaskDebugInfoResolvers<ContextType>;
  TaskFirestoreCount?: TaskFirestoreCountResolvers<ContextType>;
  TaskFirestoreCounters?: TaskFirestoreCountersResolvers<ContextType>;
  TaskParseError?: TaskParseErrorResolvers<ContextType>;
  TaskResult?: TaskResultResolvers<ContextType>;
  Thumbnail?: ThumbnailResolvers<ContextType>;
  TokenUsageInfo?: TokenUsageInfoResolvers<ContextType>;
  TotalFeedStats?: TotalFeedStatsResolvers<ContextType>;
  TotalHistoryStats?: TotalHistoryStatsResolvers<ContextType>;
  TotalObjectionableStats?: TotalObjectionableStatsResolvers<ContextType>;
  TotalSessionStats?: TotalSessionStatsResolvers<ContextType>;
  TriageOutput?: TriageOutputResolvers<ContextType>;
  TriageVideosMessage?: TriageVideosMessageResolvers<ContextType>;
  UserSession?: UserSessionResolvers<ContextType>;
  Video?: VideoResolvers<ContextType>;
  VideoCorrectiveAction?: VideoCorrectiveActionResolvers<ContextType>;
  VideoFactorBreakdown?: VideoFactorBreakdownResolvers<ContextType>;
  VideoLanguage?: VideoLanguageResolvers<ContextType>;
  VideoScoringState?: VideoScoringStateResolvers<ContextType>;
  VideoStats?: VideoStatsResolvers<ContextType>;
  VideoTranscript?: VideoTranscriptResolvers<ContextType>;
  VideosWithScores?: VideosWithScoresResolvers<ContextType>;
  Vote?: VoteResolvers<ContextType>;
  VoteSummary?: VoteSummaryResolvers<ContextType>;
  WaitlistEntry?: WaitlistEntryResolvers<ContextType>;
  WeeklyBuckets?: WeeklyBucketsResolvers<ContextType>;
  WeeklyImpact?: WeeklyImpactResolvers<ContextType>;
  WeeklyScore?: WeeklyScoreResolvers<ContextType>;
  WelcomeState?: WelcomeStateResolvers<ContextType>;
  WorkerFirestoreStatRow?: WorkerFirestoreStatRowResolvers<ContextType>;
  WorkerInfoLite?: WorkerInfoLiteResolvers<ContextType>;
  YTCredentials?: YtCredentialsResolvers<ContextType>;
  YouTubeProfile?: YouTubeProfileResolvers<ContextType>;
  YoutubeFeedSnapshot?: YoutubeFeedSnapshotResolvers<ContextType>;
  YoutubeHistorySnapshot?: YoutubeHistorySnapshotResolvers<ContextType>;
  YoutubeRelatedSnapshot?: YoutubeRelatedSnapshotResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  admin?: AdminDirectiveResolver<any, any, ContextType>;
};
